var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreserve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1653",
    "data-name": "Group 1653",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 405.096,
    height: 318.401,
    viewBox: "0 0 405.096 318.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2314",
    "data-name": "Rectangle 2314",
    width: 405.096,
    height: 318.401,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2060",
    "data-name": "Rectangle 2060",
    width: 405.095,
    height: 318.402,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M1097.928,485.355l22.307,11.789c4.975-3.09,13.951-11.531,18.939-13.378-.094-12.206-2.1-31.707-5.893-39.221-25.625,16.846-35.353,40.81-35.353,40.81",
    transform: "translate(-1097.928 -444.545)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2061",
    "data-name": "Rectangle 2061",
    width: 47.477,
    height: 46.456,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2062",
    "data-name": "Rectangle 2062",
    width: 64.618,
    height: 50.365,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2063",
    "data-name": "Rectangle 2063",
    width: 46.385,
    height: 47.532,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2064",
    "data-name": "Rectangle 2064",
    width: 59.815,
    height: 46.822,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2065",
    "data-name": "Rectangle 2065",
    width: 56.156,
    height: 51.334,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2066",
    "data-name": "Rectangle 2066",
    width: 60.509,
    height: 82.79,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2067",
    "data-name": "Rectangle 2067",
    width: 73.197,
    height: 89.151,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2068",
    "data-name": "Rectangle 2068",
    width: 82.793,
    height: 80.625,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2069",
    "data-name": "Rectangle 2069",
    width: 65.483,
    height: 83.72,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2070",
    "data-name": "Rectangle 2070",
    width: 80.744,
    height: 68.978,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2071",
    "data-name": "Rectangle 2071",
    width: 76.866,
    height: 89.584,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2072",
    "data-name": "Rectangle 2072",
    width: 51.56,
    height: 42.77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2073",
    "data-name": "Rectangle 2073",
    width: 51.561,
    height: 42.77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2074",
    "data-name": "Rectangle 2074",
    width: 61.868,
    height: 50.423,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2075",
    "data-name": "Rectangle 2075",
    width: 47.269,
    height: 46.422,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2076",
    "data-name": "Rectangle 2076",
    width: 50.17,
    height: 44.406,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M1736.856,608.7a172.63,172.63,0,0,0,14.47,13.453c11.953,14.715,28.971,28.007,28.971,28.007s-.656.723,1.17-.509c-3.946-12.7-4.194-23.054-15.676-36.32-1.457-6.778-5.006-12.086-7.531-17.024a27.294,27.294,0,0,0-8.658-9.336Z",
    transform: "translate(-1736.856 -586.967)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3.956,
    y1: 2.891,
    x2: -3.953,
    y2: 2.891,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a4a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#995e21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#ba7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba7329"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M1624.232,485.841a92.81,92.81,0,0,1,17,5.059l24.028-9.594s-13.169-22.26-41.006-35.126c-2.64,7.993-1.736,27.576-.021,39.661",
    transform: "translate(-1622.593 -446.179)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2080",
    "data-name": "Rectangle 2080",
    width: 41.019,
    height: 51.979,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2081",
    "data-name": "Rectangle 2081",
    width: 57.37,
    height: 58.474,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2082",
    "data-name": "Rectangle 2082",
    width: 39.752,
    height: 52.858,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2083",
    "data-name": "Rectangle 2083",
    width: 53.615,
    height: 53.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2084",
    "data-name": "Rectangle 2084",
    width: 49.214,
    height: 57.749,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2085",
    "data-name": "Rectangle 2085",
    width: 71.277,
    height: 74.148,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2086",
    "data-name": "Rectangle 2086",
    width: 84.767,
    height: 78.559,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2087",
    "data-name": "Rectangle 2087",
    width: 92.853,
    height: 68.598,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2088",
    "data-name": "Rectangle 2088",
    width: 76.913,
    height: 73.281,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2089",
    "data-name": "Rectangle 2089",
    width: 89.801,
    height: 56.431,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2090",
    "data-name": "Rectangle 2090",
    width: 89.03,
    height: 77.39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2091",
    "data-name": "Rectangle 2091",
    width: 45.118,
    height: 49.467,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2093",
    "data-name": "Rectangle 2093",
    width: 54.178,
    height: 58.562,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2094",
    "data-name": "Rectangle 2094",
    width: 40.132,
    height: 52.622,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2095",
    "data-name": "Rectangle 2095",
    width: 43.483,
    height: 50.862,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M1341.575,983.514s-.116,9.1-.256,17.575c-.031-.312-.062-.624-.093-.935-.265,15.085-.151,41.092,2.667,66.491,4.108,36.759,5.563,42.386,5.563,42.386l5.332,1.6c-.094-2.528-.117-7.938.079-15.065.041-.115.083-.23.123-.346.262-8.986.87-20.564,2.118-32.512-.025-.169,1.894-18.6,3.561-28.077-1.524,1.008-4.543,22.892-6.581,22.528-4.533-7.368-4.739-22.908-4.3-28.532.691-8.78,2.767-17.86,8.5-24.547,7.675-8.956,20.493-12.072,28.4-20.821.156-.173.31-.352.462-.534v-.059Z",
    transform: "translate(-1341.13 -982.666)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3.766,
    y1: 1.154,
    x2: -3.763,
    y2: 1.154,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#824d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#644254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#644254"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M1405.874,317.865s1.409,5.166,10.333,5.871,11.977-5.4,11.977-5.4l.235-38.983-25.832-1.409Z",
    transform: "translate(-1402.586 -277.943)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -9.283,
    y1: 5.826,
    x2: -9.277,
    y2: 5.826,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a4a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#995e21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#ba7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba7329"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M1353.7,167.34c-.31.967.41,2.492.831,4.33.578,2.52.533,3.431.868,4.3.716,1.867,3.33.8,3.807-1.161a20.143,20.143,0,0,0-.729-4.956,11.345,11.345,0,0,0-1.525-2.535,2.889,2.889,0,0,0-1.97-1.082,1.335,1.335,0,0,0-1.281,1.1",
    transform: "translate(-1353.623 -166.239)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -33.831,
    y1: 24.042,
    x2: -33.806,
    y2: 24.042,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a26424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#a26424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb7329"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M1560.594,162.541a11.346,11.346,0,0,0-1.525,2.535,20.136,20.136,0,0,0-.729,4.956c.477,1.961,3.091,3.028,3.807,1.161.334-.873.289-1.783.867-4.3.422-1.838,1.141-3.363.831-4.33a1.334,1.334,0,0,0-1.281-1.1,2.889,2.889,0,0,0-1.969,1.082",
    transform: "translate(-1558.339 -161.459)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -21.814,
    y1: 42.291,
    x2: -21.8,
    y2: 42.291,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M1385.436.035A18.433,18.433,0,0,0,1372.2,6.317a19.152,19.152,0,0,0-4.585,13.278l.324,8.885,1.035,14.114s7.885,14.76,12.527,19.075c5.249,1.8,10.378.617,12.03-.539.667-.822,2.242-3.57,6.161-10.889s4.391-9.728,4.068-13.1-.544-8.75-.544-8.75l-.377-10.308a19.184,19.184,0,0,0-1.776-7.442C1398.96,6.147,1394.606,0,1386.52,0c-.354,0-.716.012-1.085.036",
    transform: "translate(-1367.601 0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -3.456,
    y1: 8.242,
    x2: -3.454,
    y2: 8.242,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b5f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#9d6022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a66625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M1506.3,158.18c-.509.087-.81.174-.823.17l-.743,3.091s.317,2.388,3.953,2.423,6.413-3.349,6.413-3.349a10.02,10.02,0,0,0-6.793-2.505,11.985,11.985,0,0,0-2.008.17",
    transform: "translate(-1504.736 -158.01)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M1388.859,160.314s2.777,3.384,6.413,3.349,3.952-2.423,3.952-2.423l-.743-3.091a8.865,8.865,0,0,0-2.9-.447,10.006,10.006,0,0,0-6.724,2.613",
    transform: "translate(-1388.859 -157.701)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M1252.261,394.717l-3.053,2.652s15.019,73.8,16.48,86.4c11.974,5.747,27.8,4.9,36.995,2.943,6.079-1.295,8.195-3.341,8.195-3.341s9.791-68.336,12.139-87.279c-8.541-8.541-21.739-14.974-21.739-14.974l-4.554,15.946-7.479,6.42-7.394-5.794s-1.879-4.54-5.01-18.317c-10.8,3.6-24.58,15.343-24.58,15.343",
    transform: "translate(-1249.208 -379.374)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2107",
    "data-name": "Rectangle 2107",
    width: 66.628,
    height: 7.123,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2108",
    "data-name": "Rectangle 2108",
    width: 79.062,
    height: 7.665,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2109",
    "data-name": "Rectangle 2109",
    width: 62.337,
    height: 7.023,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2110",
    "data-name": "Rectangle 2110",
    width: 70.901,
    height: 8.756,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2111",
    "data-name": "Rectangle 2111",
    width: 70.995,
    height: 11.625,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2112",
    "data-name": "Rectangle 2112",
    width: 11.026,
    height: 104.029,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2113",
    "data-name": "Rectangle 2113",
    width: 8.968,
    height: 112.971,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2114",
    "data-name": "Rectangle 2114",
    width: 20.357,
    height: 111.921,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2115",
    "data-name": "Rectangle 2115",
    width: 5.305,
    height: 110.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2116",
    "data-name": "Rectangle 2116",
    width: 22.186,
    height: 103.663,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2117",
    "data-name": "Rectangle 2117",
    width: 7.817,
    height: 117.38,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2118",
    "data-name": "Rectangle 2118",
    width: 68.35,
    height: 4.681,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2119",
    "data-name": "Rectangle 2119",
    width: 72.513,
    height: 5.415,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2120",
    "data-name": "Rectangle 2120",
    width: 77.875,
    height: 4.986,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2121",
    "data-name": "Rectangle 2121",
    width: 64.975,
    height: 6.232,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2122",
    "data-name": "Rectangle 2122",
    width: 65.036,
    height: 4.554,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M1500.754,1268.311c7.646.1,8.162-.4,8.434-1.674-.725-9.076-3.042-43.094-4.4-65.684a19.27,19.27,0,0,1-3.31,9.28,2.067,2.067,0,0,1-1.1.836c-1.318.38-2.117-.909-2.6-2.027-2.447-5.642-12.757-32.069-15.845-33.078,3.51,24.786,16.751,75.511,18.823,92.346",
    transform: "translate(-1481.931 -1175.965)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -6.79,
    y1: 1.25,
    x2: -6.785,
    y2: 1.25,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#824d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#543847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#543847"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M804.752,920.389c-.132.732-4.393,18.048-.806,45.232a28.836,28.836,0,0,0,.6,8.463s6.374,5.494,6.754,4.274c.22-.7-1.881-2.821-3.249-4.445a5.359,5.359,0,0,1-.128-3.591s2.152,4.588,2.665,3.648c.458-.84-.449-3.091-1.013-6.082a6.35,6.35,0,0,0-.91-2.278c-.446-.688-.756-1.1-.756-1.1s1.361-20.638,5.62-38.1l2.315-8.652Z",
    transform: "translate(-802.513 -917.76)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2.56,
    y1: 2.666,
    x2: -2.556,
    y2: 2.666,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M1179.827,926.412c4.258,17.459,5.62,38.1,5.62,38.1s-.31.413-.756,1.1a6.345,6.345,0,0,0-.91,2.278c-.564,2.991-1.471,5.242-1.013,6.082.513.94,2.665-3.648,2.665-3.648a5.358,5.358,0,0,1-.128,3.591c-1.368,1.624-3.468,3.74-3.249,4.445.38,1.219,6.754-4.274,6.754-4.274a28.843,28.843,0,0,0,.6-8.463c3.587-27.184-.674-44.5-.806-45.232l-11.09-2.629Z",
    transform: "translate(-1177.512 -917.76)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2.969,
    y1: 3.297,
    x2: -2.966,
    y2: 3.297,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M1040.651,1426.16c-.361,9.561,1.624,39.687,2.706,50.149,2.345,1.263,5.953,0,5.953,0s-1.263-.722-2.886-1.443c5.231-15.694,10.824-48.345,10.824-48.345a61.135,61.135,0,0,0-9.59-.609c-2.046,0-4.392.068-7.007.248",
    transform: "translate(-1040.608 -1425.912)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -9.075,
    y1: 1.43,
    x2: -9.066,
    y2: 1.43,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a5f3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#8a5f3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#ab754c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab754c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M928.989,1471.7c-1.623.722-2.886,1.443-2.886,1.443s3.608,1.262,5.953,0c.153-1.483.325-3.361.505-5.519,1-10.9.883-28.785,4.132-45.353-17.933.355-18.215-.164-18.22-.18.006.033,7.768,39.42,10.516,49.608",
    transform: "translate(-918.473 -1422.09)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -7.516,
    y1: 1.424,
    x2: -7.508,
    y2: 1.424,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M1012.769,583.268l-1.45,10.65s.062,2.617,4.521,2.617c4.209-.1,3.959-2.555,3.959-2.555l-1.143-10.712Z",
    transform: "translate(-1011.319 -583.268)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -12.436,
    y1: 23.034,
    x2: -12.423,
    y2: 23.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a4a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#7c4b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#86511d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#965c21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#ad6a26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#ba7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba7329"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M936.231,309.385c-9.706.557-13.883,7.836-14.838,20.486-1.432,16.946-.04,22.794,2.586,25.578,3.138,3.328,12.013,4.137,12.013,4.137a17.012,17.012,0,0,0,5.092,3.1,11.724,11.724,0,0,0,4.774-3.1s5.887-1.989,8.354-2.944c11.457-4.455,2.228-27.129,2.228-27.129-2.721-17.326-9.049-20.22-17.362-20.22-.925,0-1.874.036-2.846.091",
    transform: "translate(-920.819 -309.294)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -2.745,
    y1: 5.482,
    x2: -2.742,
    y2: 5.482,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b5f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#9d6022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a66625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M1064.535,435.686s6.206-.477,8.652.9c-1.193-1.611-3.329-2.745-6.921-2.745-2.8,0-1.731,1.85-1.731,1.85",
    transform: "translate(-1064.333 -433.836)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -17.983,
    y1: 40.524,
    x2: -17.966,
    y2: 40.524,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e3324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#5e3324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#532d1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532d1c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M945.877,441.253c2.793-2.446,8.939-1.85,8.939-1.85s1.842-1.425-1.779-1.889a7.066,7.066,0,0,0-.9-.057c-3.044,0-5.673,1.948-6.261,3.8",
    transform: "translate(-945.877 -437.456)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -14.127,
    y1: 33.027,
    x2: -14.112,
    y2: 33.027,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M304.561,537.759c1.223,8.5-33.015-30.839-38.573-46.458a99.951,99.951,0,0,0-20.634,15.588c23.832,42.778-1.057,48.2-1.057,48.2s-3.147,19.67,3.692,64.124a314.481,314.481,0,0,0,43.391,4.065c8.478.181,33.012-1.984,35.357-3.427,4.51-13.169,7.4-33.914,10.643-49.789s1.263-21.828,1.263-21.828a260.822,260.822,0,0,1-.076-38.346,74.891,74.891,0,0,0-25.837-21.426c-.68,12.79,1.292,36.782-8.168,49.3",
    transform: "translate(-243.574 -488.459)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -0.234,
    y1: 1.615,
    x2: -0.232,
    y2: 1.615,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#455c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#3d5475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d5475"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M627.091,375.729s1.738-1.119,2.431.642.825,7.49-1.524,8.385c3.455-1.039,3.534-6.009,2.679-9.216-.274-1.029-.741-1.378-1.249-1.378-1.076,0-2.336,1.568-2.336,1.568",
    transform: "translate(-627.091 -374.161)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -9.684,
    y1: 52.231,
    x2: -9.668,
    y2: 52.231,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#945c21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#945c21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb7329"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M384.029,407.519c.663,3.766,3.155,8.919,7.269,8.329-2.889.2-5.529-5.844-5.659-8.02s2.228-1.849,2.228-1.849a6.644,6.644,0,0,0-2.426-.653c-.935,0-1.716.467-1.412,2.193",
    transform: "translate(-383.963 -405.326)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -5.371,
    y1: 18.76,
    x2: -5.357,
    y2: 18.76,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M613.944,284.114c1.416-.159,4.081,1.124,4.081,1.124s1.213-.818,1.875-5.712c-3.956-9.843-9.493-13.152-9.493-13.152s1.024,11.423,3.537,17.74",
    transform: "translate(-610.407 -266.374)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -6.655,
    y1: 13.073,
    x2: -6.644,
    y2: 13.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbcfb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#ddd1b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#e7dabb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#f7e9c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fceecc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M415.98,214.37c-12.214,1.9-17.071,9.827-17.636,18.15s1.932,17.49,1.932,17.49c4.5,18.485,17.421,25.214,24.51,23.833,15.128-3.818,15.147-24.8,14.083-28.266s-.483-4.373-.782-10.011c-1.646-14.017-8.314-21.486-18.5-21.486a23.435,23.435,0,0,0-3.607.291",
    transform: "translate(-398.261 -214.079)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1.132,
    y1: 4.152,
    x2: -1.129,
    y2: 4.152,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b5f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#9f6122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#b36e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#a66625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a66625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M440.173,422.936c-.505,1.535-3.338,5.873-8.345,9.405-3.772-.051-9.21-3.909-12.535-6.581-8.087-2.42-10.748-17.86-10.748-17.86l-2.349-1.635a13.818,13.818,0,0,1,.389,5.76c3.109,14.412,8.166,29.587,27.235,33.117,17.421-9.528,13.633-33.357,11.74-39.037.358,5.175-2.817,14.767-5.389,16.83",
    transform: "translate(-406.197 -406.106)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -1.324,
    y1: 5.554,
    x2: -1.32,
    y2: 5.554,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbcfb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#fceecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fceecc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M370.011,289.357s-3.61,10.914-1,14.378c1.776-1.336,4.343-1.822,7.919.837-3.963-14.7-1.895-23.1-1.895-23.1Z",
    transform: "translate(-368.065 -281.467)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -3.271,
    y1: 10.728,
    x2: -3.261,
    y2: 10.728,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M478.851,438.761s-4.852,7.666-3.29,13.081a23.593,23.593,0,0,0,4.563,3.423,25.362,25.362,0,0,1-.782-11.75s9.686,3.587,14.35-2.075c2.109,2.956,1.955,9.147,2.158,11.4,2.206-2.63,3.515-4.329,3.515-4.329s-2.468-7.727-6.18-11.384c-2.9,2.385-9.65,2.822-14.333,1.636",
    transform: "translate(-475.251 -437.125)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -2.832,
    y1: 11.277,
    x2: -2.826,
    y2: 11.277,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbcfb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#e9dcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#f7e9c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#fceecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fceecc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M563.2,379.1s4.148-2.526,8.139,1.552c0-2.462-2.037-3.31-3.552-3.708a3.406,3.406,0,0,0-.855-.1c-1.536,0-3.529.805-3.732,2.255",
    transform: "translate(-563.198 -376.841)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -10.535,
    y1: 36.255,
    x2: -10.516,
    y2: 36.255,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M460.5,387.86c-2.528.594-4.546,2.858-4.228,4.588,0,0,3.971-4.845,9.044-2.232a3.745,3.745,0,0,0-3.762-2.472,4.652,4.652,0,0,0-1.053.117",
    transform: "translate(-456.237 -387.743)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -7.6,
    y1: 25.734,
    x2: -7.583,
    y2: 25.734,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M559.169,692.819a16.464,16.464,0,0,0-4.55-1.923c-.855-.229-2.111.45-.915,1.063a17.215,17.215,0,0,0,2.275.962s-3.073.365-3.038,1.1,3.515.85,3.515.85c-3.106,1.5-3.215,2.131-3.032,2.488s3.365-.641,3.365-.641a5.269,5.269,0,0,0-.447,2.12c.087.91,1.836-.741,1.836-.741s10.333,7.556,19.375,5.128c-1.148-4.672-1.685-5.334-1.685-5.334l-3.809-.087a98.091,98.091,0,0,1-9.3-3.148,2.789,2.789,0,0,1-1-2.694c.033-1.133-.052-2.531-.684-2.64a.248.248,0,0,0-.043,0c-.643,0-1.816,2.314-1.861,3.5",
    transform: "translate(-552.94 -689.32)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -4.514,
    y1: 7.386,
    x2: -4.506,
    y2: 7.386,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b5f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#9d6022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a66625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M851.631,705.627c.532-1.521.212-2.588-1.113-2.908s-.731.979-.76,2.126a4.969,4.969,0,0,1-1.859,3.263,103.5,103.5,0,0,1-12.37,4.44l.6,6.082s5.106-1,14.912-7.456c1.6,1.212,2.443,1.5,2.79,1.085s-.713-1.491-.713-1.491,4.007.142,4.1-.579-3.279-1.451-3.279-1.451,3.784-.985,3.526-1.624-3.018-.481-3.018-.481,3.063-3.468,2.415-4.2a.313.313,0,0,0-.247-.091c-1.149,0-4.977,3.285-4.977,3.285",
    transform: "translate(-835.529 -702.342)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -6.571,
    y1: 7.866,
    x2: -6.563,
    y2: 7.866,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M742.016,725.84l-2.085,4.482a4.858,4.858,0,0,0,2.766.722,5.2,5.2,0,0,0,2.826-.722l-.7-4.9Z",
    transform: "translate(-739.931 -725.422)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -21.399,
    y1: 33.09,
    x2: -21.37,
    y2: 33.09,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M691.144,552.077c-3.685,1.6-5.543,6.7-6.3,12.734s-2.975,4.529-2.753,7.726.266,8.7,10.834,10.968,17.548-2.85,19.227-9.9c1.989-8.357-.2-20.142-9.92-21.967a28.352,28.352,0,0,0-5.226-.515,14.6,14.6,0,0,0-5.864.957",
    transform: "translate(-682.077 -551.12)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -3.431,
    y1: 6.247,
    x2: -3.426,
    y2: 6.247,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M777.043,678.036a.813.813,0,0,0-.019.463,1.5,1.5,0,0,0,.349.64,5.211,5.211,0,0,0,3.055,1.351,5.011,5.011,0,0,0,2.9-.093,1.055,1.055,0,0,0,.648-.821,1.083,1.083,0,0,0-.307-.849,5.417,5.417,0,0,0-3.42-1.338c-.226-.019-.461-.029-.7-.029-1.166,0-2.344.235-2.507.676",
    transform: "translate(-777 -677.36)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2165",
    "data-name": "Rectangle 2165",
    width: 7.021,
    height: 3.385,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M695.73,664.757a.658.658,0,0,0-.016.375,1.22,1.22,0,0,0,.283.52,4.229,4.229,0,0,0,2.478,1.1,4.065,4.065,0,0,0,2.35-.075.855.855,0,0,0,.526-.666.878.878,0,0,0-.249-.689,4.395,4.395,0,0,0-2.774-1.085c-.183-.016-.374-.024-.564-.024-.946,0-1.9.19-2.034.548",
    transform: "translate(-695.695 -664.209)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2167",
    "data-name": "Rectangle 2167",
    width: 5.695,
    height: 2.745,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M833.007,690.511s-.266,1.787-.666,4.229c3.686,2.043,7.759-1.4,6.472-4.063a2.232,2.232,0,0,0-2.19-1.229,8.985,8.985,0,0,0-3.616,1.063",
    transform: "translate(-832.341 -689.449)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -18.591,
    y1: 24.913,
    x2: -18.569,
    y2: 24.913,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M697.975,515.94a2.087,2.087,0,0,0-.722,1.082,3.955,3.955,0,0,0-.2,1.172,1.609,1.609,0,0,0-2.623.25c0-.008-1.157-.329-1.275-.351a5.987,5.987,0,0,0-1.108-.108,3.729,3.729,0,0,0-2.7,1.048,10.547,10.547,0,0,0-.809,1.6,1.91,1.91,0,0,0-1.449-.523,2.556,2.556,0,0,0-1.31.958,3.159,3.159,0,0,0-.829,2.183,1.765,1.765,0,0,0,.3.825c-1.368.452-.876,1.057-.735,2.6-1.554,1.344-1.806,3.235-.42,4.369-1.428.336-2.268,3.277-1.26,4.159a4.458,4.458,0,0,0,.9,4.617c.812-1,1.319-3.49,1.453-4.873a17.346,17.346,0,0,1,1.3-5.375c.347-.712,2.295-3.266,1.58-3.8-.1-.081-.068-.059-.04-.036s.031.026.022.02c.629.477,1.629.084,2.265-.177a3.834,3.834,0,0,0,2.1-2.938c0,.031-.027.511,1.68.755a2.139,2.139,0,0,0,2.353-1.008,4.386,4.386,0,0,0,1.764,2.1c1.344.84,3.277-.5,3.277-.5s-1.26,1.428-.252,2.688,2.773.924,2.857-1.092a1.261,1.261,0,0,0,2.184.756c-.672,2.184,1.848,2.521,2.352,1.26-.084,1.26,1.176,2.857,2.016,2.352a2.308,2.308,0,0,0,1.26,2.857c-1.68,1.26-1.26,4.537.084,5.377-.672.168-1.092,2.016-.5,3.193-1.008.084-1.512,2.521-.924,3.7a1.178,1.178,0,0,0,.756,2.016,2.068,2.068,0,0,0,1.708-.581.716.716,0,0,0,.67-.021,1.209,1.209,0,0,0,.417-.868.548.548,0,0,0,.481.094,3.628,3.628,0,0,0,2.261-2.427.682.682,0,0,0-.059-.632.229.229,0,0,0-.056-.044,4,4,0,0,0,2.051-2.984,1.55,1.55,0,0,0-.615-1.614c-.01-.005-.021-.008-.032-.012a3.328,3.328,0,0,0,.243-1.373,1.621,1.621,0,0,0,.468-.378,3.2,3.2,0,0,0,.477-2.6,2.6,2.6,0,0,0-.615-1.413,1.347,1.347,0,0,0-.371-.263,3.362,3.362,0,0,0,.286-1.9,1.537,1.537,0,0,0-.816-1.307,1.255,1.255,0,0,0,.4-.648,1.57,1.57,0,0,0-.356-1.34,1.889,1.889,0,0,0-1.483-.638,1.229,1.229,0,0,0,.178-.62,2.013,2.013,0,0,0-3.128-1.764,1.782,1.782,0,0,0-.221-.021,1.345,1.345,0,0,0,.13-.775,1.942,1.942,0,0,0-.415-.884,2.062,2.062,0,0,0-1.99-.906.875.875,0,0,1-1.36,1.092c.006-.026.012-.051.017-.076s.009-.061.013-.092a2.4,2.4,0,0,0,.817-1.629,2.047,2.047,0,0,0-1.394-2.043,1.729,1.729,0,0,0-1.181.108,2.419,2.419,0,0,0-.722-1.347c-1.032-.923-2.064-.476-2.937.545a1.342,1.342,0,0,0-1.132-.922,1.626,1.626,0,0,0-1.451,1.11c0-.052,0-.1-.006-.156a2.555,2.555,0,0,0-2.359-2.109c-.068-.005-.136-.008-.2-.008a1.825,1.825,0,0,0-1.054.3",
    transform: "translate(-682.396 -515.644)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -2.401,
    y1: 5.484,
    x2: -2.397,
    y2: 5.484,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M1641.725,485.849c7.358,15.813,8.27,35.468,8.27,35.468l24.921,2.419c-4.54-41.018-28.024-60.588-28.024-60.588s-.313,2.818-5.167,22.7",
    transform: "translate(-1641.725 -463.148)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-120"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2172",
    "data-name": "Rectangle 2172",
    width: 59.649,
    height: 25.009,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2173",
    "data-name": "Rectangle 2173",
    width: 70.976,
    height: 38.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2174",
    "data-name": "Rectangle 2174",
    width: 60.063,
    height: 23.473,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2175",
    "data-name": "Rectangle 2175",
    width: 64.771,
    height: 37.263,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2176",
    "data-name": "Rectangle 2176",
    width: 66.895,
    height: 31.649,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-125"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2177",
    "data-name": "Rectangle 2177",
    width: 51.391,
    height: 88.424,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2178",
    "data-name": "Rectangle 2178",
    width: 51.522,
    height: 102.619,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2179",
    "data-name": "Rectangle 2179",
    width: 39.321,
    height: 107.49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2180",
    "data-name": "Rectangle 2180",
    width: 47.036,
    height: 94.929,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2181",
    "data-name": "Rectangle 2181",
    width: 27.206,
    height: 102.353,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-130"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2182",
    "data-name": "Rectangle 2182",
    width: 47.308,
    height: 107.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-131"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2183",
    "data-name": "Rectangle 2183",
    width: 59.704,
    height: 28.854,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-132"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2184",
    "data-name": "Rectangle 2184",
    width: 59.705,
    height: 28.854,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2185",
    "data-name": "Rectangle 2185",
    width: 71.11,
    height: 34.746,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-134"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2186",
    "data-name": "Rectangle 2186",
    width: 61.67,
    height: 22.8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-135"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2187",
    "data-name": "Rectangle 2187",
    width: 60.516,
    height: 26.837,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M1802.883,989.48c.194,7.755-2.715,48.082-4.265,59.327s-7.949,31.409-7.949,31.409l6.375,2.579s22.9-42.518,25.615-58.8c3.3-18.031,6.592-53.9,6.592-53.9l-1.551-12.021-22.3-.969s-2.714,24.623-2.52,32.378",
    transform: "translate(-1790.668 -957.102)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -6.475,
    y1: 1.218,
    x2: -6.472,
    y2: 1.218,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0993a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#e0993a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba7329"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M1805.761,501.831l-7.091.548s7.846,19.96,12.262,25.11c2.534-12.246,5.084-26.421,5.084-26.421l-5.141.507-.891-12.1-5.347-.062Z",
    transform: "translate(-1798.67 -489.417)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -7.143,
    y1: 8.448,
    x2: -7.139,
    y2: 8.448,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M1736.563,242.61c-11.338.058-15.89,4.16-18.794,12.436-1.24,3.536,2.1,9.948,2.509,13.563.543,4.847-1.347,6.705.575,9.324,1.557.773,2.8.766,3.26,1.3,4.413,5.068,9.665,10.174,16.222,11.959,5.614-3.524,11.93-11.194,13.933-16.458,3.63.42,4.994-5.041,3.437-15.446-1.551-10.362-10.577-16.675-21.011-16.675h-.132",
    transform: "translate(-1717.495 -242.61)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -5.737,
    y1: 6.144,
    x2: -5.734,
    y2: 6.144,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M1870.389,401.7c-1.83.193-4,.924-4.125,1.672a1.072,1.072,0,0,0,.09.615,2.005,2.005,0,0,0,.628.754,7.147,7.147,0,0,0,4.427,1,6.934,6.934,0,0,0,3.853-.864,1.419,1.419,0,0,0,.662-1.247,1.436,1.436,0,0,0-.624-1.039,6.335,6.335,0,0,0-3.686-.951,11.757,11.757,0,0,0-1.225.065",
    transform: "translate(-1866.251 -401.632)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2196",
    "data-name": "Rectangle 2196",
    width: 9.725,
    height: 4.116,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M1764.9,411.941c-1.783.452-3.823,1.485-3.844,2.244a1.075,1.075,0,0,0,.177.6,2.006,2.006,0,0,0,.728.656,7.149,7.149,0,0,0,4.524.354,6.936,6.936,0,0,0,3.69-1.405,1.419,1.419,0,0,0,.477-1.329,1.435,1.435,0,0,0-.766-.94,5.135,5.135,0,0,0-2.424-.518,10.71,10.71,0,0,0-2.563.342",
    transform: "translate(-1761.058 -411.599)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2198",
    "data-name": "Rectangle 2198",
    width: 9.699,
    height: 4.592,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M1862.964,322.841c-.749.633-1.273,1.554-2.158,1.974a12.666,12.666,0,0,0,1.487.387,5.058,5.058,0,0,0,.722.077c1.48.045,2.864-.668,4.3-1.023a10.215,10.215,0,0,1,3.8-.124,3.715,3.715,0,0,1-1.091-.621c-.327-.272-.6-.6-.921-.883a4.193,4.193,0,0,0-2.768-.912,5.377,5.377,0,0,0-3.371,1.124",
    transform: "translate(-1860.806 -321.717)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -29.115,
    y1: 37.425,
    x2: -29.099,
    y2: 37.425,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M1747.53,327.549a7.725,7.725,0,0,0-.85.621c-1.34,1.071-2.434,2.345-4.032,3.069a10.585,10.585,0,0,0,4.56-.69,12.174,12.174,0,0,1,4.048-.742,9.2,9.2,0,0,0,1.9.1,1.764,1.764,0,0,0-.177-.654,4.572,4.572,0,0,0-2.372-2.046,3.688,3.688,0,0,0-1.15-.181,3.766,3.766,0,0,0-1.922.523",
    transform: "translate(-1742.648 -327.026)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -26.104,
    y1: 33.335,
    x2: -26.089,
    y2: 33.335,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M1593.344,199.184a51.681,51.681,0,0,0-9.084,11.111c-2.416,3.825-4.9,7.764-6.111,12.021a3.681,3.681,0,0,0,.055,2.931c.915,1.513,3.31,1.573,5,2.418,2.634,1.315,3.281,4.59,2.216,7.087s-3.424,4.371-5.751,6.108-4.77,3.524-6.072,5.91c-.749,1.373-.985,3.177.286,4.173,1.348,1.056,3.96.86,4.672,2.312.507,1.034-.373,2.2-1.331,3.012-1.568,1.334-3.457,2.393-5.031,3.746s-2.9,3.157-2.8,5.017c1.505.475,3.235,1.175,3.42,2.544.2,1.509-1.617,2.718-2.993,3.87a10.651,10.651,0,0,0-3.884,6.848,2.12,2.12,0,0,0,.386,1.729c.928,1,2.939.51,4.408.967a3.078,3.078,0,0,1,1.834,4.112c-.6,1.559-2.065,2.785-3.444,3.967-1.283,1.1-2.621,2.489-2.159,3.956.568,1.8,3.394,2.4,5.7,2.385s4.914-.237,6.67,1a2.781,2.781,0,0,1,.311,4.48,4.79,4.79,0,0,1-5.617-.239c-.674.542-.411,1.543.309,2.107a5.811,5.811,0,0,0,2.706.935c2.879.431,11.475-.045,12.531-3.116.712-2.072-6.8-2.512-4.516-6.461.85-1.467,2.776-2.238,4.309-3.23s2.823-2.706,1.94-4.178c-.867-1.445-3.244-1.68-4.673-2.795-1.813-1.414-1.516-3.968-.047-5.562s3.729-2.449,5.89-3.2a12.156,12.156,0,0,0,3.924-1.882,2.937,2.937,0,0,0,1.034-3.517c-1.549-2.885-7.43-1.085-10.011-3.383a1.913,1.913,0,0,1-.646-1.01c-.227-1.14,1.139-2.061,2.458-2.377s2.781-.323,3.927-.947c2.309-1.256,2.1-4.144,3.466-6.152.678-1,1.625-1.842,2.293-2.845,1.743-2.616-1.036-5.62-3.72-7.936-1.97-1.563-3.949-3.935-3.889-6.364.063-2.562,2.244-3.186,4.488-4.414a6.24,6.24,0,0,0,2.4-1.867,3.618,3.618,0,0,0,.5-1.821,6.5,6.5,0,0,0-2.666-5.332,4.143,4.143,0,0,1-1.455-1.388,2.7,2.7,0,0,1,.518-2.363c.9-1.532,2.053-2.908,2.825-4.5a27.581,27.581,0,0,1,2.936-4.774,6.87,6.87,0,0,1,3.766-2.915,9.936,9.936,0,0,1,4.585.432,9.014,9.014,0,0,0,2.979.539,5.156,5.156,0,0,0,3.054-1.077c.17-1.158-1.293-2.091-1.266-3.259,2.23-1.562,4.163-5.955.752-7.085a70.591,70.591,0,0,0-10.935-2.672,15.778,15.778,0,0,0-2.517-.214,11.364,11.364,0,0,0-7.934,3.152",
    transform: "translate(-1565.911 -196.031)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -2.849,
    y1: 2.429,
    x2: -2.847,
    y2: 2.429,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M1843.544,220.331c-1.269.286-6.706,1.749-6.938,3.134-.271,1.614-1.29,4.078-.647,5.687.61,1.525,3.5,1.378,5.118,1.277a25.01,25.01,0,0,1,5.366-.109c3.4.527,6.2,3.269,6.442,6.314a11.242,11.242,0,0,1-.718,5.193c-.559,1.423-1.354,2.9-.971,4.368.568,2.177,3.536,3.481,3.776,5.705.173,1.595-1.154,3.04-1.256,4.639-.256,4,6.664,5.87,7.012,9.861.356,4.078-3.083,5.521-5.327,9.02-.731,1.139-.886,3.834-.5,4.38,1.387,1.974.934,3.876-.548,5.856-2.715,3.628-4.232,8.545-1.679,12.264,2.063,3.005,6.127,4.353,9.892,5.495-.413,3.162-3.976,5.633-3.824,8.813.174,3.627,4.872,5.571,8.892,6.333,5.307,1.006,11.215,1.291,15.8-1.271,2.91-1.625,4.935-4.2,6.879-6.713a3.271,3.271,0,0,0,.919-1.977c-.069-1.832-2.9-2.282-4.977-2.166-.414,1.744-.983,3.631-2.61,4.685s-4.573.5-4.787-1.273c-.259-2.147,3.384-3.435,3.243-5.591-1.589.563-4.439.21-4.243-1.8.114-1.167,1.112-2.089,1.945-3,1.785-1.954,3.045-4.418,2.8-6.919a6.124,6.124,0,0,0-5.11-5.34c-1.531-.216-3.465.018-4.283-1.146a2.024,2.024,0,0,1-.3-1.4c.241-2.154,2.46-3.66,4.545-4.8s4.408-2.376,5.118-4.447c.965-2.816-1.584-5.65-4.4-7.229s-6.14-2.6-8.287-4.846a15.244,15.244,0,0,1-2.678-4.477,64.082,64.082,0,0,1-4.736-13.268c-.968-4.785-.881-9.73-2.31-14.425a16.185,16.185,0,0,0-9.449-10.578,9.382,9.382,0,0,0-3.641-.7,16.11,16.11,0,0,0-3.534.453",
    transform: "translate(-1835.749 -219.878)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -3.369,
    y1: 2.535,
    x2: -3.367,
    y2: 2.535,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M1864.784,292.513q.124.032.245.074c.014-.087-.029-.119-.091-.119a.357.357,0,0,0-.154.045m-24.105-50.357c-2.209,2.143-1.092,4.213-7.1,4.625.779.794,2.105.987,5.435,1.132a15.391,15.391,0,0,0,2.435-.16,9.346,9.346,0,0,1,3.867.072c3.032.948,5.407,3.163,5.545,6,.1,2.134-.63,3.744-1.5,5.737s-1.192,4.52.516,6.032c1.228,1.087,3.321,1.457,3.959,2.886,1.07,2.4-3.03,4.311-3.206,6.882-.123,1.793,1.687,3.187,3.392,4.166s3.653,2.052,4.076,3.809c.6,2.483-2.106,4.48-4.019,6.376a10.178,10.178,0,0,0-3.2,6.161,6.743,6.743,0,0,0,2.844,6.129c3,2.053,7.386,1.528,10.779.032,2.22-.979,4.365-2.5,4.94-4.63a11.666,11.666,0,0,0-3.092.718,4.683,4.683,0,0,1-3.129.056c-.959-.421-1.477-1.666-.738-2.351a6.1,6.1,0,0,0,5.011-2.358l-2.768-.714c-.179-.046-.077-.175.055-.244a3.49,3.49,0,0,0-3.629,1.244l1.378-.208c-.393,1.616-3.046,2.943-2.021,4.326.569.768,2.167,1.373,1.528,2.1a5.775,5.775,0,0,1-5.806-.852,4.231,4.231,0,0,1-1.035-5.116c1.246-2.349,4.481-3.337,6.2-5.439a5.3,5.3,0,0,0,.684-5.7c-1.051-2.107-3.387-3.445-5.128-5.159s-2.845-4.494-1.126-6.226a5.028,5.028,0,0,0-.9-7.634c-1.7-1.129-.631-3.468.3-5.162a13.47,13.47,0,0,0,1.447-10.082,11.249,11.249,0,0,0-7.391-7.52,13.385,13.385,0,0,0-3.9-.649,6.539,6.539,0,0,0-4.706,1.719",
    transform: "translate(-1833.583 -240.437)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -5.377,
    y1: 3.897,
    x2: -5.374,
    y2: 3.897,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f2a1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#4f2a1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#3d2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d2114"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M1672.908,222.747a10.584,10.584,0,0,0-2.029,5.623c-.142,2.652.657,5.651-1.225,7.722-1.484,1.633-4.2,2.083-5.672,3.723a4.347,4.347,0,0,0-.724,4.5,5.7,5.7,0,0,0,3.384,3.563c2.116.6,7.045.469,3.305,3.278-.753.566-1.045,1.627-2,2.036a15.457,15.457,0,0,0-2.861,1.238c-1.927,1.347-1.93,3.88-1.759,6.045a9.431,9.431,0,0,0,.636,3.211c.892,1.965,3.023,3.265,5.173,4.2,1.21.527,2.687,1.3,2.518,2.484-.26,1.831-3.754,1.506-4.9,3.047-.846,1.133.115,2.759,1.512,3.326.178,1.667-1.626,3-3.424,3.531s-3.781.616-5.432,1.44-2.79,2.865-1.618,4.181a4.7,4.7,0,0,0,1.885,1.075l4.938,1.887a6.42,6.42,0,0,0-1.92,1.838,1.876,1.876,0,0,0,.24,2.347,3.924,3.924,0,0,1,2.479-2.876,14.172,14.172,0,0,1,4.118-.933.607.607,0,0,0,.026-.958,2.287,2.287,0,0,0-1.1-.462l-6.714-1.534c-.453-.1-.966-.25-1.15-.631-.217-.45.156-.944.54-1.3a10.69,10.69,0,0,1,7.047-2.686c.209,0,.42,0,.631.007a7.21,7.21,0,0,0,1.947-.137c.829-.214,1.606-.854,1.55-1.615a4.358,4.358,0,0,0-.494-1.232c-.666-1.629.663-3.329,1.977-4.616s2.8-2.795,2.489-4.5a5.527,5.527,0,0,0-1.918-2.736l-3.55-3.36c-1.884-1.782-3.907-4.2-2.771-6.424,1.015-1.985,3.953-2.489,5.7-4.031a4.477,4.477,0,0,0,.394-6.3c-.869-.961-2.194-1.676-2.567-2.86-.412-1.311.509-2.632,1.4-3.744,1.47-1.845,3.006-3.756,3.452-5.977.41-2.041-.147-4.137-.009-6.207a2.146,2.146,0,0,1,.363-1.208,2.3,2.3,0,0,1,2.632-.381,7.171,7.171,0,0,1,2.118,1.738,8.922,8.922,0,0,0,4.153,2.642c1.67.406,3.705-.044,4.572-1.368a2.564,2.564,0,0,0-.458-3.27,3.509,3.509,0,0,0-3.688-.506c-1.159.55-2.119,1.784-3.4,1.535a2.278,2.278,0,0,1-1.228-.774,14.372,14.372,0,0,1-1.779-3.331,4.046,4.046,0,0,0-2.941-2.4,2.947,2.947,0,0,0-.336-.019,4.651,4.651,0,0,0-3.495,2.166",
    transform: "translate(-1657.304 -220.581)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -4.659,
    y1: 3.558,
    x2: -4.656,
    y2: 3.558,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M1950.059,782.992s-2.554,5.492-5.319,6.463-6.8,1.983-6.854,2.8,2.033,1.522,7.2.131c-8.71,4.279-11.3,8.25-11.372,8.778s-.1.936,4.228-.8c-4.29,3.7-4.106,5.309-1.536,4.817-.534,1.317,1.363,1.111,7.065-1.6,8.088-4.809,11.8-22.9,11.8-22.9Z",
    transform: "translate(-1933.696 -780.684)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -9.898,
    y1: 5.611,
    x2: -9.893,
    y2: 5.611,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a26424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#a26424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb7329"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M2006.128,557.66c-3.686,1.6-5.543,6.7-6.3,12.734s-2.975,4.529-2.753,7.726.267,8.7,10.834,10.968,17.548-2.85,19.227-9.9c1.989-8.356-.2-20.142-9.92-21.967a28.324,28.324,0,0,0-5.226-.515,14.6,14.6,0,0,0-5.864.956",
    transform: "translate(-1997.061 -556.704)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -10.1,
    y1: 6.221,
    x2: -10.095,
    y2: 6.221,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M2092.028,681.884a.808.808,0,0,0-.02.463,1.511,1.511,0,0,0,.349.64,5.212,5.212,0,0,0,3.055,1.351,15.908,15.908,0,0,0,2.968.373c.94-.128,1.2-.128,1.539-.9s-.315-1.486-.556-1.753c-.8-.884-3.4-1.1-4.531-1.2q-.17-.014-.337-.014a2.859,2.859,0,0,0-2.468,1.034",
    transform: "translate(-2091.984 -680.85)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-161"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2213",
    "data-name": "Rectangle 2213",
    width: 8.292,
    height: 3.861,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M2010.715,670.341a.66.66,0,0,0-.016.376,1.226,1.226,0,0,0,.283.519,4.23,4.23,0,0,0,2.479,1.1,4.063,4.063,0,0,0,2.35-.076.854.854,0,0,0,.526-.666.879.879,0,0,0-.249-.689,4.4,4.4,0,0,0-2.774-1.085c-.184-.016-.374-.023-.565-.023-.946,0-1.9.19-2.033.548",
    transform: "translate(-2010.679 -669.793)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M2147.991,696.1s-.266,1.787-.666,4.23c3.686,2.042,7.76-1.4,6.472-4.063a2.231,2.231,0,0,0-2.19-1.229,8.986,8.986,0,0,0-3.616,1.062",
    transform: "translate(-2147.325 -695.033)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -47.952,
    y1: 24.794,
    x2: -47.93,
    y2: 24.794,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M1721.047,740.038a74.9,74.9,0,0,0,.646,15.9c6.2,3.1,24.221,4.383,42.964,2.573-4.36-1.881-4.531-2.223-4.531-2.223s-13.228,2.234-29.127-6.943a57.268,57.268,0,0,0,1.257-11.495h0c-.116,0-6.724.01-11.208,2.188",
    transform: "translate(-1720.885 -737.85)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -5.9,
    y1: 4.714,
    x2: -5.897,
    y2: 4.714,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M1948.425,782.437c-4.558.492-11.417,5.892-15.214,7.953-3.862,2.054-4.446,2.443-5.457,2.766-3.138-1.715-9.441-4.841-10.712-5.108-.456.513-.086,1.363,1.2,2.736-3.687-1.372-7.01-2.451-9.176-3.021a4.526,4.526,0,0,0,1.2,2.052c-2.28.057-.188,1.141.342,1.653-.9.553.515.907,1.71,1.881s4.188,1.494,7.1,2.262,5.006.947,8.77,1.612c2.834.24,1.962-.114,4.887-.709s5.02-1.344,10.78-3.519,9.7-4.351,10.625-6.916c.575-2.058-1.882-3.7-5.038-3.7a9.348,9.348,0,0,0-1,.055",
    transform: "translate(-1909.062 -782.382)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -6.573,
    y1: 6.184,
    x2: -6.569,
    y2: 6.184,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M2158.447,1527.785s1.506,10.552,2.2,13.665c1.756,7.9-.325,18.478-.325,18.478s2.434.189,3.09-.2a89.837,89.837,0,0,0,1.174-36.55Z",
    transform: "translate(-2158.447 -1523.178)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -9.603,
    y1: 4.409,
    x2: -9.599,
    y2: 4.409,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c4b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#2c4b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#2c4b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253e76"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M2101.812,1564.357a7.987,7.987,0,0,0,3.523-.033,144.036,144.036,0,0,1,2.01-31.537s-1.236-.813-6.041-4.065c-2.334,15.042.508,35.635.508,35.635",
    transform: "translate(-2100.383 -1528.722)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -9.506,
    y1: 5.003,
    x2: -9.501,
    y2: 5.003,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M2035.638,1447.562c-1.427,1.286-2.491,3.76-2.027,5.363.227.244.429-.274.5-.447s.873-2.189,1.348-2.169c.115,1.412,1.272,3.513,2.364,3.091.61-.325-1.1-1.982-.461-3.009.32.834,2.488,2.979,2.894,1.884s-1.848-1.311-1.3-2.987c1.163.636,2.174.68,2.257.156s-2.191-1.619-2.265-2.618a40.883,40.883,0,0,1,1.13-14.6,9.672,9.672,0,0,0-2.087-2.611s-2.391,4.175-2.353,17.949",
    transform: "translate(-2033.501 -1429.613)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -13.257,
    y1: 4.516,
    x2: -13.25,
    y2: 4.516,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M2226.781,1435.054a40.881,40.881,0,0,1,1.13,14.6c-.074,1-2.349,2.094-2.266,2.618s1.094.48,2.257-.156c.552,1.676-1.7,1.891-1.3,2.986s2.574-1.049,2.895-1.883c.642,1.027-1.072,2.683-.461,3.009,1.092.422,2.248-1.68,2.364-3.091.476-.021,1.281,2,1.348,2.169s.27.691.5.447c.465-1.6-.6-4.076-2.027-5.363.039-13.774-2.352-17.949-2.352-17.949a9.675,9.675,0,0,0-2.088,2.611",
    transform: "translate(-2225.643 -1432.443)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -24.472,
    y1: 2.902,
    x2: -24.461,
    y2: 2.902,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M2135.07,1260.556l-2.024,8.314a1.856,1.856,0,0,0,1.415,2.152,7.5,7.5,0,0,0,5.572-1.529l-1.353-.984s-.515-7.906-.515-8.188Z",
    transform: "translate(-2133.014 -1260.322)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -35.883,
    y1: 8.181,
    x2: -35.866,
    y2: 8.181,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M2038.8,1057.6c-3.771,3.95-4.9,6.551-5.168,14.281l-.285,8.316s-3.994,4.441,1.216,8.952,10.771,5.281,11.728,5.2c6.128-1.439,15.135-3.6,19.831-8.49,4.927-4.645,8.653-19.179-1.318-27.365a21.458,21.458,0,0,0-13.792-4.924c-5.554,0-10.3,2.033-12.211,4.034",
    transform: "translate(-2031.887 -1053.566)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -7.592,
    y1: 3.383,
    x2: -7.589,
    y2: 3.383,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a56625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#ba7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#ba7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M2035.279,1228.845a.875.875,0,0,0-.042.464,1.485,1.485,0,0,0,.294.647,4.55,4.55,0,0,0,2.795,1.4,4.434,4.434,0,0,0,2.721-.053,1.055,1.055,0,0,0,.406-1.67,4.717,4.717,0,0,0-3.137-1.388,7.241,7.241,0,0,0-.764-.039c-1.057,0-2.1.219-2.274.644",
    transform: "translate(-2035.224 -1228.201)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-180"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2232",
    "data-name": "Rectangle 2232",
    width: 6.533,
    height: 3.425,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M2116.527,1231.05a.938.938,0,0,0-.042.542,1.751,1.751,0,0,0,.39.764,6.257,6.257,0,0,0,3.587,1.7,6.074,6.074,0,0,0,3.457.005,1.242,1.242,0,0,0,.806-.937,1.257,1.257,0,0,0-.332-1.008,6.514,6.514,0,0,0-4.022-1.7,10.2,10.2,0,0,0-1.177-.067c-1.27,0-2.473.231-2.667.7",
    transform: "translate(-2116.464 -1230.351)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-182"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2234",
    "data-name": "Rectangle 2234",
    width: 8.329,
    height: 4.063,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M2123.075,1181.761c-.8,1.992-.644,6.1,2.519,6.632,1.809.3,4.76-.595,4-6.829a5.243,5.243,0,0,0-3.565-1.471,3.023,3.023,0,0,0-2.953,1.667",
    transform: "translate(-2122.67 -1180.094)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M2046.63,1181.989c-.729,3.745,1.821,4.626,4.137,4.26a9.8,9.8,0,0,0,.406-6.282,1.656,1.656,0,0,0-1.538-1.175c-1.139,0-2.484,1.19-3.006,3.2",
    transform: "translate(-2046.503 -1178.792)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M2078.991,1247.671a29.869,29.869,0,0,1-5.417,1.337,7.083,7.083,0,0,1-2.276,0c-.823-.119-1.254-.239-1.481.409-.382,1.086,2.633,3.33,5.9,3.227a6.33,6.33,0,0,0,5.561-3.908c.213-.8-.266-1.307-1.124-1.307a3.28,3.28,0,0,0-1.166.247",
    transform: "translate(-2069.785 -1247.424)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M2068.388,1016.516h-.054a1.5,1.5,0,0,0-1.172-.6,1.564,1.564,0,0,0-1.216.558.929.929,0,0,0-.759-.417.967.967,0,0,0-.96.764l-.124.015a1.521,1.521,0,0,0-.9-.32,1.562,1.562,0,0,0-1.321.674l-.169.033a1.531,1.531,0,0,0-1.023-.437,1.554,1.554,0,0,0-1.466.926,2.113,2.113,0,0,0-2.427.637,2.075,2.075,0,0,0-.8-.186,2.144,2.144,0,0,0-1.961,1.2,1.5,1.5,0,0,0-.22-.026,1.566,1.566,0,0,0-1.31.7c-.047,0-.092-.015-.141-.015a1.6,1.6,0,0,0-1.4.87l-.073.039a2.018,2.018,0,0,0-.345-.03,2.251,2.251,0,0,0-2.035,1.421,1.012,1.012,0,0,0-.914.732,2.319,2.319,0,0,0-1.823,2.064,1.675,1.675,0,0,0-.894,1.395,1.494,1.494,0,0,0,.022.323l-.019.038a1.025,1.025,0,0,0-.706.915.878.878,0,0,0,.127.5.523.523,0,0,0-.169.5.924.924,0,0,0-.092,1.083,12.881,12.881,0,0,0,.218,4.1,10.008,10.008,0,0,1,2.145-4.45,2.74,2.74,0,0,0,2.9,2.741,1.588,1.588,0,0,0,1.216.382,1.023,1.023,0,0,0,.618-.262,2,2,0,0,0,.957.192,2.291,2.291,0,0,0,1.236-.435h.014a2.04,2.04,0,0,0,1.214.36,2.307,2.307,0,0,0,1.422-.531.946.946,0,0,0,.552.181,1,1,0,0,0,.787-.373.983.983,0,0,0,1.045-.242,1,1,0,0,0,.722.347.965.965,0,0,0,.856-.43,2.407,2.407,0,0,0,.811.188,2.22,2.22,0,0,0,1.6-.537l.032,0a1.778,1.778,0,0,0,.967.372,1.536,1.536,0,0,0,1.313-.542,1.1,1.1,0,0,0,.726.354.9.9,0,0,0,.88-.454,1.768,1.768,0,0,0,.784.257,1.512,1.512,0,0,0,1.1-.346,2.379,2.379,0,0,0,1.524,2.094,2,2,0,0,0-.023.332,2.455,2.455,0,0,0,1.252,2.018l.018.05a.86.86,0,0,0-.186.562,1.112,1.112,0,0,0,.674.974c.009.031.018.062.026.093a.875.875,0,0,0-.308.694,1.12,1.12,0,0,0,.6.962,1.535,1.535,0,0,0-.287.909,1.83,1.83,0,0,0,.541,1.283,2.259,2.259,0,0,0-.446,1.321,2.551,2.551,0,0,0,.459,1.517,1.676,1.676,0,0,0-.681,1.295,1.767,1.767,0,0,0,.6,1.438,1.094,1.094,0,0,0-.31.7,1.069,1.069,0,0,0,.268.793c0,.009,0,.018,0,.027-.035.23-.059.36-.059.36l2.1,2.8s.813,2.83-1.671,6.449a20.689,20.689,0,0,0,8.286-4.591,1.392,1.392,0,0,0,.419.094,1.554,1.554,0,0,0,1.583-1.54,1.71,1.71,0,0,0-.061-.509,1.536,1.536,0,0,0,1.539-1.529,1.709,1.709,0,0,0-.069-.526.872.872,0,0,0,.142.024.92.92,0,0,0,.953-.926,1.04,1.04,0,0,0-.121-.512,2.034,2.034,0,0,0,1.492-1.988,2.345,2.345,0,0,0-.191-.945,1.406,1.406,0,0,0,1.359-1.449,1.719,1.719,0,0,0-.342-1.022,1.991,1.991,0,0,0,1.271-1.9,2.425,2.425,0,0,0-1.113-2.058c0-.007,0-.014,0-.02a1.444,1.444,0,0,0,1.292-1.465,1.708,1.708,0,0,0-1.119-1.677.9.9,0,0,0,.794-.911,1.02,1.02,0,0,0-.872-1.074.8.8,0,0,0-.139,0c0-.012,0-.023,0-.035a2.249,2.249,0,0,0,.706-1.6,2.385,2.385,0,0,0-1.364-2.282.978.978,0,0,0,.5-.843,1.01,1.01,0,0,0-.877-1.076.807.807,0,0,0-.267.03c-.02-.053-.039-.106-.059-.159a1.694,1.694,0,0,0,.3-.927,1.625,1.625,0,0,0-1.448-1.725c-.042,0-.081.005-.122.006a1.661,1.661,0,0,0,.257-.854,1.607,1.607,0,0,0-1.473-1.682,1.4,1.4,0,0,0-.66.138c-.017-.017-.034-.036-.052-.053.005-.057.01-.114.011-.173a2.208,2.208,0,0,0-2.029-2.306,1.935,1.935,0,0,0-.693.1,1.532,1.532,0,0,0-1.36-1.065,1.4,1.4,0,0,0-.528.084,2.105,2.105,0,0,0-1.864-1.416,1.981,1.981,0,0,0-1.12.295,1.513,1.513,0,0,0-1.312-.92,1.46,1.46,0,0,0-.83.224.921.921,0,0,0-.758-.446.938.938,0,0,0-.748.348,2.067,2.067,0,0,0-1.557-.755h-.041a2.158,2.158,0,0,0-1.6.718",
    transform: "translate(-2043.919 -1015.798)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -6.151,
    y1: 2.648,
    x2: -6.148,
    y2: 2.648,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M2215.949,1222.574s3.106.2,2.492,2.076c-.4,1.218-1.384,2.124-3.932,2.31,2.033.7,5.085.543,5.875-2.94.348-1.535-.635-1.938-1.762-1.938a9.693,9.693,0,0,0-2.673.493",
    transform: "translate(-2214.509 -1222.081)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -63.369,
    y1: 16.711,
    x2: -63.34,
    y2: 16.711,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a96825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#a66624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#9e6122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#90591f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#83511d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83511d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M1206.754,1368.82a15.238,15.238,0,0,0-8.243,3.473,12.442,12.442,0,0,0-3.225,3.7,12.528,12.528,0,0,0-2.232-.405,2.279,2.279,0,0,0-1.633.31c-.519.412-.65,1.186-1.186,1.575-.63.457-1.5.192-2.262.043a3.868,3.868,0,0,0-2.078.089,2.14,2.14,0,0,0-1.381,1.473,4.688,4.688,0,0,0-4.218,1.068,1.091,1.091,0,0,0-.411.665c-.045.529.578.912.606,1.442.029.553-.561.9-1.023,1.2s-.885.967-.494,1.359c.17.171.437.208.623.362.46.383.1,1.185-.442,1.436a13.836,13.836,0,0,1-1.748.376c-.571.179-1.108.8-.829,1.332.225.426.822.5,1.14.857.578.658-.112,1.659-.826,2.167s-1.6,1.161-1.421,2.018c.237,1.118,2.165,1.475,1.993,2.6-.094.62-.854,1.055-.765,1.677.123.861,1.693.938,1.714,1.808a5.163,5.163,0,0,0-2.34.292,1.767,1.767,0,0,0-1.09,1.9,2.118,2.118,0,0,0,.573.9,5.9,5.9,0,0,0,2.337,1.48c.668.227,1.543.534,1.524,1.239a1.7,1.7,0,0,1-.2.629,1.7,1.7,0,0,0,.024,1.763c.519.6,1.486.376,2.231.1s1.712-.508,2.232.094c.575.666.232,2,1.058,2.3.606.22,1.161-.409,1.495-.96s.857-1.195,1.475-1.013c.714.21.685,1.139,1.2,1.553.3.242.721.073,1.133-.1.563-.231,1.107-.463,1.288.357.205.925.131,2.852,1.123,3.375.564.3,1.246-.093,1.7-.542a5.873,5.873,0,0,0,1.166-1.646,5.241,5.241,0,0,0,.116,2.6,1.568,1.568,0,0,0,.617.94c.666.391,1.525-.214,1.819-.928s.265-1.527.533-2.252a4.536,4.536,0,0,0,.5,1.634,1.542,1.542,0,0,0,1.414.8c.922-.11,1.327-1.229,1.368-2.157s-.041-1.976.593-2.654a.366.366,0,0,1,.214-.132c.154-.016.267.137.335.277.26.539.344,1.155.642,1.674a1.249,1.249,0,0,0,1.485.675c.885-.42.459-1.944,1.215-2.568.2.626.61,1.338,1.27,1.339a1.171,1.171,0,0,0,1.036-.97,3.424,3.424,0,0,0-.123-1.516l-.482-2.049a4.415,4.415,0,0,1,1.179,1.076,1.377,1.377,0,0,0,1.431.482c.694-.3.63-1.293.45-2.028.316.448.836.952,1.324.7.668-.338.159-1.386.4-2.1a1.558,1.558,0,0,0,2.014.79,2.669,2.669,0,0,0,1.462-1.818,2.6,2.6,0,0,0-.129-1.759,1.75,1.75,0,0,0,1.744-.305,1.788,1.788,0,0,0-.236-2.687,1.534,1.534,0,0,0,1.79-.945,1.986,1.986,0,0,0-.508-2.047.921.921,0,0,1-.339-.484c-.03-.243.169-.445.278-.664.343-.695-.256-1.492-.9-1.923s-1.43-.786-1.714-1.507c.8-.2,1.735-.51,1.964-1.3a1.523,1.523,0,0,0-.7-1.6c.173-.09.343-.187.508-.294a1.851,1.851,0,0,0,.932-1.184,1.686,1.686,0,0,0-1.2-1.618c-.672-.27-1.419-.311-2.09-.583a2.676,2.676,0,0,1,1.22-.883c.451-.238.913-.65.854-1.156-.078-.665-.909-.874-1.536-1.107a.721.721,0,0,1-.307-.185c-.314-.367.184-.849.494-1.22a1.751,1.751,0,0,0-.162-2.332,6.931,6.931,0,0,0-1.575-.808c-.527-.272-1.021-.815-.882-1.391.222-.923,1.763-.983,2-1.9a1.578,1.578,0,0,0-.6-1.383,10.415,10.415,0,0,0-7.434-2.945q-.433,0-.864.033",
    transform: "translate(-1174.943 -1368.787)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -4.481,
    y1: 1.821,
    x2: -4.478,
    y2: 1.821,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#007698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#008ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008ba6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M1060.628,1287.5a4.071,4.071,0,0,0-2.43,1.176,2.6,2.6,0,0,0-.617,2.547,1.924,1.924,0,0,0,2.169,1.259l-1.5,1.489a4.586,4.586,0,0,0-1.652-.682,10.664,10.664,0,0,0-3.579.075,6.791,6.791,0,0,0-2.5.7,2.408,2.408,0,0,0-1.3,2.114c.062.941.848,1.7,1,2.627a5.374,5.374,0,0,0-2.869.718,1.682,1.682,0,0,0-.7.652c-.391.781.334,1.636.993,2.208a4.34,4.34,0,0,0-2.184.406,1.494,1.494,0,0,0-.687,1.9c.386.663,1.487,1.061,1.245,1.788a9.48,9.48,0,0,0-4.016-.008c-.484.1-1.039.326-1.145.81-.136.621.554,1.082,1.142,1.325s1.3.642,1.231,1.275a11.994,11.994,0,0,0-3.619,1.686c-.255.176-.53.416-.51.725.04.642,1.073.534,1.547.969a6.847,6.847,0,0,1-1.421.829c-.469.29-.862.888-.6,1.371.2.356.657.472.927.776a1.318,1.318,0,0,1,.012,1.514,6.052,6.052,0,0,1-1.11,1.173,5.621,5.621,0,0,0-.866,1.051,4.841,4.841,0,0,0-.675.36,4.575,4.575,0,0,0-1.64,5.543,8.878,8.878,0,0,0,.825,1.363l.915,1.324a1.5,1.5,0,0,1,.373.976c-.071.606-.8.872-1.414.908a2.475,2.475,0,0,0-1.724.449,1.388,1.388,0,0,0,.207,1.862,4.03,4.03,0,0,0,1.871.846l1.981.51a2.577,2.577,0,0,1,1.534.8,9.055,9.055,0,0,1,.561,1.627,2.413,2.413,0,0,0,1.975,1.253,6.3,6.3,0,0,0,2.172-.251l.069.074a5.9,5.9,0,0,0,2.337,1.48c.669.227,1.543.533,1.524,1.239a1.711,1.711,0,0,1-.2.629,1.694,1.694,0,0,0,.024,1.763c.518.6,1.486.375,2.231.1s1.712-.508,2.232.094c.574.666.232,2,1.058,2.3.606.22,1.161-.409,1.495-.96s.857-1.195,1.475-1.013c.754.221.759,1.435,1.479,1.752.777.342,1.509-.635,2.351-.746a2.207,2.207,0,0,0,2.936.891,3.071,3.071,0,0,0,1.714-3.061,12.658,12.658,0,0,1-.494-2.533,2.613,2.613,0,0,0,4.09-1.655c.162-.889-.05-2.02.7-2.518a2.324,2.324,0,0,1,.894-.271,3.214,3.214,0,0,0,2.483-1.53c.647-1.408-.539-3.149.066-4.576.439-1.035,1.643-1.495,2.385-2.34,1.252-1.426.962-3.589.6-5.451a22.315,22.315,0,0,0-.674-2.794,25.532,25.532,0,0,0,1.653-4.493c4.078-1.629,8.54-2.533,12.024-5.2a5.049,5.049,0,0,0,1.444-1.543,6.116,6.116,0,0,0,.394-.993l1.04-3.144a6.3,6.3,0,0,0,.46-2.418,2.146,2.146,0,0,0-1.32-1.926,2.492,2.492,0,0,1-.7-.241c-.517-.362-.321-1.156-.1-1.747a5.306,5.306,0,0,0,.419-2.87,2.237,2.237,0,0,0-1.97-1.874,2.848,2.848,0,0,0-2.253,1.64c-.679-.633-.565-1.886-1.352-2.379a1.448,1.448,0,0,0-1.473.068,3.758,3.758,0,0,0-1.072,1.105.789.789,0,0,1-.76-.727,2.587,2.587,0,0,1,.173-.751,1.858,1.858,0,1,0-3.635-.2l-2.685-1.684a3.288,3.288,0,0,0-.216,1.682,1.05,1.05,0,0,1-1.115-.468c-.263-.343-.422-.761-.713-1.08a1.695,1.695,0,0,0-2.871,1.642,3.909,3.909,0,0,1-2.112-.665,3.815,3.815,0,0,0-2.115-.649,1.5,1.5,0,0,0-1.248.968,3.262,3.262,0,0,0-1.392-2.318,4.285,4.285,0,0,0-2.451-.716,5.223,5.223,0,0,0-.744.054",
    transform: "translate(-1033.967 -1287.451)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -3.012,
    y1: 1.689,
    x2: -3.009,
    y2: 1.689,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M1214.988,1531.554c1.86,1.395,6.653,1.33,7.821.184a6.227,6.227,0,0,1-.854-2.928c.061-.605,3.635-5.75,3.635-5.75l-4.34-1.308a45.375,45.375,0,0,1-6.262,9.8",
    transform: "translate(-1214.988 -1521.752)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -19.595,
    y1: 5.199,
    x2: -19.579,
    y2: 5.199,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M1204.15,1339.54c-8.97,4.874-12.634,16.739-7.676,25.544,0,0,8.085,10.24,16.423,11.062s23.159-2.345,16.33-14.226c-.561-10.748-2.137-18.86-7.641-22.383-2.968-1.9-5.2-3.167-8.029-3.167-2.418,0-5.275.924-9.407,3.17",
    transform: "translate(-1194.249 -1336.37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -4.523,
    y1: 2.215,
    x2: -4.519,
    y2: 2.215,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M1264.845,1497.315a1.789,1.789,0,0,0-.545.453.715.715,0,0,0-.115.674.992.992,0,0,0,.58.468,5.369,5.369,0,0,0,4,.033,2.15,2.15,0,0,0,.857-.55,1,1,0,0,0,.225-.955,1.251,1.251,0,0,0-.672-.638,3.468,3.468,0,0,0-1.532-.338,5.536,5.536,0,0,0-2.8.853",
    transform: "translate(-1264.143 -1496.462)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -36.805,
    y1: 20.936,
    x2: -36.776,
    y2: 20.936,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M1366.785,1501.17a1.8,1.8,0,0,0-.545.454.715.715,0,0,0-.115.674.99.99,0,0,0,.58.468,5.372,5.372,0,0,0,4,.034,2.15,2.15,0,0,0,.856-.55.993.993,0,0,0,.225-.955,1.251,1.251,0,0,0-.672-.639,3.47,3.47,0,0,0-1.533-.338,5.541,5.541,0,0,0-2.8.853",
    transform: "translate(-1366.083 -1500.317)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -39.773,
    y1: 20.716,
    x2: -39.744,
    y2: 20.716,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M1328.576,1468.172c.148,2.309,2.053,4.261,3.711,3.781,1.168-1.146,1.737-3.124-.3-2.923s-1.995-4.646-1.995-4.646c-.053-.414-.189-.611-.358-.611-.483,0-1.233,1.62-1.055,4.4",
    transform: "translate(-1328.549 -1463.773)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -40.35,
    y1: 7.867,
    x2: -40.319,
    y2: 7.867,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M1261.91,1417.667s4.365-2.121,8.159-1.346a4.078,4.078,0,0,0-1.039-2.108s-.267-.029-.7-.029c-1.511,0-5.052.349-6.419,3.482",
    transform: "translate(-1261.91 -1414.184)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -26.417,
    y1: 21.998,
    x2: -26.396,
    y2: 21.998,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M1370.007,1421.99s2.489.938,3.223,1.305a4.815,4.815,0,0,0-3.957-3.059Z",
    transform: "translate(-1369.273 -1420.236)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -59.166,
    y1: 24.701,
    x2: -59.122,
    y2: 24.701,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M1263.561,1449.068a7.074,7.074,0,0,0,1.022,6.319c1.381.986,5.173,1.856,6.717.341,0,0,.177-4.03-1.658-6.087a4.232,4.232,0,0,0-3.242-1.421,5.139,5.139,0,0,0-2.839.847",
    transform: "translate(-1263.22 -1448.221)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -24.457,
    y1: 7.846,
    x2: -24.437,
    y2: 7.846,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M1267.693,1454.307c-1.725,1.143-1.391,4.168-.386,5.753a7.367,7.367,0,0,0,3.573,1.081c.7-.5,1.7-3.447,1.156-5.26a2.857,2.857,0,0,0-2.719-2.08,2.927,2.927,0,0,0-1.624.507",
    transform: "translate(-1266.476 -1453.8)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -32.696,
    y1: 9.514,
    x2: -32.67,
    y2: 9.514,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M1361.026,1457.048c-1.345,2.583.446,5.879.446,5.879,2.724.936,3.514-.248,4.248-1.327.554-.814.354-3.776.135-4.689a3.488,3.488,0,0,0-2.583-1.529,2.582,2.582,0,0,0-2.245,1.666",
    transform: "translate(-1360.525 -1455.382)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -35.158,
    y1: 8.202,
    x2: -35.132,
    y2: 8.202,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M1359.322,1464.082c-.2,1.514.554,4.1,1.692,4.114,1.229.057,1.884-.26,2.308-1.242s.763-3.791-.653-5.058a1.762,1.762,0,0,0-1.174-.511c-1.087,0-1.99,1.286-2.174,2.7",
    transform: "translate(-1359.291 -1461.385)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -46.812,
    y1: 9.978,
    x2: -46.778,
    y2: 9.978,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M1284.675,1517.147s4.95,5.211,10.373,4.146l-.164-.167a14.007,14.007,0,0,1-7.212-2.009c-2.8-1.906-2.81-2.589-2.789-2.7Zm.209-.726,0-.016a.076.076,0,0,0,0,.016",
    transform: "translate(-1284.675 -1516.405)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -21.176,
    y1: 9.933,
    x2: -21.159,
    y2: 9.933,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M1301.191,1534.324c.88.917,3.635,2.327,4.519.517-1.361-.219-3.753-.7-5.106-1.866,0,0-.232.5.586,1.348",
    transform: "translate(-1300.574 -1532.976)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -41.626,
    y1: 15.317,
    x2: -41.594,
    y2: 15.317,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M1229.573,1351.817a15.794,15.794,0,0,0-2.817-5.673,39.335,39.335,0,0,1,2.817,5.673m-2.871-5.742.055.069-.049-.083a.15.15,0,0,1-.005.015m-10.525-5.016c-4.078.182-14.309,4.383-18.77,16.021-1.438,6.487,1.412,8.056,1.412,8.056l3.266-1.677s2.455-15.1,13.33-17.476c1.877-.423,6.205.65,8.628.783,2.232.122,2.613-.58,2.659-.691a13.353,13.353,0,0,0-10.107-5.025c-.143,0-.282,0-.418.009",
    transform: "translate(-1197.001 -1341.05)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -6.06,
    y1: 3.7,
    x2: -6.055,
    y2: 3.7,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M1191.586,1342.89c-6.531,9.138-3.661,14.4-3.661,14.4l2.859.522s4.379-14.557,13.283-18.33,14.01-.337,14.987,1.242a11.5,11.5,0,0,0-6.891-6.9,23.762,23.762,0,0,0-2.684-.151,21.328,21.328,0,0,0-17.894,9.213",
    transform: "translate(-1187.297 -1333.677)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -5.905,
    y1: 3.745,
    x2: -5.9,
    y2: 3.745,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M1218.381,1332.52c3.3-3.121,2.386-10.035-1.775-12.727-3.182,4.467-1.468,11.748,1.775,12.727",
    transform: "translate(-1214.915 -1319.793)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -24.966,
    y1: 7.287,
    x2: -24.945,
    y2: 7.287,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M1185.086,1388.848c3.3,3.06,10.1-1.407,8.934-3.426a3.472,3.472,0,0,0-2.443-.636,6.936,6.936,0,0,0-6.491,4.062",
    transform: "translate(-1185.086 -1384.786)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -20.069,
    y1: 11.462,
    x2: -20.052,
    y2: 11.462,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M1175.183,1457.676c-2.094,5.875,4.511,6.6,5.673,6a14.991,14.991,0,0,0,1.419-4.477c-.33-1-2.749-3.544-4.778-3.544-.935,0-1.787.54-2.314,2.018",
    transform: "translate(-1174.776 -1455.658)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -21.683,
    y1: 8.069,
    x2: -21.665,
    y2: 8.069,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M1184.326,1469c-1.236,2.633,2.776,3.607,3.439,3.338-1.977-.625-2.57-2.062-2.232-2.885.451-1.1,2.593-.417,2.593-.417a3.968,3.968,0,0,0-2.281-1.2,1.673,1.673,0,0,0-1.52,1.161",
    transform: "translate(-1184.091 -1467.835)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -39.992,
    y1: 14.144,
    x2: -39.958,
    y2: 14.144,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M1273.562,1723.112c3.117,2.425,16.3,6.268,16.3,6.268l1.834-1.718c-5.1-1.948-15.679-9.805-17.672-10.082a2.623,2.623,0,0,0-.357-.025c-2.29,0-3.076,3.248-.108,5.558",
    transform: "translate(-1271.63 -1717.554)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -10.253,
    y1: 2.092,
    x2: -10.245,
    y2: 2.092,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M1216.135,1725.38c5.424,3.191,14.7,1.129,14.7,1.129a74.348,74.348,0,0,0-3.888-8.383c-3.391.382-10.81,7.253-10.81,7.253",
    transform: "translate(-1216.135 -1718.127)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -14.147,
    y1: 2.359,
    x2: -14.135,
    y2: 2.359,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M1380.705,1758.307c-1.494.688-2.745,1.916-4.353,1.571s-2.766-.232-3.145.508-.805,2.141,1.214,2.738a14.556,14.556,0,0,0,6.234.513c.535.211,1.2-.113,1.038-.569.7.172,1.368-.442.834-.819a.322.322,0,0,1,0-.289s1.241-.154,1.164-.774-1.113-.341-1.113-.341l-.039-.249s1.285-.442,1.125-1.022-1.525-.386-1.525-.386,1.662-1.017,1.341-1.971a.5.5,0,0,0-.512-.38,4.284,4.284,0,0,0-2.267,1.469",
    transform: "translate(-1372.89 -1756.837)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -20.502,
    y1: 2.518,
    x2: -20.487,
    y2: 2.518,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M1144.717,1605.214c7.205,7.09,20.569-2.255,20.569-2.255a3.437,3.437,0,0,0-.434-.7c-4.49-14.674.994-29.626.994-29.626s-1.029-1.872-1.9-3.263a5.27,5.27,0,0,1-5.942-.854c-7.743,9.132-12.483,27.071-13.29,36.694",
    transform: "translate(-1144.717 -1568.52)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -9.263,
    y1: 1.147,
    x2: -9.255,
    y2: 1.147,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M1344.626,1734.191a10.21,10.21,0,0,0-3.652,1.784s-.239,1.981.295,9.7c4.692-1.058,8.633-4.216,11.133-6.4s.544-5.118-.493-6.175a1.624,1.624,0,0,0-1.172-.344c-1.7,0-4.543,1.067-6.111,1.433",
    transform: "translate(-1340.92 -1732.758)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -16.171,
    y1: 1.714,
    x2: -16.159,
    y2: 1.714,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M1159.375,1677.14c-10.351,2.506-13.279.316-13.279.316s-.207,4.515,1.583,7.507c2.042,3.413,20.5,4.764,36.324-2.139a24.013,24.013,0,0,0-2.385-9.993s-9.36,3.9-15.625,3.71c-.1-.712-1.6-15.163-1.731-18.113,0,0-1.161,13.122-4.886,18.712",
    transform: "translate(-1146.088 -1658.428)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -5.136,
    y1: 1.113,
    x2: -5.132,
    y2: 1.113,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M1211.4,1778.709a30.349,30.349,0,0,1-12.093.594,28.421,28.421,0,0,1-5.285-2.087l-.119-.056-.157.332.119.056a28.577,28.577,0,0,0,5.378,2.116,25.046,25.046,0,0,0,4.368.368,34.923,34.923,0,0,0,7.872-.966,91.808,91.808,0,0,0,11.665-3.835l-.13-.344a91.49,91.49,0,0,1-11.618,3.821",
    transform: "translate(-1193.746 -1774.888)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -6.942,
    y1: 2.903,
    x2: -6.936,
    y2: 2.903,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M1159.6,1766.974l-.08.023c-2.766.808-11.146,1.088-12.133.567l-.171.325a10.7,10.7,0,0,0,3.378.32,42.629,42.629,0,0,0,9.029-.859l.079-.023c2.635-.77,5.621-1.642,7.559-3.713l-.268-.251c-1.869,2-4.678,2.818-7.394,3.612",
    transform: "translate(-1147.218 -1763.362)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -9.785,
    y1: 3.488,
    x2: -9.777,
    y2: 3.488,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M1257.007,1769.649c.93.079,1.611,1.17,1.732,2.179a4.043,4.043,0,0,1-.924,3.138l.3.2a4.4,4.4,0,0,0,.984-3.386,2.687,2.687,0,0,0-2.065-2.5Z",
    transform: "translate(-1257.007 -1769.283)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -94.983,
    y1: 2.7,
    x2: -94.908,
    y2: 2.7,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M1314.966,1833.933a5.026,5.026,0,0,1-.459,1.979c-.507,1.262-.123,1.431.29,1.352s.891-1.038.891-1.038,2.33,2.137,3,2.15h.012a.166.166,0,0,0,.121-.045c.4-.41-1.318-1.621-1.018-1.919.142-.142.638.273,1.181.689.6.456,1.251.913,1.561.631.29-.263-1.693-1.711-1.54-1.91a4.3,4.3,0,0,1,1.47.252c.8.194,1.653.388,1.742.207.29-.594-2.494-1.148-2.478-1.407s1.741.085,1.719-.494-3.662-.144-4.7-.925a3.64,3.64,0,0,0-1.795.479",
    transform: "translate(-1314.264 -1833.454)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -26.368,
    y1: 1,
    x2: -26.348,
    y2: 1,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M1266.232,1682.924a14.524,14.524,0,0,0,2.076-1.054c-4.651-6.324-8.881-31.126-8.881-31.126a31.033,31.033,0,0,0-3.84-.272c1.934,16.986,10.645,32.453,10.645,32.453",
    transform: "translate(-1255.587 -1650.471)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -16.876,
    y1: 1.116,
    x2: -16.862,
    y2: 1.116,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M1249.368,1593.517l1.164,5.119a7.116,7.116,0,0,0,4.522-.6c-2.363-6.513-.282-11.016-4.027-17.01-3.952,4.326-1.659,12.488-1.659,12.488",
    transform: "translate(-1248.707 -1581.029)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -26.553,
    y1: 2.647,
    x2: -26.531,
    y2: 2.647,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M1149.508,1600.055a32.278,32.278,0,0,0-3.364,15.052,6.086,6.086,0,0,1,.67-.951s-.117-5.109,4.01-13.53c7.024-14.329,15.954-18.286,15.954-18.286s.083-.079-.814-1.311c-6.136,2.23-11.568,8.7-16.457,19.026",
    transform: "translate(-1146.102 -1581.029)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -9.341,
    y1: 1.411,
    x2: -9.333,
    y2: 1.411,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -14.082,
    y1: 4.174,
    x2: -14.071,
    y2: 4.174,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a4a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#9b5f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb7329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: -3.492,
    y1: 1.795,
    x2: -3.489,
    y2: 1.795,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a66625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a66625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -5.905,
    y1: 3.745,
    x2: -5.9,
    y2: 3.745,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#cc3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#ef3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#ef5153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef5153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -30.944,
    y1: 10.758,
    x2: -30.917,
    y2: 10.758,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa6825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#a76624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#9f6122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#91591f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#84511d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84511d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: -8.984,
    y1: 1.515,
    x2: -8.977,
    y2: 1.515,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: -19.845,
    y1: 1.812,
    x2: -19.829,
    y2: 1.812,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#144d6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#144d6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007d95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: -19.868,
    y1: 2.366,
    x2: -19.854,
    y2: 2.366,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#bb7329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb7329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: -12.747,
    y1: 1.418,
    x2: -12.738,
    y2: 1.418,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: -5.136,
    y1: 1.113,
    x2: -5.132,
    y2: 1.113,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -23.066,
    y1: 0.824,
    x2: -23.048,
    y2: 0.824,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -8.942,
    y1: 1.073,
    x2: -8.935,
    y2: 1.073,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: -5.517,
    y1: 1.959,
    x2: -5.512,
    y2: 1.959,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#006987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#007d95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007d95"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M240.775,1384.8a223.584,223.584,0,0,1,11.462,29.118c2.78,14.688,8.312,20.206,8.943,23.094a10,10,0,0,1-.119,5.023l7.519,1.264-4.133-4.784s-4.418-19.081-6.691-29.751c-2.022-10.8-6.565-29.375-6.565-29.375Z",
    transform: "translate(-240.775 -1379.389)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -0.702,
    y1: 1.23,
    x2: -0.699,
    y2: 1.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M153.638,1426.092c1.4,12.053,4.667,17.574,6.562,27.24-.623,4.145-1.627,4.271-1.627,4.271l5.023.245-1.011-5.147s-2.025-12.931-2.668-25.989c-.776-18.709-.788-29.257-.788-29.257l-10.172-.992s1.777,15.694,4.682,29.628",
    transform: "translate(-148.956 -1396.464)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -1.114,
    y1: 1.283,
    x2: -1.105,
    y2: 1.283,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M87.06,1179.46c.26,7.031,2.868,18.12,3.961,22.556a30.256,30.256,0,0,0,.845,6.864l1.341,1.84c.671.92,2.3,1.421,2.052.877a6.341,6.341,0,0,1-2.054-2.635c-.169-1-.087-2.6.332-2.679.42,1.255,1.676,1.672,2.01,1.17,0,0-.335-.167-1.174-1.673-.839-1.924-1.845-2.76-2.433-4.182a194.137,194.137,0,0,0-.609-19.5c-.005-4.269,3.242-19.216,3.242-19.216s-.006-4.855-2.268-6.527c-2.755,6.282-5.5,19.177-5.246,23.111",
    transform: "translate(-87.043 -1156.349)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 0.161,
    y1: 4.419,
    x2: 0.164,
    y2: 4.419,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M289.193,1191.707s1.6,5.481,4.033,12.426c-.163,3.935-2.2,11.555-2.2,11.555l-2.091,1.928,2.431,3.01.082-1.674c1.922-2.43,4.762-8.377,5.758-14.991-.842-4.352-3.784-14.31-3.784-14.31Z",
    transform: "translate(-288.931 -1189.651)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: -1.17,
    y1: 6.558,
    x2: -1.165,
    y2: 6.558,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M158.224,1015.8l-.052,8.853s-5.272,1.764-6.652,2.394c2.452,3.073,4.713,3.7,8.982,3.693s9.351-3.339,9.351-3.339-4.02-1.627-6.784-2.629c-.823-5.336-1.393-9.542-1.393-9.542Z",
    transform: "translate(-151.52 -1015.231)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -1.259,
    y1: 6.764,
    x2: -1.251,
    y2: 6.764,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M47.82,921.022c-1.118,1.351-.131,3.014.7,3.75,1.8,1.591,5.436,1.42,5.436,1.42s-4.669-1.481-4.511-3.378c.19-2.273,3.84.108,3.84.108l.106-.582s-2.158-2.053-4-2.053a1.947,1.947,0,0,0-1.569.735",
    transform: "translate(-47.319 -920.286)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -0.871,
    y1: 18.396,
    x2: -0.85,
    y2: 18.396,
    xlinkHref: "#linear-gradient-53"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M93.8,767.759c-15.664,2.8-16.134,26.627-16.134,26.627a44.624,44.624,0,0,0,1.29,7.314c1.951,7,13.956,11.3,23.4,10.34,10.451-5.24,14.289-10.9,14.909-13.614s.085-6.883-4.068-11.758c-1.687-4.469-1.3-8.541-4.735-13.483A15.529,15.529,0,0,0,96.643,767.5a16.124,16.124,0,0,0-2.84.257",
    transform: "translate(-77.669 -767.502)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: -0.278,
    y1: 3.935,
    x2: -0.274,
    y2: 3.935,
    xlinkHref: "#linear-gradient-51"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M244.541,918.358c-2.169.231-4.738,1.1-4.889,1.989a1.269,1.269,0,0,0,.108.729,2.378,2.378,0,0,0,.745.893c1.438,1.109,3.5,1.194,5.251,1.175a8.228,8.228,0,0,0,4.569-1.03,1.683,1.683,0,0,0,.783-1.48,1.7,1.7,0,0,0-.742-1.232,7.5,7.5,0,0,0-4.358-1.122,13.909,13.909,0,0,0-1.468.079",
    transform: "translate(-239.636 -918.279)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-256"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2305",
    "data-name": "Rectangle 2305",
    width: 11.534,
    height: 4.883,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M115.754,942.629c-2.41.611-5.167,2.007-5.195,3.033a1.446,1.446,0,0,0,.239.805,2.712,2.712,0,0,0,.985.887c1.8,1.02,4.143.782,6.115.479,2.552-.393,4.152-1.1,4.988-1.9a1.919,1.919,0,0,0,.645-1.8,1.941,1.941,0,0,0-1.035-1.27,6.94,6.94,0,0,0-3.276-.7,14.464,14.464,0,0,0-3.465.462",
    transform: "translate(-110.558 -942.167)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-258"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2307",
    "data-name": "Rectangle 2307",
    width: 13.109,
    height: 6.207,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M1581.205,1495.879l-2.309,17.252-2.812,10.185s3.159,15.735,4.9,22.054a6.167,6.167,0,0,0,.156,2.974h7.569s.625-2.969-2.014-4.011a3.139,3.139,0,0,1-1.6-1.416s-1.111-9.11-.208-14.249c1.944,2.014,3.194,3.327,5.485,3.852a12.209,12.209,0,0,0,5.626-2.958c.9,5.138-1.458,13.331-1.458,13.331a3.132,3.132,0,0,1-1.6,1.441c-2.639,1.042-2.014,4.01-2.014,4.01h7.569a6.364,6.364,0,0,0,.156-3c1.736-6.319,3.209-22.5,3.209-22.5l-3.111-9.738-2.492-16.944a26.963,26.963,0,0,0-8.725-1.608,14.148,14.148,0,0,0-6.328,1.331",
    transform: "translate(-1576.084 -1494.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: -10.454,
    y1: 1.169,
    x2: -10.447,
    y2: 1.169,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#854e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#854e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#703d15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#703d15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M1592.461,1430.452s-3.195,4.305-2.431,11.6a9.914,9.914,0,0,0,2.153.833s2.153,5,3.958,6.667a7.564,7.564,0,0,0,6.667-1.528c1.528,1.111,6.111.9,6.8-.139.486-1.111,1.528-6.25,1.528-6.25l1.458-1.805s1.042-6.6-3.958-11.25a12.543,12.543,0,0,0-7.256-2.06,11.06,11.06,0,0,0-8.924,3.935",
    transform: "translate(-1589.912 -1426.517)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: -8.204,
    y1: 2.41,
    x2: -8.199,
    y2: 2.41,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#854e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#854e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#6b3e1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3e1d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M1645.026,1543.9s1.079,2.126.624,9.534c-.239,3.878,3.4,1.909,3.4,1.909s2.626,1.85,2.864-1.552c.2-2.887-.794-7.5-3.208-10.031a18.287,18.287,0,0,1-3.681.139",
    transform: "translate(-1645.026 -1543.757)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: -32.273,
    y1: 3.831,
    x2: -32.254,
    y2: 3.831,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c34c4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#c34c4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#cf5153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf5153"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1652",
    "data-name": "Group 1652",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M964.357,658.693s28.721-15.033,32.313-23.081c9.745-9.232,17.607-15.828,20.564-20.619C1003.87,601.882,996.2,599.38,996.2,599.38s-4.913,4.688-13.632,22.64c-8.976,7.95-19.747,34.878-19.747,34.878Z",
    transform: "translate(-798.198 -496.899)",
    fill: "#b97529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M1118.269,497.829l-22.3-12.473s9.728-23.964,35.353-40.81c3.794,7.514,5.8,27.014,5.893,39.221-4.988,1.847-13.972,10.972-18.946,14.062",
    transform: "translate(-908.583 -368.538)",
    fill: "#ef5153"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103",
    transform: "translate(187.721 76.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(1.703 -7.018)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M1153.634,449.96h.054q.808-1.129,1.678-2.205c-12.692-19.937-42.442-44.25-42.442-44.25l-5.037,4.167c22.938,15.294,45.746,42.289,45.746,42.289",
    transform: "translate(-1107.888 -403.503)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059",
    transform: "translate(-30.769 20.132)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M981.222,612.654l.054,0c.49-.785.779-1,1.311-1.753-35.754-36.261-59.852-48.609-59.852-48.609l-4.765,4.474c23.852,13.826,63.252,45.891,63.252,45.891",
    transform: "translate(-917.97 -562.289)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062",
    transform: "translate(27.07 -30.914)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M1300.843,311.267h.054q.838-1.107,1.736-2.16c-12.153-20.27-41.239-45.374-41.239-45.374l-5.147,4.03c22.52,15.9,44.595,43.5,44.595,43.5",
    transform: "translate(-1256.248 -263.736)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065",
    transform: "translate(-16.28 8.008)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M1058.616,538.2s-26.943-28.348-55.907-42.413l4.272-4.411a306.633,306.633,0,0,1,55.543,41.827,7.081,7.081,0,0,1-3.907,5",
    transform: "translate(-1002.709 -491.376)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068",
    transform: "translate(9.471 -20.604)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M1205.13,375.375s-24.248-30.685-51.811-47.33l4.656-4a306.626,306.626,0,0,1,51.5,46.713,7.081,7.081,0,0,1-4.347,4.62",
    transform: "translate(-1153.319 -324.041)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071",
    transform: "translate(11.552 -7.278)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M1171.674,484.766s9.078-24.779,54.328-78.561a18.3,18.3,0,0,0-2.121-4.23s-53.934,63.711-58.387,81.468c5.227,1.022,6.18,1.322,6.18,1.322",
    transform: "translate(-1165.493 -401.977)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074",
    transform: "translate(-9.385 -19.463)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M1049.217,419.86s32.337-51.522,67.017-84.922a18.3,18.3,0,0,0-2.12-4.23s-66.623,70.072-71.077,87.83c5.227,1.022,6.18,1.322,6.18,1.322",
    transform: "translate(-1043.037 -330.708)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(-30.924 -29.069)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M923.038,355.153s38.346-47.221,76.819-76.17a18.3,18.3,0,0,0-1.592-4.455s-74.627,61.478-81.2,78.564c5.065,1.648,5.974,2.062,5.974,2.062",
    transform: "translate(-917.064 -274.528)",
    fill: "#a2d9ff"
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(2.055 -10.545)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M1112.151,465.823s22.1-39.831,63.279-81.7l-.651-1.253s-36.562,34.22-64.832,83.308c.176,1.1,2.205-.351,2.205-.351",
    transform: "translate(-1109.947 -382.867)",
    fill: "#eaeceb"
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083",
    transform: "translate(-31.557 -33.174)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M915.59,319.073s29.71-34.53,78.513-67.2l-.384-1.359s-42.734,26.107-80.359,68.453c-.051,1.115,2.23.1,2.23.1",
    transform: "translate(-913.359 -250.518)",
    fill: "#eaeceb"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086",
    transform: "translate(-21.166 -24.328)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M976.355,391.164s31.464-47.818,74.646-87.62l-.589-1.283s-45.631,41.5-76.276,89.146c.121,1.11,2.22-.242,2.22-.242",
    transform: "translate(-974.135 -302.261)",
    fill: "#eaeceb"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089",
    transform: "translate(-5.601 1.953)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M1115.366,498.742s-27.579-28.654-50.2-40.925l1.786-1.845s12.537,3.905,49.774,41.524a5.787,5.787,0,0,0-1.362,1.246",
    transform: "translate(-1065.168 -455.972)",
    fill: "#eaeceb"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092",
    transform: "translate(-29.496 33.365)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M975.613,682.459s-27.579-28.654-50.2-40.925l1.786-1.845s12.537,3.905,49.774,41.524a5.789,5.789,0,0,0-1.362,1.246",
    transform: "translate(-925.414 -639.689)",
    fill: "#eaeceb"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(-22.71 13.359)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M1025.61,573.107S987.723,536.8,965.1,524.53l1.787-1.845s22.845,11.557,60.082,49.176a5.787,5.787,0,0,0-1.362,1.246",
    transform: "translate(-965.103 -522.684)",
    fill: "#eaeceb"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098",
    transform: "translate(7.915 -12.699)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M1190.6,416.694s-25.307-30.881-46.38-45.65c.59-.764,1.064-.772,1.064-.772s16.029,9.929,46.2,45.45a1.667,1.667,0,0,0-.889.972",
    transform: "translate(-1144.218 -370.272)",
    fill: "#eaeceb"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101",
    transform: "translate(18.302 -24.895)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M1253.74,343.348s-26.581-29.583-48.766-42.623l1.849-1.782s12.4,4.333,48.321,43.207a5.78,5.78,0,0,0-1.4,1.2",
    transform: "translate(-1204.973 -298.942)",
    fill: "#eaeceb"
  }))))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M1098.256,667.46l-7.716,4.423s-16.108-10.763-25.809-13.2a51.041,51.041,0,0,0,5.687-8.293s20.05,2.9,27.838,17.069",
    transform: "translate(-882.686 -539.188)",
    fill: "#6b3f4c"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107",
    transform: "translate(296.964 100.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2078",
    "data-name": "Rectangle 2078",
    width: 71.653,
    height: 77.834,
    transform: "translate(-28.678 17.858) rotate(-31.911)",
    fill: "url(#linear-gradient)"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M1643.169,490.609l24.028-9.594s-13.169-22.26-41.006-35.126c-2.64,7.993-1.736,27.576-.021,39.661a92.827,92.827,0,0,1,17,5.059",
    transform: "translate(-1346.772 -369.652)",
    fill: "#ef5153"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159",
    transform: "translate(277.427 76.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112",
    transform: "translate(-6.503 -11.177)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M1586.6,432.783l-.054.008q-.966-1-1.986-1.933c9.6-21.6,35.422-50.047,35.422-50.047l5.6,3.375c-20.421,18.522-38.98,48.6-38.98,48.6",
    transform: "translate(-1584.56 -380.812)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115",
    transform: "translate(13.325 10.825)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M1702.14,567.962l-.054,0c-.6-.7-.918-.873-1.556-1.54,29.991-41.155,52-56.935,52-56.935l5.375,3.719c-21.542,17.205-55.76,54.751-55.76,54.751",
    transform: "translate(-1700.529 -509.492)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118",
    transform: "translate(-33.881 -31.037)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M1426.524,317.495l-.054.009q-.992-.97-2.036-1.879c9.017-21.846,34.066-50.979,34.066-50.979l5.687,3.224c-19.917,19.064-37.662,49.625-37.662,49.625",
    transform: "translate(-1424.433 -264.647)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121",
    transform: "translate(0.947 0.906)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M1632.737,505.432s22.449-32.025,49.011-50.223l-4.878-3.73a306.627,306.627,0,0,0-48.737,49.589,7.08,7.08,0,0,0,4.6,4.364",
    transform: "translate(-1628.133 -451.479)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124",
    transform: "translate(-24.414 -23.52)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M1484.779,366.373s19.437-33.937,44.232-54.48l-5.2-3.27a306.619,306.619,0,0,0-44.017,53.824,7.08,7.08,0,0,0,4.982,3.926",
    transform: "translate(-1479.797 -308.623)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127",
    transform: "translate(-35.094 -2.077)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M1482.7,508.178s-12.647-23.162-65.361-69.651a18.3,18.3,0,0,1,1.471-4.5s62.773,55.023,69.806,71.925c-5.019,1.784-5.916,2.223-5.916,2.223",
    transform: "translate(-1417.339 -434.03)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130",
    transform: "translate(-28.74 -15.348)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M1533.348,434.966S1493.738,388.8,1454.5,360.9a18.3,18.3,0,0,1,1.471-4.5s76.264,59.435,83.3,76.337c-5.018,1.784-5.916,2.223-5.916,2.223",
    transform: "translate(-1454.496 -356.407)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    transform: "translate(-18.319 -26.539)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M1602.7,359.558s-44.915-41.023-87.251-63.956a18.314,18.314,0,0,1,.915-4.642s82.907,49.75,91.938,65.675c-4.765,2.38-5.6,2.924-5.6,2.924",
    transform: "translate(-1515.452 -290.959)",
    fill: "#a2d9ff"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136",
    transform: "translate(-31.548 -5.76)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M1512.762,485.258s-27.756-36.119-74.679-71.434l.459-1.335s41.226,28.429,76.453,72.79c-.01,1.117-2.233-.021-2.233-.021",
    transform: "translate(-1438.083 -412.488)",
    fill: "#eaeceb"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139",
    transform: "translate(-16.732 -30.817)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M1612.325,322.17s-34.5-29.751-87.6-54.832l.179-1.4s46.128,19.492,89.609,55.8c.216,1.1-2.191.432-2.191.432",
    transform: "translate(-1524.728 -265.938)",
    fill: "#eaeceb"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142",
    transform: "translate(-21.875 -21.134)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M1581.45,399.531s-38.2-42.632-86.8-75.6l.393-1.357s51.273,34.29,88.635,76.869c.044,1.116-2.231.089-2.231.089",
    transform: "translate(-1494.653 -322.573)",
    fill: "#eaeceb"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(-2.393 -3.867)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M1610.134,473.03s23.033-32.422,43.586-47.907l-2.04-1.56S1639.86,429.282,1608.6,472a5.786,5.786,0,0,1,1.531,1.03",
    transform: "translate(-1608.603 -423.562)",
    fill: "#eaeceb"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148",
    transform: "translate(25.891 23.66)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M1775.55,634.029s23.033-32.422,43.586-47.907l-2.04-1.56s-11.821,5.719-43.077,48.436a5.789,5.789,0,0,1,1.531,1.03",
    transform: "translate(-1774.019 -584.561)",
    fill: "#eaeceb"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(7.157 4.88)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M1665.978,533.284s32.094-41.515,52.647-57l-2.04-1.56s-20.882,14.812-52.138,57.53a5.789,5.789,0,0,1,1.531,1.03",
    transform: "translate(-1664.448 -474.723)",
    fill: "#eaeceb"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154",
    transform: "translate(-13.103 -16.465)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M1546.982,402.5s20.455-34.288,39.11-52.014c-.7-.669-1.167-.606-1.167-.606s-14.382,12.193-38.966,51.79a1.667,1.667,0,0,1,1.023.83",
    transform: "translate(-1545.959 -349.876)",
    fill: "#eaeceb"
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157",
    transform: "translate(-28.383 -26.871)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M1458.157,339.881s21.907-33.193,41.917-49.373l-2.092-1.489s-11.618,6.121-41.391,49.885a5.789,5.789,0,0,1,1.566.977",
    transform: "translate(-1456.591 -289.019)",
    fill: "#eaeceb"
  }))))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M1700.52,631.927l7.249,5.152s14.656-8.111,25.2-9.295c-1.3-7.254-3.078-10.138-3.078-10.138s-20.237.939-29.366,14.28",
    transform: "translate(-1409.769 -512.043)",
    fill: "#6b3f4c"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(229.303 168.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2097",
    "data-name": "Rectangle 2097",
    width: 59.121,
    height: 132.04,
    transform: "matrix(0.995, -0.103, 0.103, 0.995, -13.27, 1.356)",
    fill: "url(#linear-gradient-2)"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M1342.227,987.415s-2.059,40.5,2.274,79.558c4.108,36.759,5.564,42.386,5.564,42.386l5.332,1.6c-.377-10.2.765-64.273,10.312-95.3,3.5,24.763,16.963,75.775,19.036,92.626,7.646.1,8.162-.4,8.433-1.674-.876-10.972-4.08-58.4-5.1-78.019s-.419-45.923-.419-45.923Z",
    transform: "translate(-1112.331 -814.653)",
    fill: "#824d62"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167",
    transform: "translate(239.811 47.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2099",
    "data-name": "Rectangle 2099",
    width: 25.832,
    height: 46.498,
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M1301.168,381.119s13.307,6.433,21.848,14.974c-2.348,18.944-12.139,87.12-12.139,87.12s-3.2,2.826-9.963,3.751c-11.06,1.513-27.363,2.162-35.345-3.479-1.461-12.6-16.361-86.117-16.361-86.117l3.053-2.652s13.777-11.742,24.58-15.343c3.131,13.777,5.01,18.317,5.01,18.317l7.476,5.9a36.256,36.256,0,0,0,6.907-7.4,26.733,26.733,0,0,0,4.934-15.076",
    transform: "translate(-1035.621 -314.509)",
    fill: "#ef5153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M1345.809,151.548s-.885-3.755-4.658-3.368c-2.378.244-2.414,3.581-1.253,6.623.882,2.31,1.2,5.487,1.827,7.707.519,1.83,3.286,4.016,4.935.069a98.269,98.269,0,0,0-.852-11.031",
    transform: "translate(-1110.188 -122.821)",
    fill: "#b87329"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171",
    transform: "translate(231.439 28.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2101",
    "data-name": "Rectangle 2101",
    width: 6.819,
    height: 12.071,
    transform: "matrix(0.996, -0.089, 0.089, 0.996, -1.257, 0.091)",
    fill: "url(#linear-gradient-4)"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M1562.389,146.768s.884-3.755,4.657-3.368c2.378.244,2.414,3.581,1.253,6.623-.882,2.31-1.2,5.487-1.827,7.707-.519,1.83-3.286,4.016-4.936.069a98.241,98.241,0,0,1,.852-11.031",
    transform: "translate(-1294.549 -118.859)",
    fill: "#b87329"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(266.441 27.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2103",
    "data-name": "Rectangle 2103",
    width: 12.071,
    height: 6.819,
    transform: "matrix(0.089, -0.996, 0.996, 0.089, -1.023, 11.511)",
    fill: "url(#linear-gradient-5)"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(233.829 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2104",
    "data-name": "Rectangle 2104",
    width: 63.691,
    height: 37.026,
    transform: "translate(-0.546 63.469) rotate(-89.655)",
    fill: "url(#linear-gradient-6)"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M1454.171,151.082l-.817,8.729-2.763.866s-.122,4.609,5.3,4.966c3.8-.183,2.394-7.843,2.052-12.086-.273-3.4-3.771-2.475-3.771-2.475",
    transform: "translate(-1202.571 -125.155)",
    fill: "#9b5a16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M1458.838,317l8.33-.052-3.524,3.365Z",
    transform: "translate(-1209.409 -262.76)",
    fill: "#5e3815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M1423.253,251.128s1.824,11.83,10.733,11.826c6.042-.334,8.664-10.619,8.957-12.935-2.494.768-12.35,2.259-19.689,1.109",
    transform: "translate(-1179.909 -207.271)",
    fill: "#7a4a1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M1428.808,256.614s2.855,8.36,9.119,8.184c5.426-.153,7.1-5.988,8.489-9.077-2.211,1.248-13,2.677-17.608.893",
    transform: "translate(-1184.514 -211.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M1514.013,116.58c-1.15-1.821-6.036-4.887-11.4-2.779l.671,3.641s6.228-2.108,10.444.479c0,0,.281-1.173.287-1.342",
    transform: "translate(-1245.698 -93.753)",
    fill: "#381511"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M1379.157,117.539c1.15-1.821,6.543-5.618,12.794-3.5l-.406,3.672s-7.885-1.419-12.1,1.168c0,0-.281-1.173-.288-1.341",
    transform: "translate(-1143.352 -94.024)",
    fill: "#381511"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M1437.426,272.243s2.812,2.455,8.224,2.038a10.317,10.317,0,0,0,6.545-2.839s-1.705,3.559-7.379,3.794a8.736,8.736,0,0,1-7.39-2.993",
    transform: "translate(-1191.658 -225.031)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M1406.888,193.81c-.137-1.436-.256-3.233-.348-4.824l-4.043,10.063a49.778,49.778,0,0,0-11.793-.914,74.947,74.947,0,0,0-13.09,1.774l-6.239-10.562.727,9.922s7.885,14.761,12.527,19.075c5.248,1.8,10.378.617,12.03-.54.668-.821,2.243-3.57,6.161-10.889s4.391-9.728,4.068-13.1m-16.37,21.853a19.689,19.689,0,0,1-6.623-1.426,84.014,84.014,0,0,1-5.188-12.864c9.009,1.453,16.65,1.147,22.133-1.237a105.522,105.522,0,0,1-3.38,13.375,12.536,12.536,0,0,1-6.942,2.152",
    transform: "translate(-1136.901 -156.673)",
    fill: "#5e3815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M1515.1,160.946s-2.777,3.384-6.413,3.349-3.953-2.423-3.953-2.423l.743-3.091s5.742-1.338,9.623,2.165",
    transform: "translate(-1247.46 -131.425)",
    fill: "#f6f4f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M1515.079,158.482s-5.328-3.048-9.477-1.741a15,15,0,0,0-.889,2.666,8.75,8.75,0,0,1,.562-3.434c3.9-1.16,8.156.246,9.8,2.509",
    transform: "translate(-1247.437 -128.961)",
    fill: "#412128"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(257.276 27.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M1512.32,158.178a3.087,3.087,0,1,0,2.811-3.741,3.327,3.327,0,0,0-2.811,3.741",
    transform: "translate(-1511.016 -155.043)",
    fill: "#412128"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M1388.859,160.741s2.777,3.384,6.413,3.349,3.952-2.424,3.952-2.424l-.743-3.09a10.638,10.638,0,0,0-9.623,2.165",
    transform: "translate(-1151.395 -131.165)",
    fill: "#f6f4f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M1388.859,158.537s4.882-3.208,9.477-1.741a14.967,14.967,0,0,1,.889,2.666,8.747,8.747,0,0,0-.562-3.434,9.146,9.146,0,0,0-9.8,2.509",
    transform: "translate(-1151.395 -128.961)",
    fill: "#412128"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185",
    transform: "translate(237.464 26.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M1412.274,158.5a3.087,3.087,0,1,1-2.811-3.741,3.328,3.328,0,0,1,2.811,3.741",
    transform: "translate(-1403.212 -155.256)",
    fill: "#412128"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235",
    transform: "translate(213.587 64.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    transform: "translate(6.655 60.202)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M1288.167,731.478l-.04.037c.115.918.2,1.838.263,2.758,22.848,6.044,66.025,3.993,66.025,3.993s-.533.152.342-6.326c-16.243,5.3-66.59-.463-66.59-.463",
    transform: "translate(-1288.127 -731.478)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(-0.477 21.51)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M1246.462,506.875l-.04.036c.1.92.023,2.48.069,3.4,50.508,6.5,78.992-1.539,78.992-1.539a10.364,10.364,0,0,0-.855-3.591c-34.025,6.326-78.165,1.692-78.165,1.692",
    transform: "translate(-1246.422 -505.182)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(8.163 96.532)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M1296.992,944.275l-.04.037c.12.917.211,1.836.279,2.757,22.883,5.909,61.221,3.375,61.221,3.375l.837-6.483c-27.2,4.477-62.3.314-62.3.314",
    transform: "translate(-1296.952 -943.961)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    transform: "translate(3.223 40.181)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M1268.832,617.829s42.979,1.974,70.132-3.446l-.643,6.107a307.145,307.145,0,0,1-69.552,1.322c-1.625-3.763.063-3.983.063-3.983",
    transform: "translate(-1268.063 -614.382)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    transform: "translate(3.905 74.293)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M1273.07,813.885s38.011,9.2,69.974,5.308l-1.2,6.023a306.625,306.625,0,0,1-69.35-5.014,7.081,7.081,0,0,1,.573-6.318",
    transform: "translate(-1272.049 -813.886)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203",
    transform: "translate(10.928 4.156)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M1313.12,406.448s8.8,29,6.344,99.237a18.3,18.3,0,0,0,4.278,2.022s2.5-87.3-4.942-104.029c-4.745,2.419-5.68,2.77-5.68,2.77",
    transform: "translate(-1313.12 -403.678)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206",
    transform: "translate(31.279 -0.281)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M1432.54,380.5s6.317,60.5-.387,108.18a18.3,18.3,0,0,0,4.278,2.022s9.234-96.247,1.79-112.972c-4.745,2.419-5.68,2.77-5.68,2.77",
    transform: "translate(-1432.152 -377.727)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    "data-name": "Group 1209",
    transform: "translate(46.465 1.292)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    "data-name": "Group 1208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    "data-name": "Group 1207",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M1534.469,388.988s-1.066,60.82-13.5,107.335a18.3,18.3,0,0,0,4,2.526s20.835-94.418,15.473-111.922c-5,1.826-5.974,2.061-5.974,2.061",
    transform: "translate(-1520.969 -386.927)",
    fill: "#a2d9ff"
  }))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    "data-name": "Group 1212",
    transform: "translate(23.635 -1.775)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1210",
    "data-name": "Group 1210",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M1387.436,370.774s7.64,49.924,1.048,108.28l1.286.584s7.2-54.424-.814-110.5c-.818-.76-1.519,1.636-1.519,1.636",
    transform: "translate(-1387.437 -368.989)",
    fill: "#eaeceb"
  }))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215",
    transform: "translate(53.017 11.872)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    "data-name": "Group 1214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1213",
    "data-name": "Group 1213",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M1579.659,450.325s-2.094,45.5-20.367,101.316l1.141.833s17.541-46.9,21.046-103.443c-.647-.91-1.819,1.295-1.819,1.295",
    transform: "translate(-1559.292 -448.81)",
    fill: "#eaeceb"
  }))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218",
    transform: "translate(42.481 -4.92)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M1502.4,352.327s4.719,57.047-4.729,115.009l1.255.647s10.327-60.812,5.071-117.215c-.78-.8-1.6,1.56-1.6,1.56",
    transform: "translate(-1497.67 -350.602)",
    fill: "#eaeceb"
  }))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221",
    transform: "translate(5.104 51.841)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1219",
    "data-name": "Group 1219",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M1279.367,682.575s43.023,5.24,68.045.446c-.23,2.67-.22,2.559-.22,2.559s-15.5,4.469-68.131-1.182a6.261,6.261,0,0,0,.306-1.823",
    transform: "translate(-1279.061 -682.576)",
    fill: "#eaeceb"
  }))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    "data-name": "Group 1224",
    transform: "translate(1.076 12.106)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1223",
    "data-name": "Group 1223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    "data-name": "Group 1222",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M1255.813,450.177s46.767,5.59,72.2,1.307l-.269,2.554s-19.732,4.609-72.244-2.041a5.9,5.9,0,0,0,.313-1.819",
    transform: "translate(-1255.5 -450.177)",
    fill: "#eaeceb"
  }))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227",
    transform: "translate(0.076 32.89)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1226",
    "data-name": "Group 1226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1225",
    "data-name": "Group 1225",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M1249.9,572.4s52.288,4.139,77.627-.666c-.226,2.67-.216,2.559-.216,2.559s-25.021,5.5-77.659-.065a5.574,5.574,0,0,0,.248-1.828",
    transform: "translate(-1249.648 -571.739)",
    fill: "#eaeceb"
  }))))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230",
    transform: "translate(7.195 68.799)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M1291.33,781.765s39.323,6.912,64.93,4.369c.051.964-.3,1.279-.3,1.279s-18.627,2.923-64.667-4.332a1.667,1.667,0,0,0,.04-1.317",
    transform: "translate(-1291.29 -781.764)",
    fill: "#eaeceb"
  }))))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233",
    transform: "translate(6.809 88.591)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M1289.3,897.518s39.479,4.8,64.767.033c-.23,2.67-.221,2.558-.221,2.558s-12.187,4.889-64.816-.765a5.791,5.791,0,0,0,.269-1.826",
    transform: "translate(-1289.031 -897.518)",
    fill: "#eaeceb"
  }))))))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    "data-name": "Group 1236",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M1365.941,990.936a88.828,88.828,0,0,1-11.036-.67c-3.436-.431-7.764-1.356-11.2-3.68l.213-.315c3.369,2.279,7.643,3.192,11.034,3.617,11.354,1.425,28.538.635,34.294-4.039v.741c-6.269,3.59-15.07,4.345-23.306,4.345",
    transform: "translate(-1113.962 -817.292)",
    fill: "#c26646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M1562.405,1021.265c-3.739-2.285-5.937-6.6-6.358-12.493l.378-.027c.412,5.761,2.548,9.979,6.177,12.2Z",
    transform: "translate(-1289.998 -836.271)",
    fill: "#c26646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M1355.115,1026.334l-.26-.277a59.729,59.729,0,0,0,10.455-14.332l.337.174a60.144,60.144,0,0,1-10.532,14.434",
    transform: "translate(-1123.205 -838.742)",
    fill: "#c26646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M1469.423,1031.447l-1.27-.79,1.339-15.975.378.032-1.32,15.743,1.073.667Z",
    transform: "translate(-1217.131 -841.195)",
    fill: "#c26646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M1495.461,357.355l.822.082s6.344,11.428,8.278,17.652c-4.276-2.028-6.439-2.918-6.439-2.918l-.852,4.353h-4.227a99.248,99.248,0,0,1-9.671,8.872,43.649,43.649,0,0,0,12.088-28.041",
    transform: "translate(-1229.749 -296.255)",
    fill: "#6b3f4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M1366.431,356.874l-1.234.74s-6.051,12.381-7.51,17.076c4.276-2.028,6.439-2.918,6.439-2.918l.851,4.353h4.227a99.266,99.266,0,0,0,9.671,8.872,45.38,45.38,0,0,1-12.444-28.123",
    transform: "translate(-1125.553 -295.856)",
    fill: "#6b3f4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M1343.7,1719.682s-6.926,3.351-10.412,6.746a18.012,18.012,0,0,0,12.487-4.616l1.71.787.236-3.438Z",
    transform: "translate(-1105.323 -1425.223)",
    fill: "#501410"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M1597.144,1707.923l.44,2.87,2.234-.448s7.9,4.24,13.334,2.4c-5.07-1.657-10.1-6.337-10.1-6.337a28.98,28.98,0,0,0-5.907,1.514",
    transform: "translate(-1324.068 -1414.651)",
    fill: "#501410"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239",
    transform: "translate(253.377 201.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2124",
    "data-name": "Rectangle 2124",
    width: 36.626,
    height: 94.761,
    transform: "matrix(0.995, -0.103, 0.103, 0.995, -9.464, 0.979)",
    fill: "url(#linear-gradient-7)"
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M0,1732.139H405.1s-57.012,9.683-198.849,9.683C8.566,1741.822,0,1732.139,0,1732.139",
    transform: "translate(0 -1435.982)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M831.247,1213.78a.373.373,0,0,0,.309-.088c.277-.347-.405-1.235-1.987-3.03a7.547,7.547,0,0,1-1.452-2.815,6.42,6.42,0,0,0-.856-2.913c-.72,0,.072,6.536.718,7.516,1.659,2.515,3.641,3.127,3.919,2.78.179-.224-.045-.676-.651-1.451",
    transform: "translate(-685.581 -998.917)",
    fill: "#80501c"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243",
    transform: "translate(137.212 156.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    "data-name": "Group 1242",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2126",
    "data-name": "Rectangle 2126",
    width: 46.672,
    height: 60.269,
    transform: "translate(-30.401 18.361) rotate(-33.024)",
    fill: "url(#linear-gradient-8)"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M1202.578,1213.78a.373.373,0,0,1-.309-.088c-.277-.347.405-1.235,1.987-3.03a7.547,7.547,0,0,0,1.452-2.815,6.42,6.42,0,0,1,.856-2.913c.72,0-.072,6.536-.718,7.516-1.659,2.515-3.642,3.127-3.919,2.78-.179-.224.045-.676.651-1.451",
    transform: "translate(-996.375 -998.917)",
    fill: "#80501c"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1247",
    "data-name": "Group 1247",
    transform: "translate(201.328 156.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2128",
    "data-name": "Rectangle 2128",
    width: 60.269,
    height: 46.672,
    transform: "matrix(0.545, -0.838, 0.838, 0.545, -28.247, 43.457)",
    fill: "url(#linear-gradient-9)"
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M1055.56,1709.392l.241,3.608c2.165,1.5,9.321,2.706,11.546.722-1.624-1.323-3.909-1.323-8.96-4.089a6.855,6.855,0,0,1-2.826-.24",
    transform: "translate(-875.083 -1417.124)",
    fill: "#ea6753"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1251",
    "data-name": "Group 1251",
    transform: "translate(177.921 243.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2130",
    "data-name": "Rectangle 2130",
    width: 19.434,
    height: 52.419,
    transform: "translate(-2.811 0.121) rotate(-2.77)",
    fill: "url(#linear-gradient-10)"
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1253",
    "data-name": "Group 1253",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1252",
    "data-name": "Group 1252",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M941.616,1709.392l-.241,3.608c-2.165,1.5-9.321,2.706-11.546.722,1.624-1.323,3.908-1.323,8.96-4.089a6.854,6.854,0,0,0,2.826-.24",
    transform: "translate(-770.85 -1417.124)",
    fill: "#ea6753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M918.474,1422.088h0Z",
    transform: "translate(-761.435 -1178.943)",
    fill: "#ab754c"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    "data-name": "Group 1255",
    transform: "translate(157.038 243.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1254",
    "data-name": "Group 1254",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2132",
    "data-name": "Rectangle 2132",
    width: 20.727,
    height: 53.133,
    transform: "matrix(0.999, -0.048, 0.048, 0.999, -2.525, 0.122)",
    fill: "url(#linear-gradient-11)"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1257",
    "data-name": "Group 1257",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M861.407,1013.393c-.361,9.922-2.706,32.651,8.3,64.4,9.2,1.263,31.749,3.427,40.408-1.082,3.428-24.533,11.545-43.294,1.8-80.455-44.016-1.984-46.542-2.526-46.542-2.526a72.555,72.555,0,0,0-3.969,19.663",
    transform: "translate(-713.749 -823.824)",
    fill: "#a6585a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M915.231,687.708c-2.706-22.363-3.908-30.966-9.32-38.182a20.477,20.477,0,0,0-11.375-6.772,6.037,6.037,0,0,1-.628,1.411,3.145,3.145,0,0,1-3.141,1.467,6.384,6.384,0,0,1-3.859-1.205,4.634,4.634,0,0,1-1.3-1.907c-4.591.893-12.748,5.487-14.117,6.857-8.719,8.719-12.333,38.2-11.281,84.046,0,0,7.236,5.471,24.791,7.352,17.536,1.879,28.268-4.787,30.662-6.611a233.677,233.677,0,0,0-.428-46.455",
    transform: "translate(-712.983 -532.662)",
    fill: "#f5eee1"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    "data-name": "Group 1259",
    transform: "translate(172.913 99.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1258",
    "data-name": "Group 1258",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2134",
    "data-name": "Rectangle 2134",
    width: 13.704,
    height: 9.41,
    transform: "matrix(0.052, -0.999, 0.999, 0.052, -0.69, 13.232)",
    fill: "url(#linear-gradient-12)"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1261",
    "data-name": "Group 1261",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    "data-name": "Group 1260",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M1134.012,449.551s2-5.589,3.764-3.1,2.342,12.642.374,12.691-2.787-2.614-2.787-2.614Z",
    transform: "translate(-940.121 -369.586)",
    fill: "#a76925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M1134.2,457.7s2.45-4.274,3.192-2.223,1.824,10.43-2.223,7.3c-1.311-3.7-.969-5.073-.969-5.073",
    transform: "translate(-940.245 -377.142)",
    fill: "#996022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M901.182,472.442s-3.152-5.032-4.34-2.229.415,12.851,2.348,12.478,2.163-3.149,2.163-3.149Z",
    transform: "translate(-743.164 -389.113)",
    fill: "#a76925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M906.881,480.32s-3.308-3.652-3.593-1.489.448,10.578,3.731,6.651c.489-3.9-.138-5.162-.138-5.162",
    transform: "translate(-748.799 -396.394)",
    fill: "#996022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M970.241,260.4s.676-9.269,12.769-6.444c6.86,1.6,6.285,8.393,6.285,8.393Z",
    transform: "translate(-804.352 -210.09)",
    fill: "#d6c9a9"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263",
    transform: "translate(157.44 52.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1262",
    "data-name": "Group 1262",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2136",
    "data-name": "Rectangle 2136",
    width: 55.291,
    height: 47.935,
    transform: "translate(-3.126 53.299) rotate(-87.563)",
    fill: "url(#linear-gradient-13)"
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M1062.161,470.383a4.385,4.385,0,0,1,4.007-4.405c4.07-.471,5.024,2.334,5.024,2.334s.063,3.054-4.361,3.837a5.431,5.431,0,0,1-4.629-1.569Z",
    transform: "translate(-880.555 -386.262)",
    fill: "#fbf9f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M1072.156,467.319a2.575,2.575,0,0,0-1.917,3.242,2.36,2.36,0,0,0,2.977,1.994,2.726,2.726,0,0,0,2.094-2.912,2.86,2.86,0,0,0-3.154-2.324",
    transform: "translate(-887.187 -387.392)",
    fill: "#412128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M1072.3,464.208a4.479,4.479,0,0,1-1.126,2.158s-2.261-2.965-5.414-2.265c-2.224.494-3.216,1.429-3.582,4.063-.121-2.072.839-4.5,3.683-4.966s5.488,1.92,5.488,1.92a3.568,3.568,0,0,1,.95-.91",
    transform: "translate(-880.56 -383.951)",
    fill: "#7d3e1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M966.175,476.291s-2.018-5.025-6.782-3.037a4.907,4.907,0,0,0-1.732,2.1,4.632,4.632,0,0,0,.544,2.171,4.824,4.824,0,0,0,5.35,1.567,4.515,4.515,0,0,0,2.62-2.805",
    transform: "translate(-793.922 -391.953)",
    fill: "#fbf9f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M973.916,474.1a2.671,2.671,0,0,0-1.644,3.544,2.447,2.447,0,0,0,3.279,1.75,2.827,2.827,0,0,0,1.86-3.221,2.966,2.966,0,0,0-3.495-2.073",
    transform: "translate(-805.893 -392.976)",
    fill: "#412128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M954.883,473.969c-.35-.636-2.334-4.53-5.886-2.927-2.507,1.2-2.717,2.661-2.717,2.661a17.245,17.245,0,0,1-2.259-1.116,22.436,22.436,0,0,0,2.36-.112,3.653,3.653,0,0,1,2.081-1.935c3.49-1.543,5.868.525,6.422,3.429",
    transform: "translate(-782.614 -389.652)",
    fill: "#7d3e1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M994.538,542.227s-.026,3.78,5,3.153,7.48-5.861,9.161-8.03c.095.081.411-.387.268-.508s-.13-.52-1.45.647a10.453,10.453,0,0,1-5.435,2.736,15.063,15.063,0,0,1-5.315.385,11.694,11.694,0,0,1-4.284-1.068,3.037,3.037,0,0,1-.7-1.048l-.925,1.135,1.25.164,1.474.886Z",
    transform: "translate(-821.445 -444.919)",
    fill: "#612f16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M1022.315,540.406s-3.643,4.212-8.867,4.007c-4.421-.173-5.366-.793-5.366-.793a5.852,5.852,0,0,0,6.825,2.995c4.04-.856,6.084-3.451,7.408-6.209",
    transform: "translate(-835.722 -448.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M1018.825,457.453s3.538,7.729-.652,10.8c-1.117.838.186,3.818,3.259,3.352s1.769-5.773.745-10.056-2.793-5.494-3.352-4.1",
    transform: "translate(-843.76 -378.78)",
    fill: "#9a5a16"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    "data-name": "Group 1267",
    transform: "translate(181.977 74.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1266",
    "data-name": "Group 1266",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2138",
    "data-name": "Rectangle 2138",
    width: 10.061,
    height: 6.068,
    transform: "translate(-1.795 0.357) rotate(-21.14)",
    fill: "url(#linear-gradient-14)"
  })))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1269",
    "data-name": "Group 1269",
    transform: "translate(161.724 74.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1268",
    "data-name": "Group 1268",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2139",
    "data-name": "Rectangle 2139",
    width: 11.425,
    height: 7.429,
    transform: "translate(-1.277 0.494) rotate(-21.14)",
    fill: "url(#linear-gradient-15)"
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1271",
    "data-name": "Group 1271",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1270",
    "data-name": "Group 1270",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M910.856,280.706s-2.705,8.274,4.933,9.229c1.273,2.068,7.558,6.6,10.82,3.023.4,2.864.8,9.229,4.057,8.592.4,3.66-.524,5.806,1.955,8.114.6,3.334,1.282,4.1,3.932,3.676-1.624-1.8-1.164-4.7-.781-4.766,1.5-.276,2.268-.734,2.053-3.046-.318-3.421-.756-30.033-24.067-29.477s-25.6,24.842-21.54,35.98c2.546,1.989,3.694,6.5,2.1,7.292,1.353.318,4.281-2.9,3.247-4.567.318-.636,1.989-1.273,1.114-2.546s-3.5-4.933-1.114-7.319,5.251-4.137,3.262-5.33-2.228-8.592,3.1-10.979,6.762-5.728,6.922-7.876",
    transform: "translate(-738.323 -228.846)",
    fill: "#dbcfb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M972.813,497.015l-.018-.192-.174-.084a11.506,11.506,0,0,0-4.675-.825,20.184,20.184,0,0,0-7.617,1.612l-.25.1.163,1.051a5.9,5.9,0,0,0-5.309.178l-.014-.852-.264-.059a22.2,22.2,0,0,0-4.788-.549c-4.811,0-7.354,1.774-7.46,1.849l-.157.112.014.192a13.07,13.07,0,0,0,1.8,4.762l.125.225.251-.058c2.661-.614,10.161-1.185,10.237-1.191l.321-.024-.057-3.625a5.177,5.177,0,0,1,5.422-.152l.518,3.337.321-.03c.061-.006,6.143-.578,9.344-.578.367,0,.685.008.947.022l.257.015.085-.243a13.059,13.059,0,0,0,.972-5m-28.267,6.745a13.87,13.87,0,0,1-1.569-4.062,13.663,13.663,0,0,1,6.893-1.615,21.353,21.353,0,0,1,4.376.475l.064,4.076c-1.44.113-7.193.589-9.764,1.126m26.732-2.213c-.216-.008-.459-.012-.726-.012-2.806,0-7.782.433-9.088.552l-.625-4.029a19.357,19.357,0,0,1,7.108-1.46,11.846,11.846,0,0,1,4.191.679,13.865,13.865,0,0,1-.86,4.269",
    transform: "translate(-781.148 -411.124)",
    fill: "#fac424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M828.3,644.072c-13.319,1.9-28.7,15.749-36.57,52.908,5.357,2.508,12.2,2.622,12.2,2.622a178.914,178.914,0,0,0-5.016,31.688c3.249,3.419,14.533,5.129,20.859,4.787,1.984-17.138,4.2-65.331,6.369-73.99-13.078-5.261-.726-17.475,2.16-18.016",
    transform: "translate(-656.364 -533.95)",
    fill: "#f8c141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M1069.348,645.558s14.944,9.282,2.116,18.1c.541,16.6,6.5,74.5,6.5,74.5a42.178,42.178,0,0,0,17.781-5.3l-4.388-32.646c4.871.18,10.463-1.083,13.169-4.871-.9-4.51-9.932-41.684-35.177-49.789",
    transform: "translate(-886.513 -535.182)",
    fill: "#f8c141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M1159.152,778.453s3.237,14.842,6.805,32.06c.6-14.532-.191-21.387-6.805-32.06",
    transform: "translate(-960.963 -645.355)",
    fill: "#e0993a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M62.718,763.732c-1.75-18.3,4.893-23.151,8.484-31.2,9.933-13.7,23.13-29.7,26.087-34.488-13.364-13.11-21.037-15.612-21.037-15.612s-31.714,39.691-20.615,76.845c.02.067,3.792,3.736,7.081,4.455",
    transform: "translate(-44.172 -565.751)",
    fill: "#b97529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M597.2,1714.058v1.9a18.779,18.779,0,0,1,2.176.816c2.04.816,9.383,2.312,10.607.952s-2.431-1.759-3.5-2.243a9.427,9.427,0,0,1-2.906-3.007c-1.632.272-6.38,1.578-6.38,1.578",
    transform: "translate(-495.091 -1419.684)",
    fill: "#372631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M380.974,1711.99l.087,3.305a18.769,18.769,0,0,0-2.176.816c-2.04.816-9.383,2.312-10.607.952s2.431-1.759,3.5-2.243a9.424,9.424,0,0,0,2.906-3.007,56.288,56.288,0,0,0,6.293.177",
    transform: "translate(-305.106 -1419.131)",
    fill: "#372631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M349.957,1143.611c-.917.141-3.01,15.059-3.236,16.185-1.125,5.612-5.828,39.471-6.188,41.789-.292,1.883-7.425,25.456-9.578,35.6-2.8,2.078-7.077,2.25-7.077,2.25s-.663-38.544-8.613-63.42c-2.372-.475-8.144-3.393-12.934.556-4.312,3.555-7.07,28.167-4.57,61.337-1.2,2.646-6.735,2.886-8.659,1.684-6.495-11.546-24.775-61.577-21.167-100.544,56.984,8.415,82,4.573,82.023,4.57",
    transform: "translate(-221.736 -944.29)",
    fill: "#4f6760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M335.628,1459.409c-1.528-.394-2.984-1.84-4.283-3.7,4.04,12.861,8.234,22.872,10.712,27.277,1.924,1.2,7.457.962,8.659-1.684-1.541-20.451-1.083-37.646.5-48.661-2,8.667-7.561,28.838-15.593,26.765",
    transform: "translate(-274.692 -1187.694)",
    fill: "#3d534d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M564.971,1383.21c-8.719-4.36-17.952-27.953-17.952-27.953,7.95,24.876,8.613,63.42,8.613,63.42s4.275-.171,7.077-2.25c2.154-10.139,9.286-33.712,9.579-35.595.007-.046.016-.1.026-.174-1.684,2.682-4.059,4.291-7.343,2.552",
    transform: "translate(-453.491 -1123.538)",
    fill: "#3d534d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M347.854,471.2c3.969-2.345,17.078-11.425,30.968-10.523a63.122,63.122,0,0,1,24.463,6.884c-3.969,34.274-9.922,57.365-15.514,63.679-26.7-19.122-39.917-60.039-39.917-60.039",
    transform: "translate(-288.379 -381.863)",
    fill: "#bcc5d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M727.27,572.706c-4.767-11.619-13.434-33.773-34.142-48.523-2.764,7.555-3.4,15.146-.694,22.678.758,2.115,1.748,4.137,2.683,6.18a127.09,127.09,0,0,1,8.749,26.527c.091.431.241.935.66,1.072a1.287,1.287,0,0,0,.767-.074q2.134-.657,4.322-1.121a11.775,11.775,0,0,0-.384-2.049s11.906-4.871,18.039-4.69",
    transform: "translate(-572.607 -434.559)",
    fill: "#b5bbc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M727.1,571.877c-4.767-11.619-13.519-33.944-34.227-48.694-2.764,7.555-3.311,15.317-.609,22.849.759,2.115,1.748,4.137,2.683,6.18a127.094,127.094,0,0,1,8.749,26.527c.091.431.241.935.66,1.072a1.287,1.287,0,0,0,.767-.074q2.134-.657,4.322-1.121a11.792,11.792,0,0,0-.384-2.049s11.906-4.871,18.039-4.69",
    transform: "translate(-572.435 -433.73)",
    fill: "#bcc5d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M156.967,609.683c.824-17.094-6.309-27.921-8.118-30.126-10.313,8.243-16.969,16.632-25.195,34.635l22.73,10.282-1.624,6.133s-.026.5-.059,1.419c4.328.2,11.35-3.354,12.265-22.345",
    transform: "translate(-102.512 -480.466)",
    fill: "#bcc5d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M156.967,609.683c.824-17.094-6.309-27.921-8.118-30.126-10.313,8.243-16.969,16.632-25.195,34.635l22.73,10.282-1.624,6.133s-.026.5-.059,1.419c4.328.2,11.35-3.354,12.265-22.345",
    transform: "translate(-102.512 -480.466)",
    fill: "#b5bbc0"
  })))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1273",
    "data-name": "Group 1273",
    transform: "translate(41.646 83.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1272",
    "data-name": "Group 1272",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2141",
    "data-name": "Rectangle 2141",
    width: 121.231,
    height: 150.105,
    transform: "translate(-25.317 4.001) rotate(-9.913)",
    fill: "url(#linear-gradient-16)"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    "data-name": "Group 1275",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1274",
    "data-name": "Group 1274",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M243.518,574.887s9.572,8.357,9.211,29.282c-.135,7.808-2.085,16.487-8.6,18.039-.139,6.964-.26,7.806-.26,7.806s12.443-.627,15.533-21.155c1.912-12.7-1.834-32.82-9.171-39.435-3.909,3.057-6.715,5.462-6.715,5.462",
    transform: "translate(-201.882 -472.066)",
    fill: "#344a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M407.777,535.193c11.456-20.406,12.53-34.368,9.728-52.812-2.5-1.419-2.867-1.173-5.6-2.2,1.337,10.471,2.783,24.8-6.624,43.561-7.856-8.911-20.844-16.389-31.716-41.495a45.15,45.15,0,0,0-5.485,2.838c3.914,11.978,18.773,37.358,39.7,50.106",
    transform: "translate(-305.145 -398.082)",
    fill: "#344a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M626.17,363.451s2.405-4.4,4.181-1.73,1.978,15.98-2.191,13.185c-2.634-7.023-1.989-11.455-1.989-11.455",
    transform: "translate(-519.051 -299.162)",
    fill: "#ad6c26"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277",
    transform: "translate(107.219 63.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    "data-name": "Group 1276",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2143",
    "data-name": "Rectangle 2143",
    width: 10.746,
    height: 4.816,
    transform: "translate(-0.378 10.581) rotate(-87.954)",
    fill: "url(#linear-gradient-17)"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    "data-name": "Group 1279",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1278",
    "data-name": "Group 1278",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M378.442,394.127s-4.647-3.43-5.206.221,5.684,17.653,8.684,12.711c-.654-8.614-3.477-12.932-3.477-12.932",
    transform: "translate(-309.391 -325.529)",
    fill: "#ad6c26"
  })))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1281",
    "data-name": "Group 1281",
    transform: "translate(65.649 69.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1280",
    "data-name": "Group 1280",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2145",
    "data-name": "Rectangle 2145",
    width: 11.786,
    height: 13.337,
    transform: "translate(-4.726 2.282) rotate(-26.949)",
    fill: "url(#linear-gradient-18)"
  })))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1283",
    "data-name": "Group 1283",
    transform: "translate(104.366 45.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1282",
    "data-name": "Group 1282",
    clipPath: "url(#clip-path-93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2146",
    "data-name": "Rectangle 2146",
    width: 15.25,
    height: 20.952,
    transform: "translate(-5.94 2.105) rotate(-19.516)",
    fill: "url(#linear-gradient-19)"
  })))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1285",
    "data-name": "Group 1285",
    transform: "translate(68.094 36.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2147",
    "data-name": "Rectangle 2147",
    width: 54.341,
    height: 68.793,
    transform: "translate(-13.35 2.84) rotate(-12.447)",
    fill: "url(#linear-gradient-20)"
  })))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    "data-name": "Group 1286",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M497.408,463.537s.4,10.637,9.4,9.39c8.384-1.162,5.168-8.279,5.168-8.279l.28-2.1Z",
    transform: "translate(-412.362 -383.466)",
    fill: "#7a4a1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M498.077,460.147s2.331,7.085,7.306,6.923c7.62-.249,6.162-5.71,6.162-5.71l.276-2.7Z",
    transform: "translate(-412.917 -380.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M503.553,469.9a9.421,9.421,0,0,0,8.153,1.993c4.908-1.088,4.489-4.147,4.489-4.147s.247,4.125-4.912,4.769c-5.953.744-7.729-2.615-7.729-2.615",
    transform: "translate(-417.457 -387.768)",
    fill: "#cacaca"
  })))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    "data-name": "Group 1289",
    transform: "translate(69.451 69.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1288",
    "data-name": "Group 1288",
    clipPath: "url(#clip-path-96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 50.432,
    height: 45.401,
    transform: "translate(-5.837 0.893) rotate(-8.7)",
    fill: "url(#linear-gradient-21)"
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1291",
    "data-name": "Group 1291",
    transform: "translate(62.931 48.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290",
    clipPath: "url(#clip-path-97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2150",
    "data-name": "Rectangle 2150",
    width: 17.646,
    height: 25.296,
    transform: "translate(-8.939 2.579) rotate(-19.516)",
    fill: "url(#linear-gradient-22)"
  })))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    "data-name": "Group 1293",
    transform: "translate(81.257 74.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1292",
    "data-name": "Group 1292",
    clipPath: "url(#clip-path-98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151",
    "data-name": "Rectangle 2151",
    width: 27.818,
    height: 21.768,
    transform: "translate(-3.964 0.415) rotate(-8.7)",
    fill: "url(#linear-gradient-23)"
  })))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1294",
    "data-name": "Group 1294",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M557.773,339.182c-.114-.017,6.04-3.532,10.425-.888-.012-1.1-2.8-3.765-2.8-3.765a12.678,12.678,0,0,0-7.816.977c-.7,2.634.195,3.676.195,3.676",
    transform: "translate(-462.024 -277.141)",
    fill: "#e5d8b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M440.222,348.08c.111-.029-6.353-2.611-13.271,2.138-.1-1.1,1.655-3.354,1.655-3.354s5.651-3.492,10.328-2.061c.973,2.545,1.289,3.278,1.289,3.278",
    transform: "translate(-353.948 -285.564)",
    fill: "#e5d8b9"
  })))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297",
    transform: "translate(96.294 64.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2153",
    "data-name": "Rectangle 2153",
    width: 9.095,
    height: 7.053,
    transform: "translate(-1.524 0.413) rotate(-24.172)",
    fill: "url(#linear-gradient-24)"
  })))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1299",
    "data-name": "Group 1299",
    transform: "translate(78.006 66.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1298",
    "data-name": "Group 1298",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2154",
    "data-name": "Rectangle 2154",
    width: 10.173,
    height: 9.899,
    transform: "matrix(0.737, -0.676, 0.676, 0.737, -2.698, 2.074)",
    fill: "url(#linear-gradient-25)"
  })))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1301",
    "data-name": "Group 1301",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1300",
    "data-name": "Group 1300",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M517.128,370.648s-.389,6.89,2.737,7.394,1.986,7.434-6.414,3.858c-1.616-5.192-.1-14.488,1.753-14.334s1.923,3.082,1.923,3.082",
    transform: "translate(-425.097 -304.719)",
    fill: "#9b5a16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M262.062,1208.126c.456,3.534.57,4.56,1.254,7.979,18.4,2.706,34.913,4.228,43.39,4.444,18.565.473,33.173-1.891,35.518-3.334.651-2.906,1.395-5.916,2.2-9.17-23.652,7.538-67.021,2.357-82.367.081",
    transform: "translate(-217.255 -1001.496)",
    fill: "#344a66"
  })))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1303",
    "data-name": "Group 1303",
    transform: "translate(94.54 117.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1302",
    "data-name": "Group 1302",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2156",
    "data-name": "Rectangle 2156",
    width: 21.265,
    height: 27.935,
    transform: "translate(-3.811 15.605) rotate(-77.787)",
    fill: "url(#linear-gradient-26)"
  })))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1305",
    "data-name": "Group 1305",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1304",
    "data-name": "Group 1304",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M545.886,846.89c-1.257,1.466-4.468,7.54-12.846,9.215-3.7.559-4.049-1.327-5.795-1.047s-1.815,5.446.279,8.8,4.957.14,9.425-1.536,8.962-5.024,10.4-5.81c.916.131,4.843.693,4.319,1.571-2.523,4.229-8.238,10.347-7.949,12.2.349,2.234,6.423,4.119,8.517,3.142s.349-2.164,1.257-4.329,10.908-8.779,15.516-12.061c3.281-3.281,3.551-7.657,3.341-7.8s-26.467-2.344-26.467-2.344",
    transform: "translate(-436.019 -702.091)",
    fill: "#e97f54"
  })))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1307",
    "data-name": "Group 1307",
    transform: "translate(142.857 120.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1306",
    "data-name": "Group 1306",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2158",
    "data-name": "Rectangle 2158",
    width: 21.772,
    height: 25.817,
    transform: "translate(-4.314 15.052) rotate(-74.007)",
    fill: "url(#linear-gradient-27)"
  })))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1309",
    "data-name": "Group 1309",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1308",
    "data-name": "Group 1308",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M672,748.858l-7.856,2.034s1.629,13.619-1.8,19.968c-13.516-2.435-26.008-12.54-26.008-12.54s4.327-10.421,7.431-13.714c-2.588-.212-3.873-.357-3.873-.357l1.3-5.7s6.894-.9,12.31.241c1.833.607,7.639,1.842,7.639,1.842s4.7,1.38,7.284,1.262a19.81,19.81,0,0,1,3.773.085,24.528,24.528,0,0,0-.2,6.881",
    transform: "translate(-527.538 -611.992)",
    fill: "#efaf5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M659.247,801.055l-17.352,5.493.575,7.976a12.852,12.852,0,0,1-2.42.628c-3.195.617-12.226,2.988-15.232,3.108a39.971,39.971,0,0,1-8-.122l.022-.061a.046.046,0,0,0-.01-.022,4.491,4.491,0,0,0-.52-2.968,5.218,5.218,0,0,1-.84-1.628c-.039-.226-.086-.526-.314-.556-.448.028-.567.733-.42,1.482a4.912,4.912,0,0,1-.146,1.138c-.119-.2-.235-.4-.344-.61a23.129,23.129,0,0,1-1.546-4.254,1.528,1.528,0,0,0-.2-.462.518.518,0,0,0-.423-.235.317.317,0,0,0-.307.327l-.358-.6a4.566,4.566,0,0,0-.627,1.284l-.847-2.034c-.485-.042-.562,1.83-.585,2.1a13.471,13.471,0,0,0,.322,4.3c.918,3.476,4.08,5.739,5.088,6.384.294.26.9.531,1.331.839,35,17.859,45.77,1.781,45.77,1.781s.9-.361,1.443-2.706a39.4,39.4,0,0,0-4.064-20.576",
    transform: "translate(-505.131 -664.092)",
    fill: "#b97529"
  })))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311",
    transform: "translate(126.512 124.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1310",
    "data-name": "Group 1310",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2160",
    "data-name": "Rectangle 2160",
    width: 5.905,
    height: 5.878,
    transform: "translate(-0.292 5.606) rotate(-87.013)",
    fill: "url(#linear-gradient-28)"
  })))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    "data-name": "Group 1313",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M677.6,654.34s-4.329.2-4.063-4.107,3.575-3.352,4.6-.422c-.488,4.13-.533,4.529-.533,4.529",
    transform: "translate(-558.37 -536.629)",
    fill: "#7a4a1b"
  })))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315",
    transform: "translate(116.62 94.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314",
    clipPath: "url(#clip-path-109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2162",
    "data-name": "Rectangle 2162",
    width: 33.716,
    height: 35.989,
    transform: "translate(-1.678 0.063) rotate(-2.437)",
    fill: "url(#linear-gradient-29)"
  })))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1316",
    "data-name": "Group 1316",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M738.454,653.369a2.625,2.625,0,0,1-1.51,2.4c-1.51.533-1.954.933-1.732,1.465s2.4,1.2,3.108,0,.755-4.8.133-3.863",
    transform: "translate(-609.464 -541.531)",
    fill: "#a76925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M713.151,613.593c-.091.314-.178.508-.263.749a.2.2,0,0,1-.223.133,20.594,20.594,0,0,0-3.643-.055.2.2,0,0,1-.213-.225v0a.2.2,0,0,1,.127-.166,9.577,9.577,0,0,1,4.042-.69.2.2,0,0,1,.173.258",
    transform: "translate(-587.617 -508.439)",
    fill: "#552f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M807.03,624.323c-.033.335-.025.55-.035.813a.193.193,0,0,0,.15.2,20.428,20.428,0,0,1,3.391,1.294.194.194,0,0,0,.274-.147v0a.192.192,0,0,0-.058-.167,9.292,9.292,0,0,0-3.478-2.152.2.2,0,0,0-.245.167",
    transform: "translate(-669.016 -517.433)",
    fill: "#552f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M789.759,652.281s-.533-3.53.7-4.962,5.173-.341,5.425,1.739-.532,4-1.764,4.1c-1.6-.266-4.36-.872-4.36-.872",
    transform: "translate(-654.633 -536.103)",
    fill: "#f7f5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M797.143,657.552c-1.166-.167-1.932-1.465-1.732-3.2.182-1.577.9-2.864,2.5-2.431s1.7,2.531,1.565,3.5-.992,2.323-2.331,2.131",
    transform: "translate(-659.388 -540.389)",
    fill: "#412128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M703.144,638.785s1.547-3.217.791-4.948-3.345-1-4.477.061a2.753,2.753,0,0,0-.066,3.976,26.492,26.492,0,0,1,3.753.911",
    transform: "translate(-579.123 -524.604)",
    fill: "#f7f5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M711.457,638.047c.833.122,1.51,1.244,1.166,3.219-.266,1.528-1.088,2.376-2.187,2.109s-1.464-1.4-1.288-2.842c.222-1.82.764-2.713,2.309-2.487",
    transform: "translate(-587.864 -528.927)",
    fill: "#412128"
  })))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1322",
    "data-name": "Group 1322",
    transform: "translate(132.85 115.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1321",
    "data-name": "Group 1321",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320",
    transform: "translate(-0.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2164",
    "data-name": "Rectangle 2164",
    width: 7.14,
    height: 3.447,
    transform: "translate(-0.047 -0.041)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327",
    transform: "translate(118.948 113.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326",
    clipPath: "url(#clip-path-113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325",
    transform: "translate(-0.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1323",
    "data-name": "Group 1323",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2166",
    "data-name": "Rectangle 2166",
    width: 5.745,
    height: 2.79,
    transform: "translate(-0.018 -0.008)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329",
    transform: "translate(142.312 117.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    "data-name": "Group 1328",
    clipPath: "url(#clip-path-115)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2168",
    "data-name": "Rectangle 2168",
    width: 7.658,
    height: 8.064,
    transform: "translate(-0.312 7.321) rotate(-87.563)",
    fill: "url(#linear-gradient-30)"
  })))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M839.524,696.574s2.664-1.2,3.375.355-1.421,3.685-4.13,2.353c1.11-.133,3.2-.178,2.886-1.776-.206-1.061-2.131-.933-2.131-.933",
    transform: "translate(-695.358 -577.109)",
    fill: "#a76925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M726.434,690.631a1.155,1.155,0,0,0-.8-.091,14.332,14.332,0,0,1-7.306-1.556.991.991,0,0,0-.879.12c-.561.322-.554,1.133-.383,1.757a5.361,5.361,0,0,0,6.315,3.547c3.622-.648,3.223-3.651,3.048-3.777",
    transform: "translate(-594.383 -571.133)",
    fill: "#963216"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M735.493,706.087s-6.7-1.392-7.558,1.233c1.992,1.708,6.578,1.613,7.558-1.233",
    transform: "translate(-603.474 -585.056)",
    fill: "#da5523"
  })))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333",
    transform: "translate(116.675 88.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2170",
    "data-name": "Rectangle 2170",
    width: 46.512,
    height: 43.031,
    transform: "translate(-11.187 4.107) rotate(-21.14)",
    fill: "url(#linear-gradient-31)"
  })))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M1674.916,521.777l-24.921-2.419s-.912-19.656-8.27-35.468c4.853-19.883,5.167-22.7,5.167-22.7s23.484,19.57,28.024,60.588",
    transform: "translate(-1361.027 -382.336)",
    fill: "#ef5153"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385",
    transform: "translate(280.698 79.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    "data-name": "Group 1384",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338",
    transform: "translate(-11.909 23.956)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336",
    clipPath: "url(#clip-path-120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M1572.09,625.744l-.024.049q.659,1.222,1.243,2.477c23.487-2.63,58.408-18.653,58.408-18.653l-1.527-6.356c-23.825,13.874-58.1,22.484-58.1,22.484",
    transform: "translate(-1572.067 -603.26)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341",
    transform: "translate(-33.217 -17.282)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339",
    clipPath: "url(#clip-path-121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M1447.465,398.69s-.009.021-.02.05c.489.785.555,1.139,1,1.948,48.291-16.162,69.979-32.373,69.979-32.373l-1.923-6.248c-22.908,15.34-69.034,36.622-69.034,36.622",
    transform: "translate(-1447.446 -362.068)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344",
    transform: "translate(-2.066 57.309)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342",
    clipPath: "url(#clip-path-122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M1629.665,819.242s-.011.02-.025.048q.625,1.239,1.176,2.509c23.55-2,58.887-17.079,58.887-17.079l-1.355-6.395c-24.189,13.229-58.682,20.916-58.682,20.916",
    transform: "translate(-1629.64 -798.327)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1347",
    "data-name": "Group 1347",
    transform: "translate(-22.279 1.089)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1346",
    "data-name": "Group 1346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M1511.428,501.079s37.309-11.728,62.68-31.555l2.082,5.777a306.625,306.625,0,0,1-61.993,31.486,7.082,7.082,0,0,1-2.769-5.707",
    transform: "translate(-1511.418 -469.523)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1350",
    "data-name": "Group 1350",
    transform: "translate(-10.203 36.979)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1349",
    "data-name": "Group 1349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1348",
    "data-name": "Group 1348",
    clipPath: "url(#clip-path-124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M1582.1,705.143s38.223-8.28,65.294-25.713l1.547,5.942a306.611,306.611,0,0,1-64.6,25.706,7.081,7.081,0,0,1-2.238-5.936",
    transform: "translate(-1582.048 -679.43)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    "data-name": "Group 1353",
    transform: "translate(-31.213 -1.082)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351",
    clipPath: "url(#clip-path-125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M1459.172,461.783s18.261,19.052,46.659,83.344a18.3,18.3,0,0,0,4.731-.044s-33.5-76.459-47.484-88.268c-3.217,4.245-3.906,4.968-3.906,4.968",
    transform: "translate(-1459.172 -456.816)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356",
    transform: "translate(-16.774 -17.325)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1354",
    "data-name": "Group 1354",
    clipPath: "url(#clip-path-126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M1543.621,366.788s32.048,51.7,46.791,97.538a18.3,18.3,0,0,0,4.731-.044s-33.628-90.653-47.616-102.462c-3.217,4.245-3.906,4.968-3.906,4.968",
    transform: "translate(-1543.621 -361.82)",
    fill: "#a2d9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359",
    transform: "translate(9.075 -28.368)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    "data-name": "Group 1357",
    clipPath: "url(#clip-path-127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M1694.8,301.69s25.543,55.207,34.62,102.492a18.3,18.3,0,0,0,4.7.53s-22.389-94.061-34.843-107.48c-3.708,3.824-4.479,4.458-4.479,4.458",
    transform: "translate(-1694.797 -297.232)",
    fill: "#a2d9ff"
  }))))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1362",
    "data-name": "Group 1362",
    transform: "translate(-22.582 -9.014)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    "data-name": "Group 1361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1360",
    "data-name": "Group 1360",
    clipPath: "url(#clip-path-128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M1509.733,412.59s26.051,37.368,45.545,92.765l1.412-.034s-14.651-47.886-46.3-94.866c-1.067-.327-.655,2.135-.655,2.135",
    transform: "translate(-1509.654 -410.426)",
    fill: "#eaeceb"
  }))))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1365",
    "data-name": "Group 1365",
    transform: "translate(25.524 -22.76)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1364",
    "data-name": "Group 1364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1363",
    "data-name": "Group 1363",
    clipPath: "url(#clip-path-129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M1791.013,332.068s17.943,41.869,25.816,100.066l1.39.252s-4.651-49.861-26.133-102.277c-.979-.537-1.073,1.958-1.073,1.958",
    transform: "translate(-1791.012 -330.034)",
    fill: "#eaeceb"
  }))))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368",
    transform: "translate(-5.296 -26.383)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    "data-name": "Group 1367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1366",
    "data-name": "Group 1366",
    clipPath: "url(#clip-path-130)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M1610.786,310.975s29.106,49.289,45.859,105.576l1.412.035s-17.2-59.235-46.512-107.711c-1.05-.379-.759,2.1-.759,2.1",
    transform: "translate(-1610.749 -308.836)",
    fill: "#eaeceb"
  }))))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1371",
    "data-name": "Group 1371",
    transform: "translate(-15.379 14.472)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1370",
    "data-name": "Group 1370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1369",
    "data-name": "Group 1369",
    clipPath: "url(#clip-path-131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M1551.779,574.872s37.864-12.166,58.833-27.083l.871,2.416s-9.021,9.542-59.184,26.438a5.772,5.772,0,0,0-.52-1.771",
    transform: "translate(-1551.779 -547.789)",
    fill: "#eaeceb"
  }))))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    "data-name": "Group 1374",
    transform: "translate(-33.08 -20.804)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    "data-name": "Group 1373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1372",
    "data-name": "Group 1372",
    clipPath: "url(#clip-path-132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M1448.254,368.558s37.864-12.166,58.833-27.083l.871,2.416s-9.021,9.542-59.184,26.438a5.789,5.789,0,0,0-.52-1.771",
    transform: "translate(-1448.253 -341.474)",
    fill: "#eaeceb"
  }))))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1377",
    "data-name": "Group 1377",
    transform: "translate(-29.503 -5.91)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375",
    clipPath: "url(#clip-path-133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M1469.17,461.556s49.269-18.057,70.238-32.974l.871,2.416s-20.427,15.434-70.589,32.33a5.781,5.781,0,0,0-.52-1.771",
    transform: "translate(-1469.17 -428.582)",
    fill: "#eaeceb"
  }))))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    "data-name": "Group 1380",
    transform: "translate(-9.764 33.527)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    "data-name": "Group 1378",
    clipPath: "url(#clip-path-134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M1584.617,680.811s38.864-9.145,61.4-21.575c.427.866.225,1.3.225,1.3s-15.967,10.028-61.14,21.506a1.667,1.667,0,0,0-.482-1.226",
    transform: "translate(-1584.617 -659.237)",
    fill: "#eaeceb"
  }))))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383",
    transform: "translate(-2.619 47.775)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381",
    clipPath: "url(#clip-path-135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M1626.411,767.622s38.259-10.86,59.727-25.049l.788,2.444s-9.344,9.227-60.056,24.393a5.782,5.782,0,0,0-.458-1.788",
    transform: "translate(-1626.411 -742.572)",
    fill: "#eaeceb"
  }))))))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    "data-name": "Group 1387",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M1716.006,768.245s.939,4.07-2.192,11.272c-3.6-4.7-15.219-8.823-27.274-6.945a13.074,13.074,0,0,1-.949-5.457s18.517-7.481,30.415,1.13",
    transform: "translate(-1397.377 -633.457)",
    fill: "#6b3f4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M1738.176,964.877l-6.26,5.466-3.747,9.127,5.478,5.406s6.532-9.944,7.486-17.614a32.131,32.131,0,0,0-2.957-2.386",
    transform: "translate(-1432.691 -799.905)",
    fill: "#cf9c75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M1712.65,964.144c-.9,1.315-1.743,2.7-2.719,3.964a10.506,10.506,0,0,0-2.552,5.788.969.969,0,0,0,.168.681c.629.712,1.742-.441,2.233-.79l1.584-1.125c-.047.033,1.063,2.095,1.128,2.225.71,1.4,1.521,2.721,2.238,4.114a7.34,7.34,0,0,0,.967,1.6,2.015,2.015,0,0,0,1.64.746,1.193,1.193,0,0,0,1.088-1.267,2.122,2.122,0,0,0,3.961-.97c-.007.181,1.671-.146,1.815-.2a4.156,4.156,0,0,0,1.606-1.018c.494-.5.2-1.166.02-1.788a32.889,32.889,0,0,0-1.854-4.6c-1.487-3.184-3.183-6.261-4.793-9.382a7.888,7.888,0,0,1-.722-1.532c-.716-2.357-5.808,3.552-5.808,3.552",
    transform: "translate(-1415.454 -795.892)",
    fill: "#e8ae81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M1718.869,1026.634a60.966,60.966,0,0,0,4.739-7.462c-2.736.788-4.716,3.1-6.527,5.295-.469.568-.309.965-.09,1.668s1.439,1.09,1.878.5",
    transform: "translate(-1423.247 -844.916)",
    fill: "#cf9c75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M1735.058,1029.156a6.164,6.164,0,0,0-2.279.936,10.99,10.99,0,0,0-1.826,1.708l-2.469,2.69a1.36,1.36,0,0,0-.338.849,2.459,2.459,0,0,0-.041.728.74.74,0,0,0,1.136.592,2.447,2.447,0,0,0,.625-.5,26.868,26.868,0,0,0,2.672-3.187c.463-.626.9-1.271,1.324-1.923q.305-.47.6-.945c.1-.155.432-.908.592-.948",
    transform: "translate(-1432.626 -853.193)",
    fill: "#cf9c75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M1743.553,1047.939a4.037,4.037,0,0,0-1.855.446,5.674,5.674,0,0,0-1.36,1.168l-1.807,1.922a.856.856,0,0,0-.189.676,2.041,2.041,0,0,0,.056.616,1.033,1.033,0,0,0,.4.567.785.785,0,0,0,.679.092,1.385,1.385,0,0,0,.486-.339,14.042,14.042,0,0,0,1.916-2.311c.319-.459.611-.936.892-1.422q.2-.35.4-.705c.064-.116.254-.7.387-.711",
    transform: "translate(-1441.123 -868.765)",
    fill: "#cf9c75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M1783.933,1672.216c-.259.129-2.908,3.878-2.779,6.01.152,2.647.358,5.1,1.177,6.522,1.75,3.031,8.891,2.564,8.777,1.254.114-1.653-2.28-1.995-2.451-3.306a17.11,17.11,0,0,1,.513-6.668,9.609,9.609,0,0,0-5.238-3.813",
    transform: "translate(-1476.612 -1386.304)",
    fill: "#dd3a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M1792.511,1640.693a29.434,29.434,0,0,0-2.089,4.909,4.325,4.325,0,0,0-.267,1.317,4.052,4.052,0,0,0,.2,1.114c.855,2.964,3.288,7.967,4.859,7.583.8-.194.438-4.383,1.026-6.611.572-2.167,3.122-6.552,2.783-6.864a45.552,45.552,0,0,0-4.395-3.554Z",
    transform: "translate(-1484.079 -1358.425)",
    fill: "#d09c76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M1834.7,1678.215l.77,7.689s-5.969,3.1-7.409,5.414c8.645-2.228,12.823-3.411,12.823-3.411l-.565-9.317Z",
    transform: "translate(-1515.504 -1391.277)",
    fill: "#d09c76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M1827.849,1724.529s-10.241,3.987-8.3,6.381c1.346,1.663,14.362-3.135,14.362-3.135l-.285-1.473c-7.764,2.083-8.415,2.159-9.233,1.3s3.459-3.075,3.459-3.075",
    transform: "translate(-1508.242 -1429.673)",
    fill: "#dd3a2c"
  })))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1389",
    "data-name": "Group 1389",
    transform: "translate(306.164 163.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388",
    clipPath: "url(#clip-path-137)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2189",
    "data-name": "Rectangle 2189",
    width: 46.659,
    height: 127.932,
    transform: "translate(-8.141 0.529) rotate(-3.721)",
    fill: "url(#linear-gradient-32)"
  })))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1391",
    "data-name": "Group 1391",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1390",
    "data-name": "Group 1390",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M1790.668,1226.819l6.632,2.579s18.467-33.793,22.311-48.983c-.6-.012-4.422-1.5-5.362-3.6-4.9-10.92-6.994-31.233-9.757-42.879-.626,14.264-4.6,52.2-5.875,61.47-1.551,11.245-7.949,31.409-7.949,31.409",
    transform: "translate(-1484.504 -940.061)",
    fill: "#c88430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M1701.964,938.958c-2.908,7.755-2.714,9.888-.388,29.664s14.541,66.307,24.817,100.624c8.143.194,9.888-.194,9.888-.194s-.969-7.755-2.908-21.327-1.939-33.929-1.939-33.929-1.939-25.4-2.133-33.154c.776-7.755,1.551-38.582,1.551-38.582Z",
    transform: "translate(-1409.177 -778.417)",
    fill: "#e0993a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M1685.233,313.632c-.09-.5-.165-1-.219-1.509-.511-4.8.89-9.634.606-14.449-.687-11.66-9.95-21.547-12.981-32.913-.84-3.149-1.194-6.393-2.175-9.51a14.615,14.615,0,0,0-5.647-8.116c-3.581-2.333-8.321-2.589-12.767-2.759-5.165-.2-9.873-.33-14.11,2.565a15.769,15.769,0,0,0-6.774,10c-.63,3.516.108,7.106-.046,10.663-.172,3.983-1.456,7.852-2.4,11.749-1.84,7.563-2.761,14.686-5.771,22.061-2.969,7.275-6.347,14.635-6.593,22.472a10.578,10.578,0,0,0,1.133,5.606c1.354,2.328,3.06,2.372,5.521,3.337,3.068,1.2,3.635,4.123,2.985,6.744-.208.837-1.55,2.621-.835,3.464.948,1.117,4.347-.172,5.393-.664,1.509-.71,2.786-1.754,4.268-2.506a6.173,6.173,0,0,1,4.895-.579c2.556,1.009,2.878,4.031,4.287,6.167,1.712,2.595,5.246,3.914,8.645,4.037a8.8,8.8,0,0,0,5.62-1.405c2.361-1.806,2.551-5.036,4.539-7.165,2.835-3.036,8.082-2.815,12.5-2.326,3.861.427,12.211,2.812,15.553.129a2.246,2.246,0,0,0,.649-2.353,7.7,7.7,0,0,0-1.24-2.279c-4.6-6.721-3.713-13.151-5.034-20.46",
    transform: "translate(-1339.984 -202.519)",
    fill: "#2b180f"
  })))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    "data-name": "Group 1393",
    transform: "translate(307.532 83.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392",
    clipPath: "url(#clip-path-139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2191",
    "data-name": "Rectangle 2191",
    width: 41.372,
    height: 27.137,
    transform: "translate(-10.057 35.199) rotate(-74.055)",
    fill: "url(#linear-gradient-33)"
  })))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    "data-name": "Group 1394",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M1858.681,773.274a.927.927,0,1,0,.748-1.7c-1.161-.481-1.762,1.377-.748,1.7",
    transform: "translate(-1540.46 -639.59)",
    fill: "#e0d46d"
  })))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    "data-name": "Group 1397",
    transform: "translate(293.653 41.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1396",
    "data-name": "Group 1396",
    clipPath: "url(#clip-path-141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2193",
    "data-name": "Rectangle 2193",
    width: 50.353,
    height: 44.762,
    transform: "translate(-3.03 48.492) rotate(-87.563)",
    fill: "url(#linear-gradient-34)"
  })))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    "data-name": "Group 1399",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1398",
    "data-name": "Group 1398",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M1825.158,259.279c-1.557-10.405-10.655-16.728-21.143-16.674a35.312,35.312,0,0,0-5.048.357,15.375,15.375,0,0,0,2.1,2.2,30.05,30.05,0,0,0,7.39,4.731,32.687,32.687,0,0,0,4.218,1.574c1.441.427,3,.518,4.388.992a7.342,7.342,0,0,1,3.118,1.793c1.358,1.5,1.243,3.635.763,5.48s-1.262,3.694-1,5.587a12.79,12.79,0,0,0,1.251,3.692,9.42,9.42,0,0,1,.691,5.727c3.507.237,4.808-5.211,3.275-15.457",
    transform: "translate(-1491.384 -201.124)",
    fill: "#a76925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M1726.407,281.147c-2.6-3.06-4.226-6.983-3.38-10.737a17.74,17.74,0,0,0,.77-3.46,14.754,14.754,0,0,0-.907-3.952,12.021,12.021,0,0,1,2.642-10.879,15.673,15.673,0,0,1,11.2-5.1l5.324-3.526a24.552,24.552,0,0,0-6.744-.893c-11.338.058-15.891,4.16-18.794,12.436-1.24,3.536,2.1,9.948,2.508,13.564.543,4.847-1.346,6.705.575,9.323,1.557.773,2.8.766,3.261,1.3,4.413,5.068,9.665,10.174,16.222,11.959.061-.039.123-.08.185-.12l-3.293-2.195c-3.459-2.306-6.967-4.654-9.569-7.714",
    transform: "translate(-1422.804 -201.117)",
    fill: "#a76925"
  })))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1404",
    "data-name": "Group 1404",
    transform: "translate(319.087 68.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1403",
    "data-name": "Group 1403",
    clipPath: "url(#clip-path-143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    "data-name": "Group 1402",
    transform: "translate(-0.02 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    "data-name": "Group 1401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400",
    clipPath: "url(#clip-path-144)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2195",
    "data-name": "Rectangle 2195",
    width: 9.848,
    height: 4.186,
    transform: "translate(-0.064 -0.005)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1409",
    "data-name": "Group 1409",
    transform: "translate(301.102 70.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1408",
    "data-name": "Group 1408",
    clipPath: "url(#clip-path-145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1407",
    "data-name": "Group 1407",
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1406",
    "data-name": "Group 1406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1405",
    "data-name": "Group 1405",
    clipPath: "url(#clip-path-146)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2197",
    "data-name": "Rectangle 2197",
    width: 9.766,
    height: 4.678,
    transform: "translate(-0.067 -0.068)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1411",
    "data-name": "Group 1411",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1410",
    "data-name": "Group 1410",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M1805.751,431.985s8.608-.879,14.992-4.543c-1.674,5.819-5.073,11.9-7.407,11.931-3.5.052-7.585-7.388-7.585-7.388",
    transform: "translate(-1497.008 -354.359)",
    fill: "#8b441f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M1809.037,434.995s9.143.12,14.066-4.388c-1.612,4.259-4.8,10.087-7.137,10.122-3.5.052-6.929-5.733-6.929-5.733",
    transform: "translate(-1499.732 -356.982)",
    fill: "#651419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M1821.867,444.469a6,6,0,0,0,3.521-3.508,27.712,27.712,0,0,1-10.552,2.244c.866.647,3.892,2.619,7.031,1.264",
    transform: "translate(-1504.54 -365.566)",
    fill: "#ffe8d3"
  })))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413",
    transform: "translate(318.156 55.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1412",
    "data-name": "Group 1412",
    clipPath: "url(#clip-path-148)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2200",
    "data-name": "Rectangle 2200",
    width: 10.917,
    height: 7.084,
    transform: "translate(-1.214 0.469) rotate(-21.14)",
    fill: "url(#linear-gradient-35)"
  })))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415",
    transform: "translate(297.954 55.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    "data-name": "Group 1414",
    clipPath: "url(#clip-path-149)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2201",
    "data-name": "Rectangle 2201",
    width: 11.397,
    height: 7.926,
    transform: "translate(-1.492 0.577) rotate(-21.14)",
    fill: "url(#linear-gradient-36)"
  })))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1417",
    "data-name": "Group 1417",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M1831.868,385.347a3.154,3.154,0,0,1-.338,1.589c-.265.519-.67.955-.955,1.464a1.784,1.784,0,0,0-.164,1.668,1.557,1.557,0,0,0,1.132.73,4.6,4.6,0,0,0,1.388-.046,1.982,1.982,0,0,0,.739-.2,1.425,1.425,0,0,0,.616-1,4.892,4.892,0,0,0-.092-1.716,15.461,15.461,0,0,0-.707-2.931,1.838,1.838,0,0,0-.476-.77.744.744,0,0,0-.847-.116c-.4.255-.322.849-.3,1.327",
    transform: "translate(-1517.332 -318.29)",
    fill: "#9a5a16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M1870.707,361.977a2.918,2.918,0,0,1,2.418-2.954c2.465-.37,3.944-.062,4.376-.616-.247,3.883-1.356,6.41-4.13,6.225-1.972-.123-2.4-1.109-2.4-1.109Z",
    transform: "translate(-1550.858 -297.127)",
    fill: "#ffe8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M1878.827,369.278c2.3-.256,1.886-5.341-.735-5.215-2.209.107-1.841,5.5.735,5.215",
    transform: "translate(-1555.778 -301.814)",
    fill: "#2b0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M1877.888,353.3a2.77,2.77,0,0,1-1.981.215,19.5,19.5,0,0,0-1.994-.429,3.923,3.923,0,0,0-3.009,1.059c-1.139,1.086-1.04,3.468-.831,3.408a3.51,3.51,0,0,1,1.722-1.993,10.408,10.408,0,0,1,3.282-.661,3.557,3.557,0,0,0,2.811-1.6",
    transform: "translate(-1550.224 -292.707)",
    fill: "#351601"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M1770.362,371.062a2.918,2.918,0,0,0-3.294-1.929c-2.44.511-3.719,1.314-4.317.944,1.582,3.554,3.5,5.538,6.036,4.4,1.806-.8,1.868-1.876,1.868-1.876Z",
    transform: "translate(-1461.36 -305.961)",
    fill: "#ffe8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M1783.11,376.361c-2.242.559-3.626-4.352-1.125-5.145,2.109-.669,3.639,4.518,1.125,5.145",
    transform: "translate(-1476.199 -307.697)",
    fill: "#2b0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M1755.763,363.875a2.769,2.769,0,0,0,1.933-.488,19.476,19.476,0,0,1,1.72-1.1,3.922,3.922,0,0,1,3.189-.053c1.447.622,2.181,2.89,1.965,2.906a3.51,3.51,0,0,0-2.307-1.27,10.408,10.408,0,0,0-3.308.522,3.558,3.558,0,0,1-3.192-.522",
    transform: "translate(-1455.567 -300.044)",
    fill: "#351601"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M1869.44,836.274a.927.927,0,1,0,.748-1.7c-1.16-.481-1.762,1.377-.748,1.7",
    transform: "translate(-1549.38 -691.818)",
    fill: "#e0d46d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M1881.849,895.539a.927.927,0,1,0,.748-1.7c-1.16-.481-1.762,1.377-.748,1.7",
    transform: "translate(-1559.667 -740.95)",
    fill: "#e0d46d"
  })))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1419",
    "data-name": "Group 1419",
    transform: "translate(267.736 33.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1418",
    "data-name": "Group 1418",
    clipPath: "url(#clip-path-151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2203",
    "data-name": "Rectangle 2203",
    width: 87.732,
    height: 119.666,
    transform: "translate(-36.396 14.059) rotate(-21.14)",
    fill: "url(#linear-gradient-37)"
  })))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421",
    transform: "translate(313.872 37.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1420",
    "data-name": "Group 1420",
    clipPath: "url(#clip-path-152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2204",
    "data-name": "Rectangle 2204",
    width: 88.233,
    height: 113.422,
    transform: "translate(-34.063 13.003) rotate(-21.14)",
    fill: "url(#linear-gradient-38)"
  })))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1423",
    "data-name": "Group 1423",
    transform: "translate(313.502 41.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422",
    clipPath: "url(#clip-path-153)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2205",
    "data-name": "Rectangle 2205",
    width: 56.393,
    height: 72.272,
    transform: "translate(-21.4 8.275) rotate(-21.14)",
    fill: "url(#linear-gradient-39)"
  })))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1425",
    "data-name": "Group 1425",
    transform: "translate(283.362 37.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1424",
    "data-name": "Group 1424",
    clipPath: "url(#clip-path-154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2206",
    "data-name": "Rectangle 2206",
    width: 58.115,
    height: 79.948,
    transform: "translate(-25.064 9.424) rotate(-21.14)",
    fill: "url(#linear-gradient-40)"
  })))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1427",
    "data-name": "Group 1427",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1426",
    "data-name": "Group 1426",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M1731.822,555.2l-.019-.078-5.356.568s1.084,13.484-4.477,13.42-5.235-12.873-5.235-12.873l-9.56.8s-9.118,9.579-8.924,32.415c1.939-1.939,8.725-2.908,11.052-1.745.043-.535.092-1.092.147-1.663a6.724,6.724,0,0,0,1.34.887c1.377,8.136.3,9.432.3,9.432s-9.347,10.09-13.32,18.354a24.71,24.71,0,0,0-2.256,4.318,25.465,25.465,0,0,0-2.028,10.552c23.616,8.582,55.283,8,55.283,8s.9-10.3-1.329-18.409c-4.239-15.438-10.6-16.675-12.926-21.716,1.776-7.341,1.358-16.842.382-24.983,11.709,6.866,30.123,23.949,30.123,23.949s0,.517,8.66,3.49c17.862-9.881-39.552-43.392-41.852-44.726",
    transform: "translate(-1403.921 -460.212)",
    fill: "#fae4c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M1749.85,789.183s-9.661,12.384-10.631,13.892c9.586,7.432,27.682,9.586,41.254,4.093,5.816,10.017,5.709,15.726,5.709,15.726,1.508-1.616.216-11.956-5.924-21.543-12.818-.215-30.408-12.168-30.408-12.168",
    transform: "translate(-1441.851 -654.25)",
    fill: "#d9cbba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M1779.429,671.147c0,.218-4.523,11.719,3.447,12.854,4.6,1.005,6.032-.575,6.032-.575s-11.633,1.939-9.479-12.279",
    transform: "translate(-1474.126 -556.396)",
    fill: "#d9cbba"
  })))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1429",
    "data-name": "Group 1429",
    transform: "translate(330.619 133.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1428",
    "data-name": "Group 1428",
    clipPath: "url(#clip-path-156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2208",
    "data-name": "Rectangle 2208",
    width: 32.829,
    height: 33.653,
    transform: "matrix(0.799, -0.601, 0.601, 0.799, -12.485, 9.325)",
    fill: "url(#linear-gradient-41)"
  })))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M1884.324,699.442s9.981-1.005,9.192-8.976c1.077,5.314-.577,7.563-2.873,8.617-2.657,1.221-6.319.359-6.319.359",
    transform: "translate(-1562.147 -572.412)",
    fill: "#d9cbba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M2183.914,686.839c-.1.143.019.336.145.457.891.857,2.421,1.158,2.772,2.343a.618.618,0,0,1-.072.59.6.6,0,0,1-.348.163,4.272,4.272,0,0,1-2.025-.51c-1.791-.613-3.75.027-5.494.762s-3.552,1.592-5.435,1.405a1,1,0,0,1-.7-.286,1.1,1.1,0,0,1-.185-.5q-.375-1.941-.656-3.9a1.037,1.037,0,0,1,.009-.49c.1-.3.438-.432.736-.531a42.962,42.962,0,0,0,5.424-2,10.684,10.684,0,0,0,4.394-3.655c.624-.973,1.116-2.167,2.182-2.611a3.09,3.09,0,0,1,0,2.094.662.662,0,0,1,.855.472,1.677,1.677,0,0,1-.163,1.083,8.714,8.714,0,0,1-1.559,2.47,10.471,10.471,0,0,1,3.719-.182.888.888,0,0,1,.495.176.635.635,0,0,1-.015.842,1.848,1.848,0,0,1-.788.474l-3.092,1.208a.4.4,0,0,0-.2.125",
    transform: "translate(-1800.543 -562.141)",
    fill: "#b97529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M1865.377,668.36a15.667,15.667,0,0,1-1.5-.854,5.34,5.34,0,0,1-1.64-3.688c.091-1.231.865-2.555-.586-2.355s-1.907,1.307-1.5,2.991c0,0-4.475-4.689-5.246-3.973s2.135,4.751,2.135,4.751-2.935-.465-3.279.192,3.6,2.113,3.6,2.113-3.683.421-3.662,1.2,4.321,1.056,4.321,1.056-1.248,1.042-.921,1.519,1.254.262,3.1-.863q.887.721,1.725,1.372a30.782,30.782,0,0,0,3.453-3.462",
    transform: "translate(-1536.758 -547.492)",
    fill: "#b97529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M1915.575,707.965a8.982,8.982,0,0,0,3.8-3.235c-2.832-1.493-6.209-1.328-9.41-1.256s-6.651-.068-9.2-2c-.31-.235-.68-.511-1.05-.389a1.105,1.105,0,0,0-.349.223,41.554,41.554,0,0,0-3.606,3.4.482.482,0,0,0-.059.811c2.509,2.691,5.151,5.473,8.607,6.734a3.35,3.35,0,0,0,.945.23,3.312,3.312,0,0,0,1.044-.147,19.617,19.617,0,0,0,3.206-1.262q3.085-1.45,6.068-3.107",
    transform: "translate(-1571.424 -581.187)",
    fill: "#96e6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M1786.771,756.134a2.737,2.737,0,0,0,.154,2.356c.58.723,1.669.655,2.581.819a30.479,30.479,0,0,1,3.583,1.382,11.99,11.99,0,0,0,2.481.414,37.358,37.358,0,0,0,6.651.214,13.217,13.217,0,0,0,6.277-2.014,8.088,8.088,0,0,0,3.6-5.379,1.78,1.78,0,0,0-.459-1.724,1.8,1.8,0,0,0-1.27-.212,20.217,20.217,0,0,0-4.159,1.147,21.253,21.253,0,0,1-7.934,1.291,11.062,11.062,0,0,1-7.284-3.07,2.19,2.19,0,0,0-.582-.487,1.282,1.282,0,0,0-.757-.086,2.5,2.5,0,0,0-1.674,1.269,7.413,7.413,0,0,0-.712,2.042l-.494,2.037",
    transform: "translate(-1481.117 -622.401)",
    fill: "#96e6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M1812.036,726.973a7.211,7.211,0,0,0,2.334,1.785,3.144,3.144,0,0,0,2.955-.505,8.486,8.486,0,0,0,1.618-1.794c1.6-2.177,3.2-4.486,5.546-5.827a17.792,17.792,0,0,1,2.023-.941c1.858-.771,3.737-1.753,5.658-2.346.648-.2,1.3-.188,1.941-.425a31.1,31.1,0,0,0,2.871-1.275,32.474,32.474,0,0,1,5-2.227,7.3,7.3,0,0,1,5.346.241c1.8.926,2.967,2.847,4.825,3.657a6.749,6.749,0,0,0,2.763.475c4.674-.044,8.975-2.806,13.645-3a9.053,9.053,0,0,0,1.748,6.645,56.962,56.962,0,0,0-17.972,8.376c-1.733,1.215-3.4,2.53-5.243,3.574a36.381,36.381,0,0,1-10.824,3.59c-7.849,1.6-16.189,2.446-23.717-.289a26.212,26.212,0,0,1-5.272-2.62c-1.639-1.059-3.291-2.547-3.386-4.5a4.118,4.118,0,0,1,3.1-3.953,5.659,5.659,0,0,1,5.04,1.357",
    transform: "translate(-1495.468 -591.118)",
    fill: "#96e6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M1992.588,659.923s-4.329.2-4.063-4.107,3.574-3.352,4.6-.422c-.489,4.13-.533,4.529-.533,4.529",
    transform: "translate(-1648.522 -541.258)",
    fill: "#7a4a1b"
  })))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433",
    transform: "translate(341.453 95.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432",
    clipPath: "url(#clip-path-158)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2210",
    "data-name": "Rectangle 2210",
    width: 33.716,
    height: 35.99,
    transform: "translate(-1.678 0.062) rotate(-2.437)",
    fill: "url(#linear-gradient-42)"
  })))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1435",
    "data-name": "Group 1435",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1434",
    "data-name": "Group 1434",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M2052.5,650.736s0,2.341-1.9,3.01-2.453,1.17-2.174,1.839,3.213,1.7,4.3.325c2.449-3.095.551-6.345-.229-5.174",
    transform: "translate(-1698.135 -539.272)",
    fill: "#a8591f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M2026.623,616.974c-.133.533-.255.749-.378,1.132a27.986,27.986,0,0,0-4.265-.183l-.085-.171s2.847-1.128,4.728-.778",
    transform: "translate(-1676.196 -511.429)",
    fill: "#552f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M2117.581,625.08c-.074.544-.041.791-.071,1.192,1.48.3,4.426,1.049,4.426,1.049l-.4-.373a12.445,12.445,0,0,0-3.951-1.868",
    transform: "translate(-1755.463 -518.205)",
    fill: "#552f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M2104.744,657.865s-.533-3.53.7-4.962,5.173-.341,5.425,1.739-.532,4-1.764,4.1c-1.6-.267-4.36-.873-4.36-.873",
    transform: "translate(-1744.784 -540.732)",
    fill: "#f7f5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M2112.127,663.135c-1.166-.167-1.932-1.465-1.732-3.2.182-1.577.9-2.864,2.5-2.431s1.7,2.531,1.565,3.5-.993,2.323-2.331,2.131",
    transform: "translate(-1749.539 -545.018)",
    fill: "#412128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M2018.128,644.369s1.548-3.217.791-4.948-3.345-1-4.477.061a2.753,2.753,0,0,0-.067,3.976,26.476,26.476,0,0,1,3.753.911",
    transform: "translate(-1669.274 -529.233)",
    fill: "#f7f5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M2026.441,643.631c.833.122,1.51,1.243,1.166,3.219-.266,1.528-1.088,2.376-2.187,2.109s-1.464-1.4-1.288-2.842c.222-1.82.765-2.713,2.309-2.487",
    transform: "translate(-1678.016 -533.556)",
    fill: "#412128"
  })))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1440",
    "data-name": "Group 1440",
    transform: "translate(357.683 116.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1439",
    "data-name": "Group 1439",
    clipPath: "url(#clip-path-160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1438",
    "data-name": "Group 1438",
    transform: "translate(-0.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1437",
    "data-name": "Group 1437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1436",
    "data-name": "Group 1436",
    clipPath: "url(#clip-path-161)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2212",
    "data-name": "Rectangle 2212",
    width: 8.371,
    height: 3.939,
    transform: "translate(-0.01 -0.063)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1445",
    "data-name": "Group 1445",
    transform: "translate(343.781 114.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444",
    clipPath: "url(#clip-path-162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1443",
    "data-name": "Group 1443",
    transform: "translate(-0.012 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1442",
    "data-name": "Group 1442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1441",
    "data-name": "Group 1441",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2214",
    "data-name": "Rectangle 2214",
    width: 5.827,
    height: 2.872,
    transform: "translate(-0.063 -0.06)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1447",
    "data-name": "Group 1447",
    transform: "translate(367.145 118.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1446",
    "data-name": "Group 1446",
    clipPath: "url(#clip-path-164)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2216",
    "data-name": "Rectangle 2216",
    width: 7.658,
    height: 8.064,
    transform: "translate(-0.311 7.321) rotate(-87.563)",
    fill: "url(#linear-gradient-43)"
  })))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1449",
    "data-name": "Group 1449",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1448",
    "data-name": "Group 1448",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M2154.508,702.158s2.664-1.2,3.375.355-1.421,3.685-4.13,2.353c1.11-.133,3.2-.178,2.886-1.776-.207-1.062-2.131-.933-2.131-.933",
    transform: "translate(-1785.509 -581.739)",
    fill: "#a76925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M2033.842,542.32a3.205,3.205,0,0,0,.477-2.6,2.6,2.6,0,0,0-.615-1.413,1.343,1.343,0,0,0-.376-.263,3.353,3.353,0,0,0,.292-1.9,1.536,1.536,0,0,0-.816-1.307,1.257,1.257,0,0,0,.4-.648,1.569,1.569,0,0,0-.356-1.34,1.889,1.889,0,0,0-1.486-.638,1.23,1.23,0,0,0,.181-.62,2.008,2.008,0,0,0-3.121-1.763,1.718,1.718,0,0,0-.231-.023,1.343,1.343,0,0,0,.134-.775,1.939,1.939,0,0,0-.415-.885,2.061,2.061,0,0,0-1.99-.906c-.236.118-.492.222-.736.332a3.02,3.02,0,0,0,.061-1.933,1.97,1.97,0,0,0-1.233-1.147,1.731,1.731,0,0,0-1.181.108,2.417,2.417,0,0,0-.722-1.347c-1.032-.924-2.064-.476-2.937.545a1.342,1.342,0,0,0-1.132-.922,1.627,1.627,0,0,0-1.451,1.11,1.522,1.522,0,0,0-.006-.156,2.316,2.316,0,0,0-2.689-1.975,2.155,2.155,0,0,0-1.388.9c-.143.209-.685,1.306-.454,1.519a1.609,1.609,0,0,0-2.628.242c-2.7-2.295-5.6.584-5.978,2.237a1.191,1.191,0,0,0-1.362-.573,2.556,2.556,0,0,0-1.31.958,3.156,3.156,0,0,0-.829,2.183,1.764,1.764,0,0,0,.3.825c-1.368.452-.876,1.057-.735,2.6-1.554,1.344-1.806,3.235-.42,4.369-1.428.336-2.268,3.277-1.26,4.159a4.311,4.311,0,0,0,.8,4.551c1.432-1.432,1.417-3.51,1.551-4.893a16.841,16.841,0,0,1,1.3-5.289c.347-.712,2.295-3.267,1.58-3.8-.154-.127.007,0-.018-.016.629.476,1.63.084,2.266-.177a3.84,3.84,0,0,0,2.1-2.939s-.084.5,1.68.756a2.139,2.139,0,0,0,2.353-1.008,4.386,4.386,0,0,0,1.764,2.1c1.344.84,3.277-.5,3.277-.5s-1.26,1.428-.252,2.688,2.772.924,2.856-1.092a1.261,1.261,0,0,0,2.185.756c-.672,2.184,1.848,2.52,2.353,1.26-.084,1.26,1.176,2.857,2.016,2.352a2.308,2.308,0,0,0,1.26,2.857c-1.68,1.26-1.26,4.537.084,5.377-.672.168-1.092,2.016-.5,3.193-1.008.084-1.512,2.52-.924,3.7a1.178,1.178,0,0,0,.756,2.016,2.068,2.068,0,0,0,1.709-.582.714.714,0,0,0,.668-.021,1.207,1.207,0,0,0,.417-.868.549.549,0,0,0,.481.094,3.628,3.628,0,0,0,2.261-2.427.682.682,0,0,0-.059-.632.221.221,0,0,0-.056-.044,4.006,4.006,0,0,0,2.051-2.984,1.55,1.55,0,0,0-.615-1.614c-.01-.005-.021-.008-.032-.012a3.328,3.328,0,0,0,.243-1.373,1.625,1.625,0,0,0,.468-.378",
    transform: "translate(-1655.873 -432.592)",
    fill: "#2b180f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M2027.443,678.844c-4.829,2.423-.512,10.868,4.618,8.773,6.134-2.5.9-11.541-4.618-8.773",
    transform: "translate(-1679.052 -562.344)",
    fill: "#cbd476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M2035.06,693.351c-2.351,1.966,1.075,6.117,3.291,3.719,2.177-2.356-1.135-5.523-3.291-3.719",
    transform: "translate(-1686.455 -574.362)",
    fill: "#9ea650"
  })))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1451",
    "data-name": "Group 1451",
    transform: "translate(294.233 126.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1450",
    "data-name": "Group 1450",
    clipPath: "url(#clip-path-166)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2218",
    "data-name": "Rectangle 2218",
    width: 49.352,
    height: 42.959,
    transform: "matrix(0.838, -0.545, 0.545, 0.838, -10.752, 6.674)",
    fill: "url(#linear-gradient-44)"
  })))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1453",
    "data-name": "Group 1453",
    transform: "translate(326.407 133.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1452",
    "data-name": "Group 1452",
    clipPath: "url(#clip-path-167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2219",
    "data-name": "Rectangle 2219",
    width: 49.326,
    height: 31.156,
    transform: "translate(-6.189 1.992) rotate(-21.315)",
    fill: "url(#linear-gradient-45)"
  })))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1455",
    "data-name": "Group 1455",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    "data-name": "Group 1454",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M2157.6,1732.239v1.673s-2.745,1.729-5.24,1.171c0-.892,2.935-1.9,2.935-1.9l.246-1.338Z",
    transform: "translate(-1784.354 -1435.741)",
    fill: "#00b4ca"
  })))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1457",
    "data-name": "Group 1457",
    transform: "translate(369.046 260.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1456",
    "data-name": "Group 1456",
    clipPath: "url(#clip-path-169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2221",
    "data-name": "Rectangle 2221",
    width: 37.014,
    height: 10.106,
    transform: "translate(-0.286 36.937) rotate(-89.556)",
    fill: "url(#linear-gradient-46)"
  })))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1459",
    "data-name": "Group 1459",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1458",
    "data-name": "Group 1458",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M2096.445,1731.864v1.673s-2.73,1.729-5.224,1.171c0-.892,2.943-1.9,2.943-1.9l.234-1.338Z",
    transform: "translate(-1733.669 -1435.43)",
    fill: "#00b4ca"
  })))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1461",
    "data-name": "Group 1461",
    transform: "translate(359.119 261.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1460",
    "data-name": "Group 1460",
    clipPath: "url(#clip-path-171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2223",
    "data-name": "Rectangle 2223",
    width: 36.168,
    height: 8.655,
    transform: "translate(-1.694 36.102) rotate(-89.556)",
    fill: "url(#linear-gradient-47)"
  })))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1462",
    "data-name": "Group 1462",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M2071.848,1542.146l-.3,2.226s7.171,4.2,24.884,3.569c-.128-3.653-.256-4.409-.256-4.409Z",
    transform: "translate(-1717.36 -1278.473)",
    fill: "#ff4c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M2077.049,1322.11c-.448,6.677-1.549,14.558-5.25,30.233,12.2,3.372,24.955,2.043,24.955,2.043s1.551-21.065-2.888-32.822c-2.9-6.215-3.814-7.9-5.837-8.958s-10.1-3.633-10.98,9.5",
    transform: "translate(-1717.568 -1087.41)",
    fill: "#00b4ca"
  })))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1465",
    "data-name": "Group 1465",
    transform: "translate(347.683 244.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464",
    clipPath: "url(#clip-path-173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2225",
    "data-name": "Rectangle 2225",
    width: 25.544,
    height: 15.399,
    transform: "translate(-7.628 21.779) rotate(-71.533)",
    fill: "url(#linear-gradient-48)"
  })))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1466",
    "data-name": "Group 1466",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M2050.135,1458.6a12.449,12.449,0,0,0-.544,3.549c-1.828-.205-4.475-.236-4.475-.236a30.079,30.079,0,0,1,.345-3.894c2.129-.791,4.674.581,4.674.581",
    transform: "translate(-1695.447 -1208.531)",
    fill: "#ff4c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M2063.219,1296.325s-14.532,6.155-17.477,29.353a27.14,27.14,0,0,1,4.585.446s2.058-14.139,8.154-22.549a36.183,36.183,0,0,1,4.738-7.251",
    transform: "translate(-1695.966 -1074.682)",
    fill: "#00b4ca"
  })))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469",
    transform: "translate(380.535 244.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468",
    clipPath: "url(#clip-path-175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2227",
    "data-name": "Rectangle 2227",
    width: 15.399,
    height: 25.543,
    transform: "translate(-7.354 2.429) rotate(-18.467)",
    fill: "url(#linear-gradient-49)"
  })))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1471",
    "data-name": "Group 1471",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1470",
    "data-name": "Group 1470",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M2229.8,1461.435a12.451,12.451,0,0,1,.543,3.549c1.828-.205,4.475-.236,4.475-.236a30.034,30.034,0,0,0-.345-3.894c-2.129-.791-4.674.581-4.674.581",
    transform: "translate(-1848.551 -1210.877)",
    fill: "#ff4c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M2156.3,1299.155s14.532,6.155,17.477,29.353a27.13,27.13,0,0,0-4.585.447s-2.058-14.139-8.154-22.549a36.168,36.168,0,0,0-4.738-7.251",
    transform: "translate(-1787.625 -1077.028)",
    fill: "#00b4ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M2149.5,1350.391c3.62-8.9-3.3-18.981-3.594-19.406l-.634.428c.071.1,6.981,10.173,3.515,18.7Z",
    transform: "translate(-1778.476 -1103.416)",
    fill: "#ff4c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M2128.438,1349.567c4.673-7.957,1.831-21.235,1.707-21.8l-.751.16c.03.135,2.9,13.555-1.622,21.258Z",
    transform: "translate(-1763.97 -1100.752)",
    fill: "#ff4c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M2118.679,1305.573c-2.689-.189-4.391-.507-5.16-2.522,1.823-1.851,3.688-4.036,7.352-3.587a12.438,12.438,0,0,1,8.813,5.545l.114,1.938s-2.28-2.451-3.458-3.491a10.854,10.854,0,0,1-7.662,2.117",
    transform: "translate(-1752.154 -1077.235)",
    fill: "#ff4c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M2114.387,1481.558s1.9,8.08,1.9,10.422c-6.19.585-14.879-.937-15.117-1.64,1.19-4.684,2.023-9.485,2.023-9.485s9.4,1.405,11.189.7",
    transform: "translate(-1741.92 -1227.662)",
    fill: "#0094b0"
  })))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473",
    transform: "translate(364.698 215.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1472",
    "data-name": "Group 1472",
    clipPath: "url(#clip-path-177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2229",
    "data-name": "Rectangle 2229",
    width: 10.116,
    height: 12.675,
    transform: "translate(-3.264 0.836) rotate(-15.945)",
    fill: "url(#linear-gradient-50)"
  })))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1475",
    "data-name": "Group 1475",
    transform: "translate(347.407 180.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1474",
    "data-name": "Group 1474",
    clipPath: "url(#clip-path-178)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2230",
    "data-name": "Rectangle 2230",
    width: 45.424,
    height: 40.869,
    transform: "translate(-2.533 -0.002)",
    fill: "url(#linear-gradient-51)"
  })))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1480",
    "data-name": "Group 1480",
    transform: "translate(347.978 209.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1479",
    "data-name": "Group 1479",
    clipPath: "url(#clip-path-179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1478",
    "data-name": "Group 1478",
    transform: "translate(-0.014 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1476",
    "data-name": "Group 1476",
    clipPath: "url(#clip-path-180)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2231",
    "data-name": "Rectangle 2231",
    width: 6.648,
    height: 3.447,
    transform: "translate(-0.072 -0.007)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1485",
    "data-name": "Group 1485",
    transform: "translate(361.868 210.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1484",
    "data-name": "Group 1484",
    clipPath: "url(#clip-path-181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    "data-name": "Group 1483",
    transform: "translate(-0.018 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1482",
    "data-name": "Group 1482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1481",
    "data-name": "Group 1481",
    clipPath: "url(#clip-path-182)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2233",
    "data-name": "Rectangle 2233",
    width: 8.371,
    height: 4.186,
    transform: "translate(-0.006 -0.046)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1487",
    "data-name": "Group 1487",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1486",
    "data-name": "Group 1486",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M2041.292,1134.048a10.823,10.823,0,0,1,4.83-.893c-.186-1.271-.274-2.215-.274-2.215s-3.619.619-4.556,3.108",
    transform: "translate(-1692.277 -937.574)",
    fill: "#552f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M2146.871,1138.522s-4.6-1.015-7.3-.2a10.366,10.366,0,0,1,.329-2.333s5.775.626,6.972,2.532",
    transform: "translate(-1773.751 -941.761)",
    fill: "#552f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M2125.594,1188.086c1.809.3,4.882-.708,4.123-6.942-2.3-2.174-5.845-1.682-6.642.309s-.644,6.1,2.519,6.632",
    transform: "translate(-1759.74 -978.016)",
    fill: "#f6f4f3"
  })))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1489",
    "data-name": "Group 1489",
    transform: "translate(362.929 201.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1488",
    "data-name": "Group 1488",
    clipPath: "url(#clip-path-184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M2127.508,1191.864c.2,2.115-.952,3.948-2.565,4.093s-3.082-1.451-3.279-3.566.951-3.947,2.565-4.093,3.082,1.451,3.279,3.566",
    transform: "translate(-2121.817 -1186.888)",
    fill: "#412128"
  })))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1491",
    "data-name": "Group 1491",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1490",
    "data-name": "Group 1490",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M2051.173,1179.967a9.8,9.8,0,0,1-.406,6.282c-2.317.366-4.866-.516-4.137-4.26.813-3.126,3.621-4.271,4.544-2.022",
    transform: "translate(-1696.596 -977.245)",
    fill: "#f6f4f3"
  })))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493",
    transform: "translate(349.906 201.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1492",
    "data-name": "Group 1492",
    clipPath: "url(#clip-path-186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M2056.1,1193.3c.056,2.123-.96,3.871-2.27,3.905s-2.418-1.66-2.474-3.783.96-3.872,2.27-3.905,2.418,1.66,2.474,3.783",
    transform: "translate(-2050.524 -1187.683)",
    fill: "#412128"
  })))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1495",
    "data-name": "Group 1495",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1494",
    "data-name": "Group 1494",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M2067.771,1202.1s.688,3.514-1.261,3.5-2.2.265-2.512.776,1.118,1.612,2.536,1.609a2.648,2.648,0,0,0,2.989-2.388c.5-2.771-1.705-4.654-1.751-3.493",
    transform: "translate(-1711.064 -996.282)",
    fill: "#9a5a16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M2073.575,1249.008a29.879,29.879,0,0,0,5.417-1.337c1.542-.6,2.587-.055,2.29,1.061a6.329,6.329,0,0,1-5.56,3.908c-3.271.1-6.286-2.141-5.9-3.227s1.336-.013,3.757-.4",
    transform: "translate(-1715.898 -1034.143)",
    fill: "#7f3421"
  })))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1497",
    "data-name": "Group 1497",
    transform: "translate(353.887 213.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1496",
    "data-name": "Group 1496",
    clipPath: "url(#clip-path-188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M2079.512,1244.756s2.019,2.372,4.586,1.562a5.188,5.188,0,0,0,3.225-3.487Z",
    transform: "translate(-2077.849 -1243.616)",
    fill: "#f6f4f3"
  })))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1499",
    "data-name": "Group 1499",
    transform: "translate(349.464 173.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    "data-name": "Group 1498",
    clipPath: "url(#clip-path-189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2238",
    "data-name": "Rectangle 2238",
    width: 55.902,
    height: 57.679,
    transform: "matrix(0.392, -0.92, 0.92, 0.392, -15.163, 35.222)",
    fill: "url(#linear-gradient-52)"
  })))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1501",
    "data-name": "Group 1501",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M2210.23,1213.164s7.02-3.124,7.959.776-3.847,8.374-8.608,5.989a64.689,64.689,0,0,0,.648-6.765",
    transform: "translate(-1831.793 -1004.758)",
    fill: "#ba7329"
  })))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503",
    transform: "translate(378.632 208.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1502",
    "data-name": "Group 1502",
    clipPath: "url(#clip-path-191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2240",
    "data-name": "Rectangle 2240",
    width: 5.977,
    height: 6.58,
    transform: "translate(-0.37 5.55) rotate(-86.183)",
    fill: "url(#linear-gradient-53)"
  })))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505",
    transform: "translate(200.889 234.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504",
    clipPath: "url(#clip-path-192)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2241",
    "data-name": "Rectangle 2241",
    width: 44.791,
    height: 46.326,
    transform: "translate(-0.16)",
    fill: "url(#linear-gradient-54)"
  })))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1507",
    "data-name": "Group 1507",
    transform: "translate(176.785 220.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1506",
    "data-name": "Group 1506",
    clipPath: "url(#clip-path-193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2242",
    "data-name": "Rectangle 2242",
    width: 58.63,
    height: 58.19,
    transform: "translate(-0.201)",
    fill: "url(#linear-gradient-55)"
  })))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1509",
    "data-name": "Group 1509",
    transform: "translate(207.736 260.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1508",
    "data-name": "Group 1508",
    clipPath: "url(#clip-path-194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2243",
    "data-name": "Rectangle 2243",
    width: 10.602,
    height: 11.197,
    transform: "translate(0)",
    fill: "url(#linear-gradient-56)"
  })))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1511",
    "data-name": "Group 1511",
    transform: "translate(204.19 228.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1510",
    "data-name": "Group 1510",
    clipPath: "url(#clip-path-195)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2244",
    "data-name": "Rectangle 2244",
    width: 44.54,
    height: 40.597,
    transform: "translate(-2.734 0)",
    fill: "url(#linear-gradient-57)"
  })))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1513",
    "data-name": "Group 1513",
    transform: "translate(216.14 255.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1512",
    "data-name": "Group 1512",
    clipPath: "url(#clip-path-196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2245",
    "data-name": "Rectangle 2245",
    width: 5.871,
    height: 2.987,
    transform: "translate(-0.049)",
    fill: "url(#linear-gradient-58)"
  })))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1515",
    "data-name": "Group 1515",
    transform: "translate(233.57 256.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1514",
    "data-name": "Group 1514",
    clipPath: "url(#clip-path-197)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2246",
    "data-name": "Rectangle 2246",
    width: 5.871,
    height: 2.987,
    transform: "translate(-0.049)",
    fill: "url(#linear-gradient-59)"
  })))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1517",
    "data-name": "Group 1517",
    transform: "translate(227.152 250.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1516",
    "data-name": "Group 1516",
    clipPath: "url(#clip-path-198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2247",
    "data-name": "Rectangle 2247",
    width: 5.626,
    height: 8.66,
    transform: "translate(-0.151)",
    fill: "url(#linear-gradient-60)"
  })))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1519",
    "data-name": "Group 1519",
    transform: "translate(215.758 241.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1518",
    "data-name": "Group 1518",
    clipPath: "url(#clip-path-199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2248",
    "data-name": "Rectangle 2248",
    width: 8.167,
    height: 3.482,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-61)"
  })))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1521",
    "data-name": "Group 1521",
    transform: "translate(234.115 242.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1520",
    "data-name": "Group 1520",
    clipPath: "url(#clip-path-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2249",
    "data-name": "Rectangle 2249",
    width: 3.957,
    height: 3.059,
    transform: "translate(0)",
    fill: "url(#linear-gradient-62)"
  })))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1523",
    "data-name": "Group 1523",
    transform: "translate(215.982 247.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1522",
    "data-name": "Group 1522",
    clipPath: "url(#clip-path-201)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2250",
    "data-name": "Rectangle 2250",
    width: 8.809,
    height: 9.022,
    transform: "translate(-0.552)",
    fill: "url(#linear-gradient-63)"
  })))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1525",
    "data-name": "Group 1525",
    transform: "translate(216.539 248.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1524",
    "data-name": "Group 1524",
    clipPath: "url(#clip-path-202)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2251",
    "data-name": "Rectangle 2251",
    width: 6.607,
    height: 7.34,
    transform: "translate(-0.508)",
    fill: "url(#linear-gradient-64)"
  })))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1527",
    "data-name": "Group 1527",
    transform: "translate(232.619 248.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1526",
    "data-name": "Group 1526",
    clipPath: "url(#clip-path-203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2252",
    "data-name": "Rectangle 2252",
    width: 6.592,
    height: 8.481,
    transform: "translate(-0.844)",
    fill: "url(#linear-gradient-65)"
  })))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1529",
    "data-name": "Group 1529",
    transform: "translate(232.408 249.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1528",
    "data-name": "Group 1528",
    clipPath: "url(#clip-path-204)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2253",
    "data-name": "Rectangle 2253",
    width: 4.961,
    height: 6.869,
    transform: "translate(-0.166 0)",
    fill: "url(#linear-gradient-66)"
  })))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1531",
    "data-name": "Group 1531",
    transform: "translate(219.651 259.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1530",
    "data-name": "Group 1530",
    clipPath: "url(#clip-path-205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2254",
    "data-name": "Rectangle 2254",
    width: 10.373,
    height: 5.953,
    fill: "url(#linear-gradient-67)"
  })))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1533",
    "data-name": "Group 1533",
    transform: "translate(222.369 262.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1532",
    "data-name": "Group 1532",
    clipPath: "url(#clip-path-206)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2255",
    "data-name": "Rectangle 2255",
    width: 5.337,
    height: 3.675,
    transform: "translate(-0.201 0)",
    fill: "url(#linear-gradient-68)"
  })))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1535",
    "data-name": "Group 1535",
    transform: "translate(204.66 229.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1534",
    "data-name": "Group 1534",
    clipPath: "url(#clip-path-207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2256",
    "data-name": "Rectangle 2256",
    width: 33.604,
    height: 24.086,
    transform: "translate(-1.033)",
    fill: "url(#linear-gradient-69)"
  })))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1537",
    "data-name": "Group 1537",
    transform: "translate(203.001 228.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1536",
    "data-name": "Group 1536",
    clipPath: "url(#clip-path-208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2257",
    "data-name": "Rectangle 2257",
    width: 34,
    height: 24.135,
    transform: "translate(-2.242 0)",
    fill: "url(#linear-gradient-70)"
  })))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1539",
    "data-name": "Group 1539",
    transform: "translate(207.723 225.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1538",
    "data-name": "Group 1538",
    clipPath: "url(#clip-path-209)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2258",
    "data-name": "Rectangle 2258",
    width: 8.261,
    height: 12.727,
    transform: "translate(-1.49)",
    fill: "url(#linear-gradient-71)"
  })))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1541",
    "data-name": "Group 1541",
    transform: "translate(202.623 236.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1540",
    "data-name": "Group 1540",
    clipPath: "url(#clip-path-210)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2259",
    "data-name": "Rectangle 2259",
    width: 10.096,
    height: 7.122,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-72)"
  })))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1543",
    "data-name": "Group 1543",
    transform: "translate(200.86 248.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1542",
    "data-name": "Group 1542",
    clipPath: "url(#clip-path-211)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2260",
    "data-name": "Rectangle 2260",
    width: 9.186,
    height: 8.616,
    transform: "translate(-1.686 0)",
    fill: "url(#linear-gradient-73)"
  })))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1545",
    "data-name": "Group 1545",
    transform: "translate(202.453 250.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1544",
    "data-name": "Group 1544",
    clipPath: "url(#clip-path-212)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2261",
    "data-name": "Rectangle 2261",
    width: 5.037,
    height: 4.768,
    transform: "translate(-1.001)",
    fill: "url(#linear-gradient-74)"
  })))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1547",
    "data-name": "Group 1547",
    transform: "translate(217.42 293.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1546",
    "data-name": "Group 1546",
    clipPath: "url(#clip-path-213)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2262",
    "data-name": "Rectangle 2262",
    width: 21.105,
    height: 11.825,
    transform: "translate(-1.036)",
    fill: "url(#linear-gradient-75)"
  })))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1549",
    "data-name": "Group 1549",
    transform: "translate(207.932 293.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1548",
    "data-name": "Group 1548",
    clipPath: "url(#clip-path-214)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2263",
    "data-name": "Rectangle 2263",
    width: 14.698,
    height: 10.444,
    transform: "translate(0)",
    fill: "url(#linear-gradient-76)"
  })))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1551",
    "data-name": "Group 1551",
    transform: "translate(234.734 300.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1550",
    "data-name": "Group 1550",
    clipPath: "url(#clip-path-215)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2264",
    "data-name": "Rectangle 2264",
    width: 11.426,
    height: 7.158,
    transform: "translate(-0.488)",
    fill: "url(#linear-gradient-77)"
  })))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1553",
    "data-name": "Group 1553",
    transform: "translate(195.721 268.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1552",
    "data-name": "Group 1552",
    clipPath: "url(#clip-path-216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2265",
    "data-name": "Rectangle 2265",
    width: 21.129,
    height: 43.784,
    fill: "url(#linear-gradient-78)"
  })))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1555",
    "data-name": "Group 1555",
    transform: "translate(229.267 296.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1554",
    "data-name": "Group 1554",
    clipPath: "url(#clip-path-217)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2266",
    "data-name": "Rectangle 2266",
    width: 14.166,
    height: 12.915,
    transform: "translate(-0.186)",
    fill: "url(#linear-gradient-79)"
  })))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1557",
    "data-name": "Group 1557",
    transform: "translate(195.955 283.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1556",
    "data-name": "Group 1556",
    clipPath: "url(#clip-path-218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2267",
    "data-name": "Rectangle 2267",
    width: 38.113,
    height: 31.3,
    transform: "translate(-0.2)",
    fill: "url(#linear-gradient-80)"
  })))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1559",
    "data-name": "Group 1559",
    transform: "translate(204.104 303.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1558",
    "data-name": "Group 1558",
    clipPath: "url(#clip-path-219)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2268",
    "data-name": "Rectangle 2268",
    width: 29.401,
    height: 5.145,
    fill: "url(#linear-gradient-81)"
  })))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1561",
    "data-name": "Group 1561",
    transform: "translate(196.149 301.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1560",
    "data-name": "Group 1560",
    clipPath: "url(#clip-path-220)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2269",
    "data-name": "Rectangle 2269",
    width: 20.045,
    height: 4.846,
    fill: "url(#linear-gradient-82)"
  })))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1563",
    "data-name": "Group 1563",
    transform: "translate(214.92 302.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1562",
    "data-name": "Group 1562",
    clipPath: "url(#clip-path-221)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2270",
    "data-name": "Rectangle 2270",
    width: 2.263,
    height: 5.887,
    fill: "url(#linear-gradient-83)"
  })))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1565",
    "data-name": "Group 1565",
    transform: "translate(224.71 313.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1564",
    "data-name": "Group 1564",
    clipPath: "url(#clip-path-222)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2271",
    "data-name": "Rectangle 2271",
    width: 8.512,
    height: 4.922,
    transform: "translate(-0.265)",
    fill: "url(#linear-gradient-84)"
  })))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1567",
    "data-name": "Group 1567",
    transform: "translate(214.677 282.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1566",
    "data-name": "Group 1566",
    clipPath: "url(#clip-path-223)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2272",
    "data-name": "Rectangle 2272",
    width: 12.721,
    height: 32.453,
    transform: "translate(0)",
    fill: "url(#linear-gradient-85)"
  })))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1569",
    "data-name": "Group 1569",
    transform: "translate(213.501 270.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1568",
    "data-name": "Group 1568",
    clipPath: "url(#clip-path-224)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2273",
    "data-name": "Rectangle 2273",
    width: 7.979,
    height: 18.162,
    transform: "translate(-1.631)",
    fill: "url(#linear-gradient-86)"
  })))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1571",
    "data-name": "Group 1571",
    transform: "translate(195.958 270.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570",
    clipPath: "url(#clip-path-225)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2274",
    "data-name": "Rectangle 2274",
    width: 20.958,
    height: 34.079,
    transform: "translate(-0.196)",
    fill: "url(#linear-gradient-87)"
  })))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1573",
    "data-name": "Group 1573",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M1218.8,1395.264a.921.921,0,0,1-.339-.484c-.03-.243.169-.445.277-.664.343-.695-.256-1.492-.9-1.923s-1.43-.786-1.714-1.507c.8-.2,1.735-.511,1.964-1.3a1.522,1.522,0,0,0-.7-1.6c.173-.09.343-.187.508-.294a1.85,1.85,0,0,0,.932-1.184,1.686,1.686,0,0,0-1.2-1.618c-.672-.27-1.419-.312-2.09-.583a2.676,2.676,0,0,1,1.221-.883c.451-.238.913-.649.854-1.156-.078-.664-.909-.874-1.536-1.107a.719.719,0,0,1-.307-.185c-.314-.367.184-.849.494-1.22a1.752,1.752,0,0,0-.162-2.332,6.9,6.9,0,0,0-1.575-.808c-.526-.272-1.021-.815-.882-1.391.223-.923,1.763-.983,2-1.9a1.578,1.578,0,0,0-.595-1.383,10.557,10.557,0,0,0-8.3-2.913,15.239,15.239,0,0,0-8.243,3.473,12.448,12.448,0,0,0-3.225,3.7,12.5,12.5,0,0,0-2.232-.4,2.278,2.278,0,0,0-1.633.31c-.518.412-.65,1.186-1.186,1.575-.63.457-1.5.192-2.261.042a3.868,3.868,0,0,0-2.078.089,2.141,2.141,0,0,0-1.381,1.473,4.688,4.688,0,0,0-4.217,1.068,1.088,1.088,0,0,0-.411.665c-.045.529.578.912.606,1.442.029.553-.561.9-1.023,1.2s-.885.967-.494,1.36c.17.171.437.208.623.362.46.383.1,1.185-.442,1.436a13.892,13.892,0,0,1-1.748.375c-.571.179-1.108.8-.829,1.332.224.426.822.5,1.14.857.578.658-.112,1.659-.826,2.167s-1.6,1.161-1.421,2.018c.237,1.118,2.165,1.475,1.993,2.6-.094.62-.854,1.055-.765,1.677.123.86,1.693.938,1.714,1.808a5.155,5.155,0,0,0-2.34.292,1.767,1.767,0,0,0-1.09,1.9,2.116,2.116,0,0,0,.573.9,5.9,5.9,0,0,0,2.337,1.48c.668.227,1.543.534,1.524,1.239a1.708,1.708,0,0,1-.2.629,1.7,1.7,0,0,0,.024,1.763c.519.6,1.486.375,2.231.1s1.712-.508,2.232.094c.575.666.232,2,1.058,2.305.606.22,1.161-.409,1.495-.961s.856-1.195,1.475-1.013c.714.21.685,1.139,1.2,1.553.707.573,2.107-1.159,2.422.26.2.926.131,2.852,1.123,3.375.564.3,1.245-.093,1.7-.542a5.861,5.861,0,0,0,1.167-1.646,5.239,5.239,0,0,0,.115,2.6,1.571,1.571,0,0,0,.617.941c.666.391,1.525-.214,1.819-.929s.265-1.527.533-2.252a4.544,4.544,0,0,0,.5,1.635,1.543,1.543,0,0,0,1.414.8c.922-.11,1.327-1.229,1.368-2.157s-.041-1.976.593-2.654a.363.363,0,0,1,.214-.133c.154-.016.267.137.335.277.26.539.344,1.155.642,1.674a1.249,1.249,0,0,0,1.485.675c.885-.42.459-1.945,1.215-2.568.2.626.611,1.337,1.27,1.339a1.171,1.171,0,0,0,1.037-.969,3.423,3.423,0,0,0-.123-1.516l-.482-2.05a4.426,4.426,0,0,1,1.179,1.076,1.377,1.377,0,0,0,1.431.482c.694-.3.631-1.294.45-2.028.317.447.836.952,1.324.7.668-.338.159-1.386.4-2.1a1.558,1.558,0,0,0,2.014.79,2.669,2.669,0,0,0,1.462-1.818,2.6,2.6,0,0,0-.129-1.759,1.749,1.749,0,0,0,1.744-.305,1.788,1.788,0,0,0-.236-2.687,1.534,1.534,0,0,0,1.79-.945,1.985,1.985,0,0,0-.508-2.047",
    transform: "translate(-974.054 -1134.755)",
    fill: "#1d1a15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M1092.334,1300.644a2.145,2.145,0,0,0-1.32-1.926,2.5,2.5,0,0,1-.7-.241c-.517-.362-.321-1.156-.1-1.747a5.3,5.3,0,0,0,.419-2.87,2.238,2.238,0,0,0-1.97-1.874,2.847,2.847,0,0,0-2.252,1.64c-.679-.633-.566-1.886-1.352-2.379a1.448,1.448,0,0,0-1.473.068,3.761,3.761,0,0,0-1.072,1.105.789.789,0,0,1-.76-.727,2.6,2.6,0,0,1,.173-.751,1.858,1.858,0,1,0-3.635-.2l-2.685-1.684a3.292,3.292,0,0,0-.216,1.681,1.049,1.049,0,0,1-1.115-.468c-.263-.343-.422-.76-.713-1.08a1.695,1.695,0,0,0-2.871,1.643,3.911,3.911,0,0,1-2.111-.665,3.818,3.818,0,0,0-2.115-.65,1.5,1.5,0,0,0-1.249.968,3.261,3.261,0,0,0-1.392-2.318,4.5,4.5,0,0,0-3.195-.663,4.073,4.073,0,0,0-2.43,1.176,2.6,2.6,0,0,0-.616,2.547,1.924,1.924,0,0,0,2.169,1.259l-1.5,1.489a4.576,4.576,0,0,0-1.652-.682,10.652,10.652,0,0,0-3.579.075,6.792,6.792,0,0,0-2.5.7,2.408,2.408,0,0,0-1.3,2.113c.062.941.847,1.7,1,2.627a5.375,5.375,0,0,0-2.869.718,1.685,1.685,0,0,0-.7.653c-.391.78.334,1.636.994,2.208a4.339,4.339,0,0,0-2.184.406,1.493,1.493,0,0,0-.687,1.9c.386.663,1.486,1.061,1.245,1.789a9.477,9.477,0,0,0-4.016-.008c-.484.1-1.039.326-1.145.81-.136.622.554,1.082,1.142,1.325s1.3.642,1.231,1.275a12,12,0,0,0-3.619,1.686c-.255.176-.53.416-.51.725.04.642,1.073.534,1.547.969a6.836,6.836,0,0,1-1.421.829c-.469.29-.862.888-.6,1.371.2.356.657.472.927.776a1.317,1.317,0,0,1,.011,1.514,6.047,6.047,0,0,1-1.11,1.173,5.615,5.615,0,0,0-.866,1.051,4.855,4.855,0,0,0-.675.36,4.575,4.575,0,0,0-1.64,5.543,8.864,8.864,0,0,0,.825,1.363l.915,1.324a1.5,1.5,0,0,1,.373.977c-.071.606-.8.872-1.414.908a2.475,2.475,0,0,0-1.724.449,1.387,1.387,0,0,0,.207,1.862,4.036,4.036,0,0,0,1.872.847l1.981.51a2.579,2.579,0,0,1,1.533.8,9.041,9.041,0,0,1,.561,1.627,2.413,2.413,0,0,0,1.975,1.253,6.3,6.3,0,0,0,2.172-.25l.069.074a5.906,5.906,0,0,0,2.337,1.48c.668.227,1.543.534,1.524,1.239a1.707,1.707,0,0,1-.2.629,1.7,1.7,0,0,0,.024,1.763c.519.6,1.486.375,2.231.1s1.712-.508,2.232.094c.575.666.232,2,1.058,2.3.606.22,1.161-.409,1.495-.96s.857-1.195,1.475-1.013c.754.221.76,1.436,1.479,1.752.777.342,1.509-.635,2.351-.746a2.208,2.208,0,0,0,2.936.891,3.072,3.072,0,0,0,1.713-3.061,12.673,12.673,0,0,1-.494-2.533,2.613,2.613,0,0,0,4.091-1.656c.162-.889-.05-2.02.7-2.518a2.325,2.325,0,0,1,.894-.271,3.215,3.215,0,0,0,2.483-1.53c.647-1.408-.539-3.148.066-4.576.439-1.035,1.643-1.495,2.385-2.34,1.252-1.426.962-3.589.6-5.451a22.3,22.3,0,0,0-.674-2.794,25.544,25.544,0,0,0,1.653-4.493c4.078-1.629,8.54-2.533,12.024-5.2a5.045,5.045,0,0,0,1.444-1.544,6.062,6.062,0,0,0,.394-.993l1.04-3.144a6.3,6.3,0,0,0,.46-2.418",
    transform: "translate(-857.182 -1067.326)",
    fill: "#1d1a15"
  })))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1575",
    "data-name": "Group 1575",
    transform: "translate(207.736 260.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1574",
    "data-name": "Group 1574",
    clipPath: "url(#clip-path-194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2276",
    "data-name": "Rectangle 2276",
    width: 14.609,
    height: 14.318,
    transform: "translate(-4.26 9.231) rotate(-65.225)",
    fill: "url(#linear-gradient-88)"
  })))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1577",
    "data-name": "Group 1577",
    transform: "translate(204.19 228.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576",
    clipPath: "url(#clip-path-195)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2277",
    "data-name": "Rectangle 2277",
    width: 56.049,
    height: 53.762,
    transform: "translate(-16.204 5.114) rotate(-20.788)",
    fill: "url(#linear-gradient-89)"
  })))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1579",
    "data-name": "Group 1579",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1578",
    "data-name": "Group 1578",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M1269.85,1497.44a1.249,1.249,0,0,0-.672-.638,4.643,4.643,0,0,0-4.332.515,1.8,1.8,0,0,0-.545.454.715.715,0,0,0-.115.674.989.989,0,0,0,.58.468,5.369,5.369,0,0,0,4,.034,2.147,2.147,0,0,0,.857-.55.993.993,0,0,0,.225-.955",
    transform: "translate(-1048.004 -1240.601)",
    fill: "#d47329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M1371.79,1501.294a1.249,1.249,0,0,0-.672-.638,4.644,4.644,0,0,0-4.332.515,1.8,1.8,0,0,0-.545.454.716.716,0,0,0-.115.674.989.989,0,0,0,.58.468,5.37,5.37,0,0,0,4,.034,2.15,2.15,0,0,0,.857-.55.993.993,0,0,0,.225-.955",
    transform: "translate(-1132.514 -1243.796)",
    fill: "#d47329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M1329.989,1464.384s-.046,4.847,1.995,4.646,1.471,1.777.3,2.923c-1.657.48-3.562-1.471-3.711-3.781-.24-3.748,1.208-5.387,1.413-3.788",
    transform: "translate(-1101.397 -1213.501)",
    fill: "#9b5a16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M1261.91,1417.667s4.365-2.121,8.159-1.346a4.077,4.077,0,0,0-1.039-2.107s-5.361-.579-7.12,3.453",
    transform: "translate(-1046.152 -1172.39)",
    fill: "#552f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M1369.273,1420.237l.734,1.754s2.488.938,3.223,1.306a4.814,4.814,0,0,0-3.957-3.06",
    transform: "translate(-1135.158 -1177.408)",
    fill: "#552f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M1271.3,1455.728s.177-4.03-1.658-6.087a4.721,4.721,0,0,0-6.081-.573,7.076,7.076,0,0,0,1.022,6.319c1.381.986,5.173,1.856,6.717.341",
    transform: "translate(-1047.237 -1200.607)",
    fill: "#f7f5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M1270.879,1461.14c.7-.5,1.7-3.448,1.156-5.26a2.831,2.831,0,0,0-4.343-1.573c-1.725,1.142-1.391,4.168-.386,5.753a7.368,7.368,0,0,0,3.573,1.08",
    transform: "translate(-1049.937 -1205.232)",
    fill: "#412128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M1361.472,1462.927s-1.791-3.3-.446-5.879,3.569-1.788,4.828-.137c.219.913.419,3.875-.135,4.689-.734,1.079-1.524,2.263-4.248,1.326",
    transform: "translate(-1127.906 -1206.544)",
    fill: "#f7f5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M1363.322,1466.954c.424-.982.764-3.791-.653-5.059-1.55-1.387-3.1.286-3.348,2.186-.2,1.514.554,4.1,1.692,4.115,1.229.057,1.884-.26,2.309-1.242",
    transform: "translate(-1126.882 -1211.52)",
    fill: "#412128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M1284.889,1516.405l-.214.742s4.95,5.211,10.373,4.146l-.164-.167a14.007,14.007,0,0,1-7.212-2.009c-3.079-2.095-2.784-2.712-2.784-2.712",
    transform: "translate(-1065.024 -1257.134)",
    fill: "#7f3421"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M1300.6,1532.976s-.232.5.586,1.348c.88.917,3.635,2.327,4.519.517-1.361-.219-3.753-.7-5.106-1.866",
    transform: "translate(-1078.205 -1270.871)",
    fill: "#7f3421"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M1198.819,1365.136l3.266-1.677s2.455-15.1,13.33-17.476c1.877-.423,6.205.65,8.628.783s2.665-.7,2.665-.7a40.391,40.391,0,0,1,2.866,5.756c-2.345-8.451-9.318-10.94-13.4-10.758s-14.309,4.384-18.77,16.021c-1.438,6.487,1.412,8.056,1.412,8.056",
    transform: "translate(-992.341 -1111.76)",
    fill: "#1d1a15"
  })))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581",
    transform: "translate(203.001 228.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1580",
    "data-name": "Group 1580",
    clipPath: "url(#clip-path-208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2279",
    "data-name": "Rectangle 2279",
    width: 34,
    height: 24.135,
    transform: "translate(-2.242 0)",
    fill: "url(#linear-gradient-90)"
  })))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1583",
    "data-name": "Group 1583",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1582",
    "data-name": "Group 1582",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M1218.381,1332.52c-3.243-.979-4.956-8.26-1.775-12.727,4.161,2.692,5.079,9.607,1.775,12.727",
    transform: "translate(-1007.191 -1094.138)",
    fill: "#ef3653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M1194.02,1385.422c-.478-.83-6.547-1.714-8.934,3.426,3.3,3.06,10.1-1.407,8.934-3.426",
    transform: "translate(-982.463 -1148.018)",
    fill: "#ef3653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M1182.276,1459.2c-.482-1.464-5.422-6.212-7.092-1.526-2.093,5.875,4.51,6.6,5.673,6a14.99,14.99,0,0,0,1.419-4.477",
    transform: "translate(-973.916 -1206.773)",
    fill: "#b97229"
  })))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1585",
    "data-name": "Group 1585",
    transform: "translate(202.453 250.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1584",
    "data-name": "Group 1584",
    clipPath: "url(#clip-path-212)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2281",
    "data-name": "Rectangle 2281",
    width: 6.487,
    height: 6.342,
    transform: "matrix(0.923, -0.386, 0.386, 0.923, -2.699, 0.71)",
    fill: "url(#linear-gradient-91)"
  })))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1587",
    "data-name": "Group 1587",
    transform: "translate(217.42 293.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1586",
    "data-name": "Group 1586",
    clipPath: "url(#clip-path-213)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2282",
    "data-name": "Rectangle 2282",
    width: 23.928,
    height: 18.545,
    transform: "translate(-4.96 1.489) rotate(-20.788)",
    fill: "url(#linear-gradient-92)"
  })))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589",
    transform: "translate(207.932 293.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1588",
    "data-name": "Group 1588",
    clipPath: "url(#clip-path-214)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2283",
    "data-name": "Rectangle 2283",
    width: 10.582,
    height: 14.796,
    transform: "matrix(0.009, -1, 1, 0.009, -0.098, 10.443)",
    fill: "url(#linear-gradient-93)"
  })))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1591",
    "data-name": "Group 1591",
    transform: "translate(234.734 300.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1590",
    "data-name": "Group 1590",
    clipPath: "url(#clip-path-215)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2284",
    "data-name": "Rectangle 2284",
    width: 11.781,
    height: 7.74,
    transform: "translate(-0.858 0.019) rotate(-2.968)",
    fill: "url(#linear-gradient-94)"
  })))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1593",
    "data-name": "Group 1593",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1592",
    "data-name": "Group 1592",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M1194.149,1798.1s3.782-4.7-22.27-5.3-24.8,5.3-24.8,5.3a126.911,126.911,0,0,0,24.2,2.263,104.572,104.572,0,0,0,22.865-2.263",
    transform: "translate(-950.95 -1486.241)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M1165.846,1572.637s-5.484,14.953-.994,29.626a3.431,3.431,0,0,1,.434.7s-13.364,9.345-20.569,2.255c.806-9.623,5.547-27.562,13.29-36.694a5.27,5.27,0,0,0,5.942.854c.868,1.392,1.9,3.263,1.9,3.263",
    transform: "translate(-948.996 -1300.338)",
    fill: "#eaeaea"
  })))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1595",
    "data-name": "Group 1595",
    transform: "translate(229.267 296.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1594",
    "data-name": "Group 1594",
    clipPath: "url(#clip-path-217)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2286",
    "data-name": "Rectangle 2286",
    width: 17.828,
    height: 17.102,
    transform: "matrix(0.935, -0.355, 0.355, 0.935, -4.471, 1.627)",
    fill: "url(#linear-gradient-95)"
  })))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1597",
    "data-name": "Group 1597",
    transform: "translate(195.955 283.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1596",
    "data-name": "Group 1596",
    clipPath: "url(#clip-path-218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2287",
    "data-name": "Rectangle 2287",
    width: 38.113,
    height: 31.3,
    transform: "translate(-0.2)",
    fill: "url(#linear-gradient-96)"
  })))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1599",
    "data-name": "Group 1599",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1598",
    "data-name": "Group 1598",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M1203.61,1780.032a25.05,25.05,0,0,1-4.368-.368,28.567,28.567,0,0,1-5.378-2.116l-.119-.056.157-.332.119.056a28.423,28.423,0,0,0,5.285,2.087,30.348,30.348,0,0,0,12.093-.594,91.468,91.468,0,0,0,11.618-3.821l.13.344a91.86,91.86,0,0,1-11.665,3.835,34.921,34.921,0,0,1-7.872.966",
    transform: "translate(-989.641 -1471.422)",
    fill: "#bb7329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M1150.6,1768.208a10.7,10.7,0,0,1-3.378-.32l.171-.325c.986.521,9.366.241,12.133-.567l.079-.023c2.716-.793,5.525-1.614,7.394-3.612l.268.25c-1.938,2.071-4.924,2.944-7.559,3.713l-.079.023a42.625,42.625,0,0,1-9.029.859",
    transform: "translate(-951.069 -1461.866)",
    fill: "#bb7329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M1258.12,1775.17l-.3-.2a4.045,4.045,0,0,0,.924-3.138c-.121-1.009-.8-2.1-1.732-2.179l.031-.365a2.687,2.687,0,0,1,2.065,2.5,4.4,4.4,0,0,1-.984,3.386",
    transform: "translate(-1042.087 -1466.775)",
    fill: "#bb7329"
  })))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1601",
    "data-name": "Group 1601",
    transform: "translate(224.71 313.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1600",
    "data-name": "Group 1600",
    clipPath: "url(#clip-path-222)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2289",
    "data-name": "Rectangle 2289",
    width: 9.705,
    height: 7.622,
    transform: "translate(-1.898 0.62) rotate(-20.788)",
    fill: "url(#linear-gradient-97)"
  })))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603",
    transform: "translate(214.677 282.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1602",
    "data-name": "Group 1602",
    clipPath: "url(#clip-path-223)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2290",
    "data-name": "Rectangle 2290",
    width: 23.41,
    height: 34.855,
    transform: "matrix(0.935, -0.355, 0.355, 0.935, -10.768, 4.088)",
    fill: "url(#linear-gradient-98)"
  })))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M1249.368,1593.517l1.164,5.119a7.117,7.117,0,0,0,4.523-.6c-2.363-6.513-.282-11.016-4.027-17.01-3.952,4.326-1.659,12.488-1.659,12.488",
    transform: "translate(-1035.206 -1310.708)",
    fill: "#eaeaea"
  })))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607",
    transform: "translate(195.958 270.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    clipPath: "url(#clip-path-225)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2292",
    "data-name": "Rectangle 2292",
    width: 34.274,
    height: 21.277,
    transform: "translate(-0.517 34.076) rotate(-89.461)",
    fill: "url(#linear-gradient-99)"
  })))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1609",
    "data-name": "Group 1609",
    transform: "translate(41.167 235.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608",
    clipPath: "url(#clip-path-244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2293",
    "data-name": "Rectangle 2293",
    width: 45.805,
    height: 69.323,
    transform: "translate(-18.398 5.828) rotate(-17.576)",
    fill: "url(#linear-gradient-100)"
  })))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M357.489,1720.245l-.608,2.974s5.666,2.678,9.927,2.073l1.974-.372a16.46,16.46,0,0,0,.159-2.585c-.12-.261-4.065,1-5.178-1.157-.5-2.157-.684-1.559-.757-3.118s-2.268-.041-1.791,1.359a18.985,18.985,0,0,0,1.028,2.417s-3.581,1.132-4.754-1.591",
    transform: "translate(-295.862 -1423.764)",
    fill: "#ef5153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M355.155,1744.169s-.249,2.171-.276,2.84c.294.413,3.188.377,4.884.744s6.2,1.475,7.814-.355l.053-.98a11.79,11.79,0,0,1-7.282.418,19.9,19.9,0,0,1-5.192-2.666",
    transform: "translate(-294.203 -1445.955)",
    fill: "#eadfbe"
  })))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    transform: "translate(25.468 238.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1612",
    "data-name": "Group 1612",
    clipPath: "url(#clip-path-246)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2295",
    "data-name": "Rectangle 2295",
    width: 20.316,
    height: 62.485,
    transform: "translate(-5.715 0.537) rotate(-5.366)",
    fill: "url(#linear-gradient-101)"
  })))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M198.2,1711.181a41.721,41.721,0,0,0,7.6-.049l.035-1.973s-1.3-3.037-1.814-4.259c.219-2.328.605-3.695-1.462-4.087s-2.489,1.882-1.9,4.288a12.049,12.049,0,0,0-2.465,6.08",
    transform: "translate(-164.311 -1409.975)",
    fill: "#ef5153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M197.439,1748.589a11.294,11.294,0,0,0-.108,2.446c1.366.472,5.832.7,8.377-.641a5.168,5.168,0,0,0-.482-1.933,3.216,3.216,0,0,1-1.439.554,3.5,3.5,0,0,0-3.323-.982,3.737,3.737,0,0,0-2.139.91Z",
    transform: "translate(-163.554 -1449.12)",
    fill: "#eadfbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M135.68,1314.722l-.074,8.288-.334,1.005,14.234,2.411,1.335-3.769,1.088-.085,2.264,3.178,12.548-7.13-2.768-5.019-.68-8.873Z",
    transform: "translate(-112.144 -1081.648)",
    fill: "#61d8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M237.6,1379.674l1.425,1.672,12.548-7.131-1.51-2.426Z",
    transform: "translate(-196.976 -1137.244)",
    fill: "#85efff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M135.52,1399.906l-.248,3.014s13.4,2.83,14.569,2.577l.751-2.345Z",
    transform: "translate(-112.144 -1160.553)",
    fill: "#85efff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M118.2,1454.882s1.447,2.761,2.536,3.22c-.271.544-1.025.231-2.157-.834a2.963,2.963,0,0,1-1.132-1.882Z",
    transform: "translate(-97.369 -1206.129)",
    fill: "#996022"
  })))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1617",
    "data-name": "Group 1617",
    transform: "translate(14.882 197.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1616",
    "data-name": "Group 1616",
    clipPath: "url(#clip-path-248)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2297",
    "data-name": "Rectangle 2297",
    width: 56.054,
    height: 23.673,
    transform: "translate(-14.92 51.615) rotate(-74.123)",
    fill: "url(#linear-gradient-102)"
  })))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619",
    transform: "translate(49.401 203.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618",
    clipPath: "url(#clip-path-249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2298",
    "data-name": "Rectangle 2298",
    width: 32.057,
    height: 16.429,
    transform: "translate(-8.151 28.658) rotate(-74.123)",
    fill: "url(#linear-gradient-103)"
  })))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621",
    transform: "translate(25.907 173.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1620",
    "data-name": "Group 1620",
    clipPath: "url(#clip-path-250)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2299",
    "data-name": "Rectangle 2299",
    width: 19.938,
    height: 21.878,
    transform: "translate(-4.082 14.353) rotate(-74.123)",
    fill: "url(#linear-gradient-104)"
  })))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M278.661,849.263c-1.435-.493-3.595,1.865-4.07,3.565.606,1.585,2.581,7.367,2.912,8.713.2-.029,1.415-.5,1.589-.568,3.76-1.413,1.868-10.92-.431-11.71",
    transform: "translate(-227.642 -704.003)",
    fill: "#ba7329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M51.31,947.8s-6.56,19.479,6.051,28.693c.961,5.589,3.894,6.24,4.694,6.369a2.844,2.844,0,0,0,1.087,4.256,5.15,5.15,0,0,0,.908-4.8c1.852-2.407.764-6.929-1.239-7.852,1.85-2.806,6.958-19.88,4-26.125-13.907-11.255-15.5-.543-15.5-.543",
    transform: "translate(-41.123 -781.933)",
    fill: "#542f1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M57.752,990.093A19.128,19.128,0,0,1,54.09,980.9c-.16.643-.339,1.434-.508,2.34a33.234,33.234,0,0,0,4.23,11.966,16.973,16.973,0,0,0,9.649,7.484c.065-.178.13-.361.2-.551a16.381,16.381,0,0,1-9.354-7.245,29.274,29.274,0,0,1-3.593-9.069,19.291,19.291,0,0,0,2.578,4.619A19.511,19.511,0,0,0,69,997.753q.075-.281.149-.566a19.219,19.219,0,0,1-11.4-7.095",
    transform: "translate(-44.421 -813.188)",
    fill: "#ab4d37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M67.207,972.3a33.574,33.574,0,0,0,9,3.835q.049-.29.1-.579a32.924,32.924,0,0,1-8.775-3.742c-3.379-2.222-6.142-6.229-6.686-9.476a3.515,3.515,0,0,0-.224.629,15.407,15.407,0,0,0,6.59,9.333",
    transform: "translate(-50.253 -797.8)",
    fill: "#ab4d37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M67.975,1104.405a13.516,13.516,0,0,1-4.587-3.791,18.074,18.074,0,0,0,1.393,2.325,13.384,13.384,0,0,0,2.936,1.988,11.857,11.857,0,0,0,5.292,1.239,10.819,10.819,0,0,0,2.3-.257,3.5,3.5,0,0,0-.454-.514,11.185,11.185,0,0,1-6.881-.99",
    transform: "translate(-52.55 -912.433)",
    fill: "#ab4d37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M42.32,761.479S32.6,732.1,56.349,726.542C76.693,721.783,83.934,743.908,82,758.021c-12.074,9.118-28.7,13.925-39.677,3.459",
    transform: "translate(-33.452 -601.773)",
    fill: "#542f1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M53.221,804.758l2.089,2.281c-.3-.528-2.172-3.636-2.439-4.182a29.187,29.187,0,0,1-1.79-20.727,19.028,19.028,0,0,0-1.159,2.31,29.746,29.746,0,0,0,3.3,20.319",
    transform: "translate(-40.933 -648.402)",
    fill: "#9c341b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M66.792,786.982l.405-.418a16.98,16.98,0,0,1-4.75-14.983q-.392.5-.742,1.026a17.619,17.619,0,0,0,5.087,14.374",
    transform: "translate(-51.067 -639.659)",
    fill: "#9c341b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M46.264,917.545s-9.955,2.138-9.957-7.015c0-4.889,5.712-3.932,7.4-.812a59.661,59.661,0,0,0,2.557,7.828",
    transform: "translate(-30.099 -752.022)",
    fill: "#ba7329"
  })))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625",
    transform: "translate(8.091 157.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624",
    clipPath: "url(#clip-path-252)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2301",
    "data-name": "Rectangle 2301",
    width: 8.096,
    height: 8.83,
    transform: "translate(-2.476 5.442) rotate(-71.141)",
    fill: "url(#linear-gradient-105)"
  })))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1627",
    "data-name": "Group 1627",
    transform: "translate(13.28 131.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626",
    clipPath: "url(#clip-path-253)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2302",
    "data-name": "Rectangle 2302",
    width: 42.923,
    height: 47.871,
    transform: "translate(-2.779 0.17) rotate(-3.508)",
    fill: "url(#linear-gradient-106)"
  })))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1629",
    "data-name": "Group 1629",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1628",
    "data-name": "Group 1628",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M167.364,943.62a33.044,33.044,0,0,0,10.076-1.644c4.259-1.526,7.968-4.741,8.726-6.269-3.537,4.672-3.117,6.011-10.9,8.323-4.956.984-7.9-.409-7.9-.409",
    transform: "translate(-138.749 -775.722)",
    fill: "#a43d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M174.168,974.41s4.485,5.394,10.259,3.922c3.233-.824,3.534-4.321,3.371-6.292-5.826,2.9-13.63,2.37-13.63,2.37",
    transform: "translate(-144.389 -805.843)",
    fill: "#a43d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M168.342,964.4s8.616,2.51,15.515-3.818c-1.754,3.141-1.124,5.108-5.349,6.338-4.414,1.286-10.166-2.52-10.166-2.52",
    transform: "translate(-139.559 -796.344)",
    fill: "#f8f6f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M114.412,901.8s-1.141-5.522-6.618-4.85-5.854,4.906-5.854,4.906,1.1,4.562,7.635,3.491a7.011,7.011,0,0,0,4.845-3.258Z",
    transform: "translate(-84.511 -743.548)",
    fill: "#f8f6f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M233.286,877.338s.294-6.928,6.194-6.484a5.66,5.66,0,0,1,2.664,1.836,6.607,6.607,0,0,1,.228,2.858c-.226,1.25-.585,3.982-5.2,4.11-2.3.064-3.888-2.321-3.888-2.321",
    transform: "translate(-193.399 -721.94)",
    fill: "#f8f6f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M121.258,897.5A3.7,3.7,0,0,1,125,901.4a3.386,3.386,0,0,1-3.5,3.764,3.911,3.911,0,0,1-3.882-3.378c-.327-2.554,2.246-4.244,3.639-4.283",
    transform: "translate(-97.485 -744.048)",
    fill: "#412128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M229.9,829.884a13.233,13.233,0,0,1,7.557.051c-.155-.793-2.279-2.3-4.359-2.159-3.121.217-3.2,2.108-3.2,2.108",
    transform: "translate(-190.594 -686.237)",
    fill: "#552f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M88.715,854.476s5.5-5.023,9.394-4.88c.038-.978-2.517-2.107-5.008-.428-4.35,2.932-4.386,5.308-4.386,5.308",
    transform: "translate(-73.547 -703.266)",
    fill: "#552f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M236.63,876.144a3.581,3.581,0,0,1,3.629,3.777,3.282,3.282,0,0,1-3.394,3.648,3.367,3.367,0,0,1-3.46-3.113,3.938,3.938,0,0,1,3.225-4.312",
    transform: "translate(-193.472 -726.342)",
    fill: "#412128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M91.821,897.6l2,1.217s2.7-4.761,5.763-4.961a6.628,6.628,0,0,1,6.452,4.58c-.486-2.937-2.5-6.02-6.368-5.74s-6.812,4.7-6.812,4.7Z",
    transform: "translate(-76.122 -740.054)",
    fill: "#412128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M232.749,875.56c.139-.917.822-6.459,5.267-5.982,3.161.416,3.939,2.105,3.939,2.105.134.306-.054-2.591-3.548-2.935-4.355-.43-6.15,3.06-5.657,6.812",
    transform: "translate(-192.888 -720.182)",
    fill: "#412128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M202.58,902.949s-.121,3.579,1.637,3.639,2.134-.191,2.324.625-.813,2.889-4.581,2.14c-2.7-1.127-2.111-8.123-.2-8.35,1.067-.127.818,1.945.818,1.945",
    transform: "translate(-165.91 -746.948)",
    fill: "#9a5a16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M124.764,1130.555s16.577,1.57,29.956-10.416c.241-8.455-4.058-33.02-4.4-36.451a13.334,13.334,0,0,0-3.184-2.047s-10.96,5.2-16.995-.984c-4.769,2.015-6.023,3.774-6.023,3.774s1.057,43.7.641,46.125",
    transform: "translate(-102.901 -895.888)",
    fill: "#d2e4a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M87.93,1101.627s-4.494,4.547-7.742,18.614c3.022,7.028,9.537,12.148,9.537,12.148l-.942-22.412Z",
    transform: "translate(-66.478 -913.273)",
    fill: "#d2e4a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M274.423,1095.206s6.371,7.861,7.974,17.57a77.183,77.183,0,0,1-3.923,9.38s-3.459-22.1-4.05-26.95",
    transform: "translate(-227.503 -907.95)",
    fill: "#d2e4a7"
  })))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634",
    transform: "translate(40.972 157.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    "data-name": "Group 1633",
    clipPath: "url(#clip-path-255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1632",
    "data-name": "Group 1632",
    transform: "translate(-0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1631",
    "data-name": "Group 1631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630",
    clipPath: "url(#clip-path-256)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2304",
    "data-name": "Rectangle 2304",
    width: 11.654,
    height: 4.924,
    transform: "translate(-0.079 -0.034)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAI4AAAA8CAIAAAA/nRUhAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAjqADAAQAAAABAAAAPAAAAAD/VTvOAAAMgklEQVR4Ad2cXZYcVxGEGQ4LwF6C5B34ZwnWLswzxlvhzZhnswvwDmy/84K8BJsVIKIqqr6Ozry3ulozIwv6tO5ERkZm3s6c+ulRzzy8efPmN/8vj9f/+Mvspfy0uz54+ekHLz/rspef/6mT7xXz8D80KiZB38+38mGV3vtdeZnr+g398tVX5ys+ufL9HdXPr7//5fUPesF9MOq7m+4BHDelaM5Mq2iWcnHuYX46Oj/8aHCAHu/nrb3vy6gYzC/7hPIl0W5AegvummRyDIlLkmLmqIgC6OT5Dsb2q43KZ7PjwdAv9zo7LuxOJYleYMbLRYtT33GV5bhWtQUp8wH3TOfJdzoqHzp9PKWtaRp3pnfWTCpnGvHZ3wOZXZv4elSZAZxgOdQ++uzD0S3MzYpDwbsYlSeUl5xsaGJtMU3jziCjNakZvs6TJAm7fnHdmlaGC+v54XrD+STH2TOOSqe4cgBl64fNhUylu4ZLZmK82SaT59eD2Opa7y+SNIaZmY+/nj3xqPopjraW7sPT6xko/NA02ddSJQU0F7Iz6XIqH1coAVIa5+pwMch0MXvx+Vdvd9/4NKM6OMXlhGhcB35VN/mUITZ5c5WelkmcOGNnvDWLN06DKTaGSdBdn/zx23sH9qhR/fyv73UF+uWn5d2PHtk7sEDiosQ1Cy96ZAQK0BSLy4oSPvWJESToAk0KEqAQYcwC0jTWqiPs0y//lrWO8VuOah3S136LqgIPD1tD/CXXxbtvYQbEa+t4M2SIUQL2Cnd8pX2KSdxTFO9ixrQIF28l+gLSC9Y17ORNx92jev33r3W/4B5d1nVUNO7CjwaATC9SOE23KRmwAaZj0dMUGAOvxYtryHeyMIv5dKNSspMXsDtGNR7S3u43+5GlbmZDtZXS5aFJ+zIWfAaQoYPSawRDvpMDJu4D7UUjkNi1INOVWDIN7JPD8+GpUWlIvCvKRoO3Vu7TUmFc9GXTNBc8URky9A5JohLQDsjOyNXJm4wFHF2beZ0KkhLHzPG0boxK16Qf//oHtYbuHGBtiGGl3m0yk+uity9AF++SizgDU2/sdhB1QMpVxMXsgmQQG+TKGTI1V4K9tMjkhWc3h9NR5Y1D9hdcuixzY0bXLb3Ci0AG4kOwCve0NkI/9O6q5atbkMx5sscWBtMgV6oMyP0wTJdwMYfTGo+qXJY8g+w1jBuByzwH12bu/cVUFBhAKoO7zEzil51JhIdk54usmOQ0jzfNQlJi04wucsPwj9sbr8Gofvjmi3+v/1Hk189KO2C0DzBgI+PYIhC9QMGPMTP/mnhb6FohpU9XYiuHTImS0rJch2QKfFBdMWvJIfP5n//p/Xj9bRrCOSdtzl0owGYhFZu8vgUwXQI9SvPFLFHH3sxpJTkJlCYfNrNKYiuHjFyFl2kSV5pj3L6DS5KM+vGbL2TyuBpVmZNEuTmSmkxvlenughuMPQklnccmqciGrDOzwFSyky7GNSvRBTAGBGIK6OEVb4IU3Iv1EwZdich2GdVwTuwjy5gUw3NJp+8Xnou9PCwwLma6EiMTySMFiS1IJSECVnYvPC4zxCJwkiGPy0lma8YehCArgI+TiN9Gpen5p0Rselbb/JaR2azHdSmTJmlFznBxOTzFFpifea3vUUPeCeXKbJj2eh0mTMFNLMH2GPXKRYcrB9Y+qvVnRblL5R1GLjwT2qsPxTgz7QyTIaOK+LzpJNLns2S+mY3YWaAz3FzJA1g6uPZw6yQFRoADaxkVcxPOwgSa7Oc3BEOQqS67XKU2iXoqkyoloQvhLXXFzwQznlRngJJQgoRJ5tgWvOuJ0ntckeuo9o8zOpFX67z6VlLvwLsgmRmmpATCmMZDExfeEltM68sGhkkIvJmZcNIOGSc8WDMcDPA2cr0cEvuRp/9Ml347AVrq+MRk3MD1tERmjRkmLZkFwE6CWVw99ljv8J5kyENmlUJSTjyP1Jjva4qFCe9KXA7pgtfffSPX70pGmTp2pM4VzQI0rfUgvSLDcCBEL1xcJ03L8lUllreYhckTgpRpWlmYYkpTmKFpsrgUy8Ol+wYkGJIECiyjkui+x3xaTpUrmbPKDFuc3vOMGtQDHV56V0xpCvMY0xWzrrP1NZVn8DIqZZm9yFmKru9Mic0qBVtJBr8qkXcx0hNIbDJFILMzx/qZ13xfXaKsmeRkiDLo0yvLtSo/VpjBpYbNrX3rRcuYhg71SZZdpimZzCGT5BmNKxZlMXu5oeD85lOZWGn1yNVeM8ZnVs1oGZU+BKr1ZHBWvQunmM2J9LMz1pufaYgS6KnwZiqU6T0vGO7EOYcrVR4PllHpkxjDRH4BfbW48wdMcck0Q10zQ7JoMAV6HkinKoJiWnyQsOidE30x4Z8JbDfrzn6y9vYCJv9LplTOk2shKbelsr2uZhybMiQzwTBVicIUKPpHmk74TKu3vY3qRRxY2vTNkghW7XQhFcCBNgmT6ScMMpQ3BY6dpeqZYUrmx5jkfA6wjYqPommjepxZvZsDJS4AmQ3E2+VUx6Q1DjkZRcKSH9OCmVm2d9Mkm7d375rbKNhXqMsJ8OMvvy0Kapu/q3aKSQtpQFqZfqayM3gFirekwiwhxVQSHiVhuqS5yyTnXcAlhmsdlW4H/fvMqXax4UYXcn65WpxrMCuAnGJMmnFIIdM0zhCYJMlT0j636T2cWdnJGaBPnFl2Oapkv3i13Qoe15MyBVkPHmBxMUuIvBbAF2ZmZlTRUPdAU0IeY7LzM8Bbmq0lA+96r0Yl9sX+S+SzROYzHUqAvQemXH6WPA6BLJpuStnJwmQ2sAMxS8ixWWJtKgR+hlfJ7SXDdUjxVupqVEojR/mzDhl5jMte0+yB3rJ4P2065JghRIBHCSGPBcWbZuISRawBpkJ4lHDx9qYmxUWQ4iHOO/M6KuX65Mtv86JFpQ6W7HG5KsXSXIRrPKsBOWX6WRhMgRJiJsmS4aYgY3v+kq2YQ73IfDh/WclTeAUmI1OHDWc/mYNRic1pOXUWgOnZS7GbZqZSNid0VJowXX8zJPMYz0LwWjAzcw/g/6xqzAPgtBLokWvywr+PU59d41HJp2lJbZFXly+MTOoBIAF2pQkjEt7YZhckI5zmcUgqM9AYL+Zx36nlQEdBGvT1pszZFLjEvnnDJcqM1sGna/EJ5CfOFvXq40fpFzD6RECKUfYka8rL/3e8hUlOx/YMV10I0Yy3JL1i0gQDyCrGZF+HSdAv3vX/K3SEDH+b8caoFK8Pyfg3drL14un+AvzpjUKGWfXXrvQKD029JCoOBWvcZZHYzbpQ10x6E9+rL7E2+6q0KAvwhEzO5qTw26OSaPZbIUu8/mmNowoyQeItRFQ8cgyii4kQHtBdMB3QI7nAgGP9QUhmMM41AxNrQikT1q358Hjyxk6NylIdXv7VUtpksKxxVKlkEWyV/GX3olmid1dRXtOLlcrExdUDxbgvdoEBw5BZVOGL6ZxkBiyydTopELapixM/iZWyP+4YlYI5vGiTwbLun40pLpeEXISmRqCLd+32lVjZiUtgdseyZBIrsJhbpf0LXsDuqYESqJZWlPthszHwFLX45pBc8b5ROaZcvUTStQ444LZ6/rKuA/E1H9oNEiI7sd1ish1Dsgs6sxXbv6Qg8e6/FC2zkcD6jIIRWH8YcfYvjrzNqLQDHV76HOHgV+3ZfrSSngKkWvD1FY7QlEEapCtxkaUpGd1JPnG2Mnnh7mIeKNEcgEwl2fK26dVX+Q6XbDPwlqMiHRcwMe5d6eCQdHi5GdnI6E5JhcBA61CA9wDQ002zXeB3q0UWfZqJFWcTcgiGvz/aalbisaNyvj4w8fQRkMUXcnJUIZsG7ooUqClp7hI1j3ZtXLV36YyXP12JHVoYmTAAKXW600/sju8d9r0Mvj7NqJxYA8s/VUbjANS/MPutI64CLsrdURiZ2Y5ddfmqV3gxmvjKl7prnLLEqEziAkjwyAlR4ilHRdIyM/H0F7CJHz0qis4Ao8r2SVzMWXhXlsA0E+uH4jqG7v2bVwfbeJZRUc8z+/n1D3VC+/BuTWrJVGKLSa0puD6qhrJscQqGfJKJHfjkE2I/zzsqyviOMU+PdnlUesEHAyiuYlJiCm6NqrebVN3VGZ/fFPK0xxB7ALyjUVHPQEebwDK5n34srm6W2WD2rpXYTTkZ1c1wZeuadzaY8lpk/jqj6vvg1yjt4k86deW9jF5hCal2cYe5DebhQeCu90CR48ng+zKqgxfkP+HZBf102jULE6PSOUpNH8qe+/Q1LHoX+V9ZO4XNBEuWWAAAAABJRU5ErkJggg=="
  }))))))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1639",
    "data-name": "Group 1639",
    transform: "translate(18.903 161.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1638",
    "data-name": "Group 1638",
    clipPath: "url(#clip-path-257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1637",
    "data-name": "Group 1637",
    transform: "translate(-0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1636",
    "data-name": "Group 1636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1635",
    "data-name": "Group 1635",
    clipPath: "url(#clip-path-258)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2306",
    "data-name": "Rectangle 2306",
    width: 13.131,
    height: 6.237,
    transform: "translate(-0.02 -0.015)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1641",
    "data-name": "Group 1641",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1640",
    "data-name": "Group 1640",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M1530.133,1786.1s3.782-4.7-22.269-5.3-24.8,5.3-24.8,5.3a126.905,126.905,0,0,0,24.2,2.263,104.57,104.57,0,0,0,22.865-2.263",
    transform: "translate(-1229.489 -1476.293)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M1586.6,1373.335s-3.125-7.5-3.264-13.541c-2.292-.972-6.667,7.152-5.833,16.527a13.726,13.726,0,0,1,3.055,5.486c3.264-3.055,6.042-8.472,6.042-8.472",
    transform: "translate(-1307.703 -1127.234)",
    fill: "#703d15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M1586.533,1364.646a45.059,45.059,0,0,0,2.222,13.888,35.727,35.727,0,0,1-3.958,5.972s-.709-3.354-1.805-3.958c-2.832-1.561,1.111-15.764,3.542-15.9",
    transform: "translate(-1311.52 -1131.322)",
    fill: "#e09a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M1681.377,1373.335s3.125-7.5,3.264-13.541c2.292-.972,6.667,7.152,5.833,16.527a13.723,13.723,0,0,0-3.055,5.486c-3.264-3.055-6.042-8.472-6.042-8.472",
    transform: "translate(-1393.899 -1127.234)",
    fill: "#703d15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M1503.185,1769.472s-17.281.393-17.188,7.06a51.367,51.367,0,0,1,22.695-.857v-5.093Z",
    transform: "translate(-1231.924 -1466.932)",
    fill: "#703d15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M1693.346,1364.646a45.046,45.046,0,0,1-2.222,13.888,35.715,35.715,0,0,0,3.958,5.972s.84-3.161,1.806-3.958c2.611-2.158-1.112-15.764-3.542-15.9",
    transform: "translate(-1401.98 -1131.322)",
    fill: "#e09a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M1586.957,1546.772a19.95,19.95,0,0,0-4.511-.612s.006.009,2.645-4.713c2.341-10.273-.543-17.912-3.737-27.286-.833-5.694-2.443-16.942-2.443-16.942l-6.45-1.041v-.345l-1.018.174-1.034-.174v.351l-6.436,1.038s-1.618,11.25-2.451,16.944c-3.194,9.375-4.837,21.11-3.726,27.291,2.639,4.722,2.651,4.722,2.651,4.722a19.5,19.5,0,0,0-4.508.595,1.447,1.447,0,0,0-.619,2.123h32.258a1.449,1.449,0,0,0-.622-2.123",
    transform: "translate(-1289.196 -1240.078)",
    fill: "#703d15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M1606.2,1690.779h13.366s3.581-16.414.955-23.595h-15.991c-2.745,8.036,1.671,23.595,1.671,23.595",
    transform: "translate(-1329.445 -1382.132)",
    fill: "#e09a64"
  })))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1643",
    "data-name": "Group 1643",
    transform: "translate(269.475 255.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1642",
    "data-name": "Group 1642",
    clipPath: "url(#clip-path-260)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2309",
    "data-name": "Rectangle 2309",
    width: 25.777,
    height: 53.796,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-107)"
  })))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1645",
    "data-name": "Group 1645",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1644",
    "data-name": "Group 1644",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M1628.78,1549.218a43.446,43.446,0,0,1,1.111,5.555c.139,1.875,3.68,2.361,6.319,1.944a5.167,5.167,0,0,0,3.68-2.986s-1.667-6.041-1.944-6.319a40.368,40.368,0,0,0-9.166,1.806",
    transform: "translate(-1350.295 -1282.839)",
    fill: "#5c3212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M1639.25,1549.358a20.676,20.676,0,0,1,1.253,5.251c.477,1.85,2.327,1.372,4.117,1.193s2.745-2.208,2.745-2.208l-1.79-5.609Z",
    transform: "translate(-1358.975 -1283.314)",
    fill: "#8f292d"
  })))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1647",
    "data-name": "Group 1647",
    transform: "translate(271.839 243.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1646",
    "data-name": "Group 1646",
    clipPath: "url(#clip-path-262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2311",
    "data-name": "Rectangle 2311",
    width: 32.557,
    height: 32.74,
    transform: "translate(-10.543 18.694) rotate(-62.103)",
    fill: "url(#linear-gradient-108)"
  })))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1649",
    "data-name": "Group 1649",
    transform: "translate(281.263 263.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1648",
    "data-name": "Group 1648",
    clipPath: "url(#clip-path-263)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2312",
    "data-name": "Rectangle 2312",
    width: 8.69,
    height: 14.315,
    transform: "translate(-1.64 0.201) rotate(-7.001)",
    fill: "url(#linear-gradient-109)"
  })))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1651",
    "data-name": "Group 1651",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1650",
    "data-name": "Group 1650",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M1626.19,1499.753a8.9,8.9,0,0,0-6.174,2.164c-1.6,1.33-1.25,7.014.208,8.333,1.945.9,5.764-.278,6.667-1.528,1.806,1.042,5.625,1.042,6.667.208.833-1.945-.069-6.875-1.528-7.778a9.17,9.17,0,0,0-5.839-1.4",
    transform: "translate(-1342.156 -1243.317)",
    fill: "#e09a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M1645.225,1503.161a10.572,10.572,0,0,1-2.292,4.792c-1.736.556-2.222.278-2.222.278s-3.055-2.361-3.4-4.444c.764-1.736,6.6-2.291,7.917-.625",
    transform: "translate(-1357.366 -1245.324)",
    fill: "#5e2400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M1682.493,1469.812c1.387-.1,2.014,1.18,2.014,2.639s-.208,2.777-1.389,2.847-1.944-1.528-1.944-2.847.347-2.57,1.319-2.639",
    transform: "translate(-1393.73 -1218.502)",
    fill: "#1d0b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M1616.975,1471.463c.972,0,1.667,1.042,1.805,2.639s-.555,2.847-1.25,2.847a2.509,2.509,0,0,1-2.222-2.431c-.139-1.736.764-3.055,1.667-3.055",
    transform: "translate(-1339.115 -1219.875)",
    fill: "#1d0b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M1622.3,1448c.534.449-.347,1.25-1.667,1.319s-1.6-.208-1.6-.556,1.944-1.875,3.264-.764",
    transform: "translate(-1342.215 -1200.097)",
    fill: "#573318"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M1679.217,1448c-.534.449.347,1.25,1.667,1.319s1.6-.208,1.6-.556-1.944-1.875-3.264-.764",
    transform: "translate(-1391.977 -1200.097)",
    fill: "#573318"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M69.479,1108.491c.36-.813-8.278-3.529-8.232-8.185-.9-.763-3.408-4.507-5.038-6.732.034,1.061-2.876,16.51,7.1,22.193,1.852,1.307,2.438,1.081,2.745.828l-.493-.753s.759.92,1.526.287-.345-2.292-.345-2.292,1.418,1.407,2.032.9-3.2-6.014-3.2-6.014,3.551.58,3.911-.233",
    transform: "translate(-46.292 -906.598)",
    fill: "#b97529"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreserve);
export default __webpack_public_path__ + "static/media/preserve.3f99813a163798201a33002e7fe93a56.svg";
export { ForwardRef as ReactComponent };